/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as AuthRouteRouteImport } from './routes/_auth/route'
import { Route as PhoebeThinkingTipsMockupRouteImport } from './routes/phoebe-thinking-tips-mockup'
import { Route as TeachPhoebeFeedbackTagsMockupRouteImport } from './routes/teach-phoebe-feedback-tags-mockup'
import { Route as OrganizationIdDemoRouteImport } from './routes/$organization-id.demo'
import { Route as AppagentRouteRouteImport } from './routes/_app/(agent)/route'
import { Route as AppextensionRouteRouteImport } from './routes/_app/(extension)/route'
import { Route as AppmainRouteRouteImport } from './routes/_app/(main)/route'
import { Route as AppAdminRouteRouteImport } from './routes/_app/admin/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AuthAcceptInvitationRouteImport } from './routes/_auth/accept-invitation'
import { Route as AuthChangePasswordRouteImport } from './routes/_auth/change-password'
import { Route as AuthErrorRouteImport } from './routes/_auth/error'
import { Route as AuthIntroCallBookedRouteImport } from './routes/_auth/intro-call-booked'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as ChromeExtensionPrivacyRouteImport } from './routes/chrome-extension.privacy'
import { Route as OutreachesPhoebeThinkingTipsMockupRouteImport } from './routes/outreaches/phoebe-thinking-tips-mockup'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as SimulatorWorldDisplayRouteImport } from './routes/simulator-world/display'
import { Route as SlackAgentV3LinkRouteImport } from './routes/slack-agent-v3/link'
import { Route as AppagentAgentRouteImport } from './routes/_app/(agent)/agent'
import { Route as AppextensionExtensionRouteRouteImport } from './routes/_app/(extension)/extension/route'
import { Route as AppextensionExtensionLocalRouteRouteImport } from './routes/_app/(extension)/extension-local/route'
import { Route as AppmainIndexRouteImport } from './routes/_app/(main)/index'
import { Route as AppmainActivityRouteImport } from './routes/_app/(main)/activity'
import { Route as AppmainActivityBoardRouteImport } from './routes/_app/(main)/activity-board'
import { Route as AppmainAuthorizationsRouteImport } from './routes/_app/(main)/authorizations'
import { Route as AppmainCalloutsRouteImport } from './routes/_app/(main)/callouts'
import { Route as AppmainCaregiversRouteImport } from './routes/_app/(main)/caregivers'
import { Route as AppmainClientsRouteImport } from './routes/_app/(main)/clients'
import { Route as AppmainCoverageRouteImport } from './routes/_app/(main)/coverage'
import { Route as AppmainDryRunReportRouteImport } from './routes/_app/(main)/dry-run-report'
import { Route as AppmainFinancialsRouteImport } from './routes/_app/(main)/financials'
import { Route as AppmainHomeRouteImport } from './routes/_app/(main)/home'
import { Route as AppmainLeaderboardRouteImport } from './routes/_app/(main)/leaderboard'
import { Route as AppmainLearnPhoebeRouteImport } from './routes/_app/(main)/learn-phoebe'
import { Route as AppmainMetricsRouteImport } from './routes/_app/(main)/metrics'
import { Route as AppmainPhoneRouteImport } from './routes/_app/(main)/phone'
import { Route as AppmainPlaybooksRouteImport } from './routes/_app/(main)/playbooks'
import { Route as AppmainReferralsRouteImport } from './routes/_app/(main)/referrals'
import { Route as AppmainTeachPhoebeRouteImport } from './routes/_app/(main)/teach-phoebe'
import { Route as AppmainTrainingRouteImport } from './routes/_app/(main)/training'
import { Route as AppmainVoiceCallsRouteImport } from './routes/_app/(main)/voice-calls'
import { Route as AppAdminIndexRouteImport } from './routes/_app/admin/index'
import { Route as AppAdminAgentToolsRouteImport } from './routes/_app/admin/agent-tools'
import { Route as AppAdminAmdLiveRouteImport } from './routes/_app/admin/amd-live'
import { Route as AppAdminCarePlanPreviewerRouteImport } from './routes/_app/admin/care-plan-previewer'
import { Route as AppAdminDashboardUsageRouteImport } from './routes/_app/admin/dashboard-usage'
import { Route as AppAdminDataQualityRouteImport } from './routes/_app/admin/data-quality'
import { Route as AppAdminDataSyncRouteImport } from './routes/_app/admin/data-sync'
import { Route as AppAdminDemoOrgRouteImport } from './routes/_app/admin/demo-org'
import { Route as AppAdminDesignKitRouteImport } from './routes/_app/admin/design-kit'
import { Route as AppAdminDocumentIngestionRouteImport } from './routes/_app/admin/document-ingestion'
import { Route as AppAdminExtensionLabRouteRouteImport } from './routes/_app/admin/extension-lab/route'
import { Route as AppAdminFlagsRouteImport } from './routes/_app/admin/flags'
import { Route as AppAdminImessageRouteImport } from './routes/_app/admin/imessage'
import { Route as AppAdminLlmSpendRouteImport } from './routes/_app/admin/llm-spend'
import { Route as AppAdminMessageQueueRouteImport } from './routes/_app/admin/message-queue'
import { Route as AppAdminNotificationsLabRouteImport } from './routes/_app/admin/notifications-lab'
import { Route as AppAdminOrgSnapshotsRouteImport } from './routes/_app/admin/org-snapshots'
import { Route as AppAdminOrganizationDefaultSettingsRouteImport } from './routes/_app/admin/organization-default-settings'
import { Route as AppAdminOutreachObservabilityRouteImport } from './routes/_app/admin/outreach-observability'
import { Route as AppAdminOutreachesRouteImport } from './routes/_app/admin/outreaches'
import { Route as AppAdminPromptRolloutRouteImport } from './routes/_app/admin/prompt-rollout'
import { Route as AppAdminQualityScoreboardRouteImport } from './routes/_app/admin/quality-scoreboard'
import { Route as AppAdminReportGeneratorRouteImport } from './routes/_app/admin/report-generator'
import { Route as AppAdminSearchRouteImport } from './routes/_app/admin/search'
import { Route as AppAdminShiftAssignmentHealthRouteImport } from './routes/_app/admin/shift-assignment-health'
import { Route as AppAdminSimulatorWorldRouteImport } from './routes/_app/admin/simulator-world'
import { Route as AppAdminSyncSettingsRouteImport } from './routes/_app/admin/sync-settings'
import { Route as AppAdminTagMatchingRouteImport } from './routes/_app/admin/tag-matching'
import { Route as AppAdminTamMapRouteImport } from './routes/_app/admin/tam-map'
import { Route as AppAdminUiComponentsRouteImport } from './routes/_app/admin/ui-components'
import { Route as AppAdminV3AgentRouteRouteImport } from './routes/_app/admin/v3-agent/route'
import { Route as AppAdminV3EventComponentsRouteImport } from './routes/_app/admin/v3-event-components'
import { Route as AppAdminVoiceRouteImport } from './routes/_app/admin/voice'
import { Route as AppAdminVoiceLatencyRouteImport } from './routes/_app/admin/voice-latency'
import { Route as AppAdminWbrRouteImport } from './routes/_app/admin/wbr'
import { Route as AppInternalAgreementsRouteImport } from './routes/_app/internal/agreements'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsActivityFeedRouteImport } from './routes/_app/settings/activity-feed'
import { Route as AppSettingsAgencyContextRouteImport } from './routes/_app/settings/agency-context'
import { Route as AppSettingsAgentRulesRouteImport } from './routes/_app/settings/agent-rules'
import { Route as AppSettingsAutoAssignRouteImport } from './routes/_app/settings/auto-assign'
import { Route as AppSettingsAutoDraftRouteImport } from './routes/_app/settings/auto-draft'
import { Route as AppSettingsAutoReplySettingsRouteImport } from './routes/_app/settings/auto-reply-settings'
import { Route as AppSettingsAutoSendRouteImport } from './routes/_app/settings/auto-send'
import { Route as AppSettingsAutomationScheduleRouteImport } from './routes/_app/settings/automation-schedule'
import { Route as AppSettingsAutomationsRouteImport } from './routes/_app/settings/automations'
import { Route as AppSettingsCallRoutingRouteImport } from './routes/_app/settings/call-routing'
import { Route as AppSettingsCallTemplatesRouteImport } from './routes/_app/settings/call-templates'
import { Route as AppSettingsCancellationsRouteImport } from './routes/_app/settings/cancellations'
import { Route as AppSettingsCareCoordinatorsRouteImport } from './routes/_app/settings/care-coordinators'
import { Route as AppSettingsCaregiverEngagementRouteImport } from './routes/_app/settings/caregiver-engagement'
import { Route as AppSettingsCaregiverTagsRouteImport } from './routes/_app/settings/caregiver-tags'
import { Route as AppSettingsChangeHistoryRouteImport } from './routes/_app/settings/change-history'
import { Route as AppSettingsChromeExtensionRouteImport } from './routes/_app/settings/chrome-extension'
import { Route as AppSettingsClientCommunicationRouteImport } from './routes/_app/settings/client-communication'
import { Route as AppSettingsClockInOutRouteImport } from './routes/_app/settings/clock-in-out'
import { Route as AppSettingsClockInTemplatesRouteImport } from './routes/_app/settings/clock-in-templates'
import { Route as AppSettingsConfigurationsRouteImport } from './routes/_app/settings/configurations'
import { Route as AppSettingsConfirmationMessagesRouteImport } from './routes/_app/settings/confirmation-messages'
import { Route as AppSettingsDailyDigestRouteImport } from './routes/_app/settings/daily-digest'
import { Route as AppSettingsDataSyncRouteImport } from './routes/_app/settings/data-sync'
import { Route as AppSettingsEarlyAccessRouteImport } from './routes/_app/settings/early-access'
import { Route as AppSettingsHelpCenterRouteImport } from './routes/_app/settings/help-center'
import { Route as AppSettingsNotificationsRouteRouteImport } from './routes/_app/settings/notifications/route'
import { Route as AppSettingsOffHoursRouteImport } from './routes/_app/settings/off-hours'
import { Route as AppSettingsOfficesRouteImport } from './routes/_app/settings/offices'
import { Route as AppSettingsOpenShiftResponsesRouteImport } from './routes/_app/settings/open-shift-responses'
import { Route as AppSettingsOtherTemplatesRouteImport } from './routes/_app/settings/other-templates'
import { Route as AppSettingsOutreachAutomationRouteImport } from './routes/_app/settings/outreach-automation'
import { Route as AppSettingsOutreachTemplatesRouteImport } from './routes/_app/settings/outreach-templates'
import { Route as AppSettingsPhoebeRouteImport } from './routes/_app/settings/phoebe'
import { Route as AppSettingsPhoneRouteImport } from './routes/_app/settings/phone'
import { Route as AppSettingsPhoneInstructionsRouteImport } from './routes/_app/settings/phone-instructions'
import { Route as AppSettingsPhoneNumbersRouteImport } from './routes/_app/settings/phone-numbers'
import { Route as AppSettingsPhoneTryRouteImport } from './routes/_app/settings/phone-try'
import { Route as AppSettingsPronunciationsRouteImport } from './routes/_app/settings/pronunciations'
import { Route as AppSettingsQuietHoursRouteImport } from './routes/_app/settings/quiet-hours'
import { Route as AppSettingsRecommendationsRouteImport } from './routes/_app/settings/recommendations'
import { Route as AppSettingsShiftConfirmationSkipAllowListsRouteImport } from './routes/_app/settings/shift-confirmation-skip-allow-lists'
import { Route as AppSettingsShiftConfirmationsRouteImport } from './routes/_app/settings/shift-confirmations'
import { Route as AppSettingsSkipAllowListsRouteImport } from './routes/_app/settings/skip-allow-lists'
import { Route as AppSettingsSlackRouteImport } from './routes/_app/settings/slack'
import { Route as AppSettingsTagMatchingRouteImport } from './routes/_app/settings/tag-matching'
import { Route as AppSettingsTagsRouteImport } from './routes/_app/settings/tags'
import { Route as AppSettingsTeamCoverageRouteImport } from './routes/_app/settings/team-coverage'
import { Route as AppSettingsTeamMembersRouteImport } from './routes/_app/settings/team-members'
import { Route as AppSettingsTeamsRouteImport } from './routes/_app/settings/teams'
import { Route as AppSlackLinkRouteImport } from './routes/_app/slack/link'
import { Route as AppagentAgentIndexRouteImport } from './routes/_app/(agent)/agent/index'
import { Route as AppmainAutomationsIndexRouteImport } from './routes/_app/(main)/automations/index'
import { Route as AppmainAutomationsAutomationIdRouteImport } from './routes/_app/(main)/automations/$automationId'
import { Route as AppmainCalendarIndexRouteImport } from './routes/_app/(main)/calendar/index'
import { Route as AppmainConversationsIndexRouteImport } from './routes/_app/(main)/conversations/index'
import { Route as AppmainOutreachesIndexRouteImport } from './routes/_app/(main)/outreaches/index'
import { Route as AppmainOutreachesCalloutIdRouteImport } from './routes/_app/(main)/outreaches/$callout-id'
import { Route as AppmainRoutinesIndexRouteImport } from './routes/_app/(main)/routines/index'
import { Route as AppmainRoutinesRoutineIdRouteImport } from './routes/_app/(main)/routines/$routineId'
import { Route as AppmainScheduledIndexRouteImport } from './routes/_app/(main)/scheduled/index'
import { Route as AppmainShiftsIndexRouteImport } from './routes/_app/(main)/shifts/index'
import { Route as AppmainShiftsShiftIdRouteImport } from './routes/_app/(main)/shifts/$shift-id'
import { Route as AppmainSurveysIndexRouteImport } from './routes/_app/(main)/surveys/index'
import { Route as AppmainSurveysSurveyIdRouteImport } from './routes/_app/(main)/surveys/$survey-id'
import { Route as AppmainSurveysCreateRouteImport } from './routes/_app/(main)/surveys/create'
import { Route as AppmainTrainingIndexRouteImport } from './routes/_app/(main)/training/index'
import { Route as AppmainTrainingAnnouncementRouteImport } from './routes/_app/(main)/training/announcement'
import { Route as AppmainTrainingClientOnboardingRouteImport } from './routes/_app/(main)/training/client-onboarding'
import { Route as AppmainTrainingDemoRouteImport } from './routes/_app/(main)/training/demo'
import { Route as AppmainTrainingOnboardingRouteImport } from './routes/_app/(main)/training/onboarding'
import { Route as AppAdminAccessTokensIndexRouteImport } from './routes/_app/admin/access-tokens/index'
import { Route as AppAdminAccountsIndexRouteImport } from './routes/_app/admin/accounts/index'
import { Route as AppAdminAccountsAccountIdRouteImport } from './routes/_app/admin/accounts/$accountId'
import { Route as AppAdminAgentNotesIndexRouteImport } from './routes/_app/admin/agent-notes/index'
import { Route as AppAdminAgentNotesNoteIdRouteImport } from './routes/_app/admin/agent-notes/$note-id'
import { Route as AppAdminAgentTracesIndexRouteImport } from './routes/_app/admin/agent-traces/index'
import { Route as AppAdminAgentTracesConversationIdRouteImport } from './routes/_app/admin/agent-traces/$conversationId'
import { Route as AppAdminAgentTracesCaregiverRouteImport } from './routes/_app/admin/agent-traces/caregiver'
import { Route as AppAdminAgentTracesClientRouteImport } from './routes/_app/admin/agent-traces/client'
import { Route as AppAdminAgentTracesContinualRouteImport } from './routes/_app/admin/agent-traces/continual'
import { Route as AppAdminAgentTracesEphemeralRouteImport } from './routes/_app/admin/agent-traces/ephemeral'
import { Route as AppAdminAgentTracesPromptsRouteImport } from './routes/_app/admin/agent-traces/prompts'
import { Route as AppAdminAgentChatRouteRouteImport } from './routes/_app/admin/agent/_chat/route'
import { Route as AppAdminAgentConnectionsRouteImport } from './routes/_app/admin/agent/connections'
import { Route as AppAdminAgentJudgeRouteRouteImport } from './routes/_app/admin/agent/judge/route'
import { Route as AppAdminAgentSkillsRouteImport } from './routes/_app/admin/agent/skills'
import { Route as AppAdminAgentV3AutomationsRouteImport } from './routes/_app/admin/agent/v3-automations'
import { Route as AppAdminAgentVirtualizationRouteImport } from './routes/_app/admin/agent/virtualization'
import { Route as AppAdminAutoCalloutBoardIndexRouteImport } from './routes/_app/admin/auto-callout-board/index'
import { Route as AppAdminAutomationsIndexRouteImport } from './routes/_app/admin/automations/index'
import { Route as AppAdminCallsIndexRouteImport } from './routes/_app/admin/calls/index'
import { Route as AppAdminCallsCallIdRouteImport } from './routes/_app/admin/calls/$callId'
import { Route as AppAdminCareCoordinatorsIndexRouteImport } from './routes/_app/admin/care-coordinators/index'
import { Route as AppAdminCareCoordinatorsCareCoordinatorIdRouteImport } from './routes/_app/admin/care-coordinators/$care-coordinator-id'
import { Route as AppAdminCaregiversIndexRouteImport } from './routes/_app/admin/caregivers/index'
import { Route as AppAdminCaregiversCaregiverIdRouteImport } from './routes/_app/admin/caregivers/$caregiver-id'
import { Route as AppAdminClientsIndexRouteImport } from './routes/_app/admin/clients/index'
import { Route as AppAdminClientsClientIdRouteImport } from './routes/_app/admin/clients/$client-id'
import { Route as AppAdminExtensionLabIndexRouteImport } from './routes/_app/admin/extension-lab/index'
import { Route as AppAdminFranchisesIndexRouteImport } from './routes/_app/admin/franchises/index'
import { Route as AppAdminOrgDistributionsIndexRouteImport } from './routes/_app/admin/org-distributions/index'
import { Route as AppAdminOrganizationAttributesIndexRouteImport } from './routes/_app/admin/organization-attributes/index'
import { Route as AppAdminOrganizationsIndexRouteImport } from './routes/_app/admin/organizations/index'
import { Route as AppAdminOrganizationsOrganizationIdRouteImport } from './routes/_app/admin/organizations/$organization-id'
import { Route as AppAdminOutboxIndexRouteImport } from './routes/_app/admin/outbox/index'
import { Route as AppAdminRecommendationExplorerIndexRouteImport } from './routes/_app/admin/recommendation-explorer/index'
import { Route as AppAdminRevenueIndexRouteImport } from './routes/_app/admin/revenue/index'
import { Route as AppAdminRevenueAccountIdRouteImport } from './routes/_app/admin/revenue/$account-id'
import { Route as AppAdminRevenueAccountsRouteImport } from './routes/_app/admin/revenue/accounts'
import { Route as AppAdminSalesAgreementsRouteImport } from './routes/_app/admin/sales/agreements'
import { Route as AppAdminSandboxIndexRouteImport } from './routes/_app/admin/sandbox/index'
import { Route as AppAdminSandboxOrganizationIdRouteImport } from './routes/_app/admin/sandbox/$organizationId'
import { Route as AppAdminShiftsIndexRouteImport } from './routes/_app/admin/shifts/index'
import { Route as AppAdminShiftsShiftIdRouteImport } from './routes/_app/admin/shifts/$shift-id'
import { Route as AppAdminUsersIndexRouteImport } from './routes/_app/admin/users/index'
import { Route as AppAdminUsersUserIdRouteImport } from './routes/_app/admin/users/$user-id'
import { Route as AppAdminV3AgentIndexRouteImport } from './routes/_app/admin/v3-agent/index'
import { Route as AppAdminV3AgentRunIdRouteImport } from './routes/_app/admin/v3-agent/$runId'
import { Route as AppAdminV3AgentAutomationsRouteImport } from './routes/_app/admin/v3-agent/automations'
import { Route as AppAdminV3AgentJudgeRouteRouteImport } from './routes/_app/admin/v3-agent/judge/route'
import { Route as AppAdminV3AgentNewRouteImport } from './routes/_app/admin/v3-agent/new'
import { Route as AppAdminV3AgentSkillsRouteImport } from './routes/_app/admin/v3-agent/skills'
import { Route as AppAdminVoiceConfigIndexRouteImport } from './routes/_app/admin/voice-config/index'
import { Route as AppAdminVoiceConfigOrganizationIdRouteImport } from './routes/_app/admin/voice-config/$organization-id'
import { Route as AppAdminVoiceEvalsIndexRouteImport } from './routes/_app/admin/voice-evals/index'
import { Route as AppAdminVoiceEvalsCasesRouteImport } from './routes/_app/admin/voice-evals/cases'
import { Route as AppAdminVoiceEvalsCatalogRouteImport } from './routes/_app/admin/voice-evals/catalog'
import { Route as AppAdminVoiceEvalsCompareRouteImport } from './routes/_app/admin/voice-evals/compare'
import { Route as AppAdminVoiceEvalsCompareCaseRouteImport } from './routes/_app/admin/voice-evals/compare-case'
import { Route as AppAdminVoicePlaygroundIndexRouteImport } from './routes/_app/admin/voice-playground/index'
import { Route as AppAdminVoicePlaygroundCallIdRouteImport } from './routes/_app/admin/voice-playground/$call-id'
import { Route as AppAdminVoiceQaIndexRouteImport } from './routes/_app/admin/voice-qa/index'
import { Route as AppAdminVoiceQaCallIdRouteImport } from './routes/_app/admin/voice-qa/$callId'
import { Route as AppAdminVoiceQaShadowComparisonRouteImport } from './routes/_app/admin/voice-qa/shadow-comparison'
import { Route as AppAdminVoipIndexRouteImport } from './routes/_app/admin/voip/index'
import { Route as AppAdminVoipOrganizationIdRouteImport } from './routes/_app/admin/voip/$organization-id'
import { Route as AppSettingsNotificationsIndexRouteImport } from './routes/_app/settings/notifications/index'
import { Route as AppSettingsNotificationsChannelRouteImport } from './routes/_app/settings/notifications/$channel'
import { Route as AppSettingsTeamMembersMemberUserIdRouteImport } from './routes/_app/settings/team-members_.$memberUserId'
import { Route as AppSettingsTeamMembersBulkRouteImport } from './routes/_app/settings/team-members_.bulk'
import { Route as AppSettingsTeamMembersDefaultsRouteImport } from './routes/_app/settings/team-members_.defaults'
import { Route as AppagentAgentRunsRunIdRouteImport } from './routes/_app/(agent)/agent/runs/$runId'
import { Route as AppmainOutreachesMessageMessageIdRouteImport } from './routes/_app/(main)/outreaches/message.$message-id'
import { Route as AppmainOutreachesMessageCreateRouteImport } from './routes/_app/(main)/outreaches/message.create'
import { Route as AppmainOutreachesSurveySurveyIdRouteImport } from './routes/_app/(main)/outreaches/survey.$survey-id'
import { Route as AppmainOutreachesSurveyCreateRouteImport } from './routes/_app/(main)/outreaches/survey.create'
import { Route as AppAdminAgentTracesRunRunIdRouteImport } from './routes/_app/admin/agent-traces/run/$runId'
import { Route as AppAdminAgentChatIndexRouteImport } from './routes/_app/admin/agent/_chat/index'
import { Route as AppAdminAgentChatRunIdRouteImport } from './routes/_app/admin/agent/_chat/$runId'
import { Route as AppAdminAgentChatNewRouteImport } from './routes/_app/admin/agent/_chat/new'
import { Route as AppAdminAgentActionsIndexRouteImport } from './routes/_app/admin/agent/actions/index'
import { Route as AppAdminAgentActionsAuditIdRouteImport } from './routes/_app/admin/agent/actions/$audit-id'
import { Route as AppAdminAgentAutomationsIndexRouteImport } from './routes/_app/admin/agent/automations/index'
import { Route as AppAdminAgentAutomationsListRouteImport } from './routes/_app/admin/agent/automations/list'
import { Route as AppAdminAgentAutomationsRunsRouteImport } from './routes/_app/admin/agent/automations/runs'
import { Route as AppAdminAgentJudgeIndexRouteImport } from './routes/_app/admin/agent/judge/index'
import { Route as AppAdminAgentPagesIndexRouteImport } from './routes/_app/admin/agent/pages/index'
import { Route as AppAdminAgentPagesSlugRouteImport } from './routes/_app/admin/agent/pages/$slug'
import { Route as AppAdminAgentScratchpadIndexRouteImport } from './routes/_app/admin/agent/scratchpad/index'
import { Route as AppAdminAgentScratchpadNoteIdRouteImport } from './routes/_app/admin/agent/scratchpad/$note-id'
import { Route as AppAdminAutomationsOrganizationIdAutomationIdRouteImport } from './routes/_app/admin/automations/$organizationId/$automationId'
import { Route as AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRouteImport } from './routes/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId'
import { Route as AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125RouteImport } from './routes/_app/admin/ehr-contracts/{-$vendor}.{-$endpoint}'
import { Route as AppAdminOrganizationAttributesTabChar123OrganizationIdChar125RouteImport } from './routes/_app/admin/organization-attributes/$tab.{-$organizationId}'
import { Route as AppAdminV3AgentJudgeIndexRouteImport } from './routes/_app/admin/v3-agent/judge/index'
import { Route as AppAdminV3AgentScratchpadIndexRouteImport } from './routes/_app/admin/v3-agent/scratchpad/index'
import { Route as AppAdminV3AgentScratchpadNoteIdRouteImport } from './routes/_app/admin/v3-agent/scratchpad/$note-id'
import { Route as AppSettingsTeamMembersMemberUserIdIndexRouteImport } from './routes/_app/settings/team-members_.$memberUserId.index'
import { Route as AppmainExtensionReviewCalendarPhpUnassignedRouteImport } from './routes/_app/(main)/extension-review/calendar/php/unassigned'
import { Route as AppAdminAgentAutomationsOrganizationIdAutomationIdRouteImport } from './routes/_app/admin/agent/automations/$organizationId/$automationId'
import { Route as AppAdminAgentAutomationsGroupsAutomationGroupIdRouteImport } from './routes/_app/admin/agent/automations/groups/$automationGroupId'
import { Route as AppAdminAgentJudgeTraceRunIdRouteImport } from './routes/_app/admin/agent/judge/trace/$runId'
import { Route as AppAdminAutomationsOrganizationIdAutomationIdIndexRouteImport } from './routes/_app/admin/automations/$organizationId/$automationId/index'
import { Route as AppAdminV3AgentJudgeTraceRunIdRouteImport } from './routes/_app/admin/v3-agent/judge/trace/$runId'
import { Route as AppAdminVoiceEvalsRunsRunIdIndexRouteImport } from './routes/_app/admin/voice-evals/runs/$runId/index'
import { Route as AppSettingsTeamMembersMemberUserIdNotificationsIndexRouteImport } from './routes/_app/settings/team-members_.$memberUserId.notifications.index'
import { Route as AppSettingsTeamMembersMemberUserIdNotificationsChannelRouteImport } from './routes/_app/settings/team-members_.$memberUserId.notifications.$channel'
import { Route as AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRouteImport } from './routes/_app/admin/agent/automations/$organizationId/$automationId/index'
import { Route as AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport } from './routes/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId'
import { Route as AppAdminExtensionLabEhrProviderEntityExternalIdRouteImport } from './routes/_app/admin/extension-lab/ehr/$provider/$entity/$externalId'
import { Route as AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRouteImport } from './routes/_app/admin/voice-evals/runs/$runId/cases/$caseResultId'
import { Route as AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport } from './routes/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'

const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const PhoebeThinkingTipsMockupRoute =
  PhoebeThinkingTipsMockupRouteImport.update({
    id: '/phoebe-thinking-tips-mockup',
    path: '/phoebe-thinking-tips-mockup',
    getParentRoute: () => rootRouteImport,
  } as any)
const TeachPhoebeFeedbackTagsMockupRoute =
  TeachPhoebeFeedbackTagsMockupRouteImport.update({
    id: '/teach-phoebe-feedback-tags-mockup',
    path: '/teach-phoebe-feedback-tags-mockup',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrganizationIdDemoRoute = OrganizationIdDemoRouteImport.update({
  id: '/$organization-id/demo',
  path: '/$organization-id/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const AppagentRouteRoute = AppagentRouteRouteImport.update({
  id: '/(agent)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppextensionRouteRoute = AppextensionRouteRouteImport.update({
  id: '/(extension)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppmainRouteRoute = AppmainRouteRouteImport.update({
  id: '/(main)',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAdminRouteRoute = AppAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthAcceptInvitationRoute = AuthAcceptInvitationRouteImport.update({
  id: '/accept-invitation',
  path: '/accept-invitation',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthChangePasswordRoute = AuthChangePasswordRouteImport.update({
  id: '/change-password',
  path: '/change-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/error',
  path: '/error',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthIntroCallBookedRoute = AuthIntroCallBookedRouteImport.update({
  id: '/intro-call-booked',
  path: '/intro-call-booked',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRoute = AuthSignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignOutRoute = AuthSignOutRouteImport.update({
  id: '/sign-out',
  path: '/sign-out',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignUpRoute = AuthSignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ChromeExtensionPrivacyRoute = ChromeExtensionPrivacyRouteImport.update({
  id: '/chrome-extension/privacy',
  path: '/chrome-extension/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OutreachesPhoebeThinkingTipsMockupRoute =
  OutreachesPhoebeThinkingTipsMockupRouteImport.update({
    id: '/outreaches/phoebe-thinking-tips-mockup',
    path: '/outreaches/phoebe-thinking-tips-mockup',
    getParentRoute: () => rootRouteImport,
  } as any)
const RCodeRoute = RCodeRouteImport.update({
  id: '/r/$code',
  path: '/r/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const SimulatorWorldDisplayRoute = SimulatorWorldDisplayRouteImport.update({
  id: '/simulator-world/display',
  path: '/simulator-world/display',
  getParentRoute: () => rootRouteImport,
} as any)
const SlackAgentV3LinkRoute = SlackAgentV3LinkRouteImport.update({
  id: '/slack-agent-v3/link',
  path: '/slack-agent-v3/link',
  getParentRoute: () => rootRouteImport,
} as any)
const AppagentAgentRoute = AppagentAgentRouteImport.update({
  id: '/agent',
  path: '/agent',
  getParentRoute: () => AppagentRouteRoute,
} as any)
const AppextensionExtensionRouteRoute =
  AppextensionExtensionRouteRouteImport.update({
    id: '/extension',
    path: '/extension',
    getParentRoute: () => AppextensionRouteRoute,
  } as any)
const AppextensionExtensionLocalRouteRoute =
  AppextensionExtensionLocalRouteRouteImport.update({
    id: '/extension-local',
    path: '/extension-local',
    getParentRoute: () => AppextensionRouteRoute,
  } as any)
const AppmainIndexRoute = AppmainIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainActivityRoute = AppmainActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainActivityBoardRoute = AppmainActivityBoardRouteImport.update({
  id: '/activity-board',
  path: '/activity-board',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainAuthorizationsRoute = AppmainAuthorizationsRouteImport.update({
  id: '/authorizations',
  path: '/authorizations',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainCalloutsRoute = AppmainCalloutsRouteImport.update({
  id: '/callouts',
  path: '/callouts',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainCaregiversRoute = AppmainCaregiversRouteImport.update({
  id: '/caregivers',
  path: '/caregivers',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainClientsRoute = AppmainClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainCoverageRoute = AppmainCoverageRouteImport.update({
  id: '/coverage',
  path: '/coverage',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainDryRunReportRoute = AppmainDryRunReportRouteImport.update({
  id: '/dry-run-report',
  path: '/dry-run-report',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainFinancialsRoute = AppmainFinancialsRouteImport.update({
  id: '/financials',
  path: '/financials',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainHomeRoute = AppmainHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainLeaderboardRoute = AppmainLeaderboardRouteImport.update({
  id: '/leaderboard',
  path: '/leaderboard',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainLearnPhoebeRoute = AppmainLearnPhoebeRouteImport.update({
  id: '/learn-phoebe',
  path: '/learn-phoebe',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainMetricsRoute = AppmainMetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainPhoneRoute = AppmainPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainPlaybooksRoute = AppmainPlaybooksRouteImport.update({
  id: '/playbooks',
  path: '/playbooks',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainReferralsRoute = AppmainReferralsRouteImport.update({
  id: '/referrals',
  path: '/referrals',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainTeachPhoebeRoute = AppmainTeachPhoebeRouteImport.update({
  id: '/teach-phoebe',
  path: '/teach-phoebe',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainTrainingRoute = AppmainTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainVoiceCallsRoute = AppmainVoiceCallsRouteImport.update({
  id: '/voice-calls',
  path: '/voice-calls',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppAdminIndexRoute = AppAdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentToolsRoute = AppAdminAgentToolsRouteImport.update({
  id: '/agent-tools',
  path: '/agent-tools',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAmdLiveRoute = AppAdminAmdLiveRouteImport.update({
  id: '/amd-live',
  path: '/amd-live',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCarePlanPreviewerRoute =
  AppAdminCarePlanPreviewerRouteImport.update({
    id: '/care-plan-previewer',
    path: '/care-plan-previewer',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminDashboardUsageRoute = AppAdminDashboardUsageRouteImport.update({
  id: '/dashboard-usage',
  path: '/dashboard-usage',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDataQualityRoute = AppAdminDataQualityRouteImport.update({
  id: '/data-quality',
  path: '/data-quality',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDataSyncRoute = AppAdminDataSyncRouteImport.update({
  id: '/data-sync',
  path: '/data-sync',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDemoOrgRoute = AppAdminDemoOrgRouteImport.update({
  id: '/demo-org',
  path: '/demo-org',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminDesignKitRoute = AppAdminDesignKitRouteImport.update({
  id: '/design-kit',
  path: '/design-kit',
  getParentRoute: () => AppAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/admin/design-kit.lazy').then((d) => d.Route),
)
const AppAdminDocumentIngestionRoute =
  AppAdminDocumentIngestionRouteImport.update({
    id: '/document-ingestion',
    path: '/document-ingestion',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminExtensionLabRouteRoute =
  AppAdminExtensionLabRouteRouteImport.update({
    id: '/extension-lab',
    path: '/extension-lab',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminFlagsRoute = AppAdminFlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminImessageRoute = AppAdminImessageRouteImport.update({
  id: '/imessage',
  path: '/imessage',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminLlmSpendRoute = AppAdminLlmSpendRouteImport.update({
  id: '/llm-spend',
  path: '/llm-spend',
  getParentRoute: () => AppAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/admin/llm-spend.lazy').then((d) => d.Route),
)
const AppAdminMessageQueueRoute = AppAdminMessageQueueRouteImport.update({
  id: '/message-queue',
  path: '/message-queue',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminNotificationsLabRoute =
  AppAdminNotificationsLabRouteImport.update({
    id: '/notifications-lab',
    path: '/notifications-lab',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrgSnapshotsRoute = AppAdminOrgSnapshotsRouteImport.update({
  id: '/org-snapshots',
  path: '/org-snapshots',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrganizationDefaultSettingsRoute =
  AppAdminOrganizationDefaultSettingsRouteImport.update({
    id: '/organization-default-settings',
    path: '/organization-default-settings',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOutreachObservabilityRoute =
  AppAdminOutreachObservabilityRouteImport.update({
    id: '/outreach-observability',
    path: '/outreach-observability',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/outreach-observability.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminOutreachesRoute = AppAdminOutreachesRouteImport.update({
  id: '/outreaches',
  path: '/outreaches',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminPromptRolloutRoute = AppAdminPromptRolloutRouteImport.update({
  id: '/prompt-rollout',
  path: '/prompt-rollout',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminQualityScoreboardRoute =
  AppAdminQualityScoreboardRouteImport.update({
    id: '/quality-scoreboard',
    path: '/quality-scoreboard',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminReportGeneratorRoute = AppAdminReportGeneratorRouteImport.update({
  id: '/report-generator',
  path: '/report-generator',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSearchRoute = AppAdminSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminShiftAssignmentHealthRoute =
  AppAdminShiftAssignmentHealthRouteImport.update({
    id: '/shift-assignment-health',
    path: '/shift-assignment-health',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminSimulatorWorldRoute = AppAdminSimulatorWorldRouteImport.update({
  id: '/simulator-world',
  path: '/simulator-world',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSyncSettingsRoute = AppAdminSyncSettingsRouteImport.update({
  id: '/sync-settings',
  path: '/sync-settings',
  getParentRoute: () => AppAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/admin/sync-settings.lazy').then((d) => d.Route),
)
const AppAdminTagMatchingRoute = AppAdminTagMatchingRouteImport.update({
  id: '/tag-matching',
  path: '/tag-matching',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminTamMapRoute = AppAdminTamMapRouteImport.update({
  id: '/tam-map',
  path: '/tam-map',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUiComponentsRoute = AppAdminUiComponentsRouteImport.update({
  id: '/ui-components',
  path: '/ui-components',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminV3AgentRouteRoute = AppAdminV3AgentRouteRouteImport.update({
  id: '/v3-agent',
  path: '/v3-agent',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminV3EventComponentsRoute =
  AppAdminV3EventComponentsRouteImport.update({
    id: '/v3-event-components',
    path: '/v3-event-components',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceRoute = AppAdminVoiceRouteImport.update({
  id: '/voice',
  path: '/voice',
  getParentRoute: () => AppAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/admin/voice.lazy').then((d) => d.Route),
)
const AppAdminVoiceLatencyRoute = AppAdminVoiceLatencyRouteImport.update({
  id: '/voice-latency',
  path: '/voice-latency',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminWbrRoute = AppAdminWbrRouteImport.update({
  id: '/wbr',
  path: '/wbr',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppInternalAgreementsRoute = AppInternalAgreementsRouteImport.update({
  id: '/internal/agreements',
  path: '/internal/agreements',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsActivityFeedRoute = AppSettingsActivityFeedRouteImport.update({
  id: '/activity-feed',
  path: '/activity-feed',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAgencyContextRoute =
  AppSettingsAgencyContextRouteImport.update({
    id: '/agency-context',
    path: '/agency-context',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAgentRulesRoute = AppSettingsAgentRulesRouteImport.update({
  id: '/agent-rules',
  path: '/agent-rules',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutoAssignRoute = AppSettingsAutoAssignRouteImport.update({
  id: '/auto-assign',
  path: '/auto-assign',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutoDraftRoute = AppSettingsAutoDraftRouteImport.update({
  id: '/auto-draft',
  path: '/auto-draft',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutoReplySettingsRoute =
  AppSettingsAutoReplySettingsRouteImport.update({
    id: '/auto-reply-settings',
    path: '/auto-reply-settings',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAutoSendRoute = AppSettingsAutoSendRouteImport.update({
  id: '/auto-send',
  path: '/auto-send',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsAutomationScheduleRoute =
  AppSettingsAutomationScheduleRouteImport.update({
    id: '/automation-schedule',
    path: '/automation-schedule',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsAutomationsRoute = AppSettingsAutomationsRouteImport.update({
  id: '/automations',
  path: '/automations',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCallRoutingRoute = AppSettingsCallRoutingRouteImport.update({
  id: '/call-routing',
  path: '/call-routing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsCallTemplatesRoute =
  AppSettingsCallTemplatesRouteImport.update({
    id: '/call-templates',
    path: '/call-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCancellationsRoute =
  AppSettingsCancellationsRouteImport.update({
    id: '/cancellations',
    path: '/cancellations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCareCoordinatorsRoute =
  AppSettingsCareCoordinatorsRouteImport.update({
    id: '/care-coordinators',
    path: '/care-coordinators',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCaregiverEngagementRoute =
  AppSettingsCaregiverEngagementRouteImport.update({
    id: '/caregiver-engagement',
    path: '/caregiver-engagement',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsCaregiverTagsRoute =
  AppSettingsCaregiverTagsRouteImport.update({
    id: '/caregiver-tags',
    path: '/caregiver-tags',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsChangeHistoryRoute =
  AppSettingsChangeHistoryRouteImport.update({
    id: '/change-history',
    path: '/change-history',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsChromeExtensionRoute =
  AppSettingsChromeExtensionRouteImport.update({
    id: '/chrome-extension',
    path: '/chrome-extension',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsClientCommunicationRoute =
  AppSettingsClientCommunicationRouteImport.update({
    id: '/client-communication',
    path: '/client-communication',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsClockInOutRoute = AppSettingsClockInOutRouteImport.update({
  id: '/clock-in-out',
  path: '/clock-in-out',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsClockInTemplatesRoute =
  AppSettingsClockInTemplatesRouteImport.update({
    id: '/clock-in-templates',
    path: '/clock-in-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsConfigurationsRoute =
  AppSettingsConfigurationsRouteImport.update({
    id: '/configurations',
    path: '/configurations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsConfirmationMessagesRoute =
  AppSettingsConfirmationMessagesRouteImport.update({
    id: '/confirmation-messages',
    path: '/confirmation-messages',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsDailyDigestRoute = AppSettingsDailyDigestRouteImport.update({
  id: '/daily-digest',
  path: '/daily-digest',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsDataSyncRoute = AppSettingsDataSyncRouteImport.update({
  id: '/data-sync',
  path: '/data-sync',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsEarlyAccessRoute = AppSettingsEarlyAccessRouteImport.update({
  id: '/early-access',
  path: '/early-access',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsHelpCenterRoute = AppSettingsHelpCenterRouteImport.update({
  id: '/help-center',
  path: '/help-center',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationsRouteRoute =
  AppSettingsNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOffHoursRoute = AppSettingsOffHoursRouteImport.update({
  id: '/off-hours',
  path: '/off-hours',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOfficesRoute = AppSettingsOfficesRouteImport.update({
  id: '/offices',
  path: '/offices',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsOpenShiftResponsesRoute =
  AppSettingsOpenShiftResponsesRouteImport.update({
    id: '/open-shift-responses',
    path: '/open-shift-responses',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOtherTemplatesRoute =
  AppSettingsOtherTemplatesRouteImport.update({
    id: '/other-templates',
    path: '/other-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOutreachAutomationRoute =
  AppSettingsOutreachAutomationRouteImport.update({
    id: '/outreach-automation',
    path: '/outreach-automation',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsOutreachTemplatesRoute =
  AppSettingsOutreachTemplatesRouteImport.update({
    id: '/outreach-templates',
    path: '/outreach-templates',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPhoebeRoute = AppSettingsPhoebeRouteImport.update({
  id: '/phoebe',
  path: '/phoebe',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoneRoute = AppSettingsPhoneRouteImport.update({
  id: '/phone',
  path: '/phone',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoneInstructionsRoute =
  AppSettingsPhoneInstructionsRouteImport.update({
    id: '/phone-instructions',
    path: '/phone-instructions',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsPhoneNumbersRoute = AppSettingsPhoneNumbersRouteImport.update({
  id: '/phone-numbers',
  path: '/phone-numbers',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPhoneTryRoute = AppSettingsPhoneTryRouteImport.update({
  id: '/phone-try',
  path: '/phone-try',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPronunciationsRoute =
  AppSettingsPronunciationsRouteImport.update({
    id: '/pronunciations',
    path: '/pronunciations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsQuietHoursRoute = AppSettingsQuietHoursRouteImport.update({
  id: '/quiet-hours',
  path: '/quiet-hours',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsRecommendationsRoute =
  AppSettingsRecommendationsRouteImport.update({
    id: '/recommendations',
    path: '/recommendations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsShiftConfirmationSkipAllowListsRoute =
  AppSettingsShiftConfirmationSkipAllowListsRouteImport.update({
    id: '/shift-confirmation-skip-allow-lists',
    path: '/shift-confirmation-skip-allow-lists',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsShiftConfirmationsRoute =
  AppSettingsShiftConfirmationsRouteImport.update({
    id: '/shift-confirmations',
    path: '/shift-confirmations',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsSkipAllowListsRoute =
  AppSettingsSkipAllowListsRouteImport.update({
    id: '/skip-allow-lists',
    path: '/skip-allow-lists',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsSlackRoute = AppSettingsSlackRouteImport.update({
  id: '/slack',
  path: '/slack',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTagMatchingRoute = AppSettingsTagMatchingRouteImport.update({
  id: '/tag-matching',
  path: '/tag-matching',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTagsRoute = AppSettingsTagsRouteImport.update({
  id: '/tags',
  path: '/tags',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamCoverageRoute = AppSettingsTeamCoverageRouteImport.update({
  id: '/team-coverage',
  path: '/team-coverage',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamMembersRoute = AppSettingsTeamMembersRouteImport.update({
  id: '/team-members',
  path: '/team-members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsTeamsRoute = AppSettingsTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSlackLinkRoute = AppSlackLinkRouteImport.update({
  id: '/slack/link',
  path: '/slack/link',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppagentAgentIndexRoute = AppagentAgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppagentAgentRoute,
} as any)
const AppmainAutomationsIndexRoute = AppmainAutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainAutomationsAutomationIdRoute =
  AppmainAutomationsAutomationIdRouteImport.update({
    id: '/automations/$automationId',
    path: '/automations/$automationId',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainCalendarIndexRoute = AppmainCalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainConversationsIndexRoute =
  AppmainConversationsIndexRouteImport.update({
    id: '/conversations/',
    path: '/conversations/',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesIndexRoute = AppmainOutreachesIndexRouteImport.update({
  id: '/outreaches/',
  path: '/outreaches/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainOutreachesCalloutIdRoute =
  AppmainOutreachesCalloutIdRouteImport.update({
    id: '/outreaches/$callout-id',
    path: '/outreaches/$callout-id',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainRoutinesIndexRoute = AppmainRoutinesIndexRouteImport.update({
  id: '/routines/',
  path: '/routines/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainRoutinesRoutineIdRoute =
  AppmainRoutinesRoutineIdRouteImport.update({
    id: '/routines/$routineId',
    path: '/routines/$routineId',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainScheduledIndexRoute = AppmainScheduledIndexRouteImport.update({
  id: '/scheduled/',
  path: '/scheduled/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainShiftsIndexRoute = AppmainShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainShiftsShiftIdRoute = AppmainShiftsShiftIdRouteImport.update({
  id: '/shifts/$shift-id',
  path: '/shifts/$shift-id',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainSurveysIndexRoute = AppmainSurveysIndexRouteImport.update({
  id: '/surveys/',
  path: '/surveys/',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainSurveysSurveyIdRoute = AppmainSurveysSurveyIdRouteImport.update({
  id: '/surveys/$survey-id',
  path: '/surveys/$survey-id',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainSurveysCreateRoute = AppmainSurveysCreateRouteImport.update({
  id: '/surveys/create',
  path: '/surveys/create',
  getParentRoute: () => AppmainRouteRoute,
} as any)
const AppmainTrainingIndexRoute = AppmainTrainingIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppmainTrainingRoute,
} as any)
const AppmainTrainingAnnouncementRoute =
  AppmainTrainingAnnouncementRouteImport.update({
    id: '/announcement',
    path: '/announcement',
    getParentRoute: () => AppmainTrainingRoute,
  } as any)
const AppmainTrainingClientOnboardingRoute =
  AppmainTrainingClientOnboardingRouteImport.update({
    id: '/client-onboarding',
    path: '/client-onboarding',
    getParentRoute: () => AppmainTrainingRoute,
  } as any)
const AppmainTrainingDemoRoute = AppmainTrainingDemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => AppmainTrainingRoute,
} as any)
const AppmainTrainingOnboardingRoute =
  AppmainTrainingOnboardingRouteImport.update({
    id: '/onboarding',
    path: '/onboarding',
    getParentRoute: () => AppmainTrainingRoute,
  } as any)
const AppAdminAccessTokensIndexRoute =
  AppAdminAccessTokensIndexRouteImport.update({
    id: '/access-tokens/',
    path: '/access-tokens/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAccountsIndexRoute = AppAdminAccountsIndexRouteImport.update({
  id: '/accounts/',
  path: '/accounts/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAccountsAccountIdRoute =
  AppAdminAccountsAccountIdRouteImport.update({
    id: '/accounts/$accountId',
    path: '/accounts/$accountId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentNotesIndexRoute = AppAdminAgentNotesIndexRouteImport.update({
  id: '/agent-notes/',
  path: '/agent-notes/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentNotesNoteIdRoute =
  AppAdminAgentNotesNoteIdRouteImport.update({
    id: '/agent-notes/$note-id',
    path: '/agent-notes/$note-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentTracesIndexRoute =
  AppAdminAgentTracesIndexRouteImport.update({
    id: '/agent-traces/',
    path: '/agent-traces/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentTracesConversationIdRoute =
  AppAdminAgentTracesConversationIdRouteImport.update({
    id: '/agent-traces/$conversationId',
    path: '/agent-traces/$conversationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/agent-traces/$conversationId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminAgentTracesCaregiverRoute =
  AppAdminAgentTracesCaregiverRouteImport.update({
    id: '/agent-traces/caregiver',
    path: '/agent-traces/caregiver',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/agent-traces/caregiver.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminAgentTracesClientRoute =
  AppAdminAgentTracesClientRouteImport.update({
    id: '/agent-traces/client',
    path: '/agent-traces/client',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/agent-traces/client.lazy').then((d) => d.Route),
  )
const AppAdminAgentTracesContinualRoute =
  AppAdminAgentTracesContinualRouteImport.update({
    id: '/agent-traces/continual',
    path: '/agent-traces/continual',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/agent-traces/continual.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminAgentTracesEphemeralRoute =
  AppAdminAgentTracesEphemeralRouteImport.update({
    id: '/agent-traces/ephemeral',
    path: '/agent-traces/ephemeral',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentTracesPromptsRoute =
  AppAdminAgentTracesPromptsRouteImport.update({
    id: '/agent-traces/prompts',
    path: '/agent-traces/prompts',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentChatRouteRoute = AppAdminAgentChatRouteRouteImport.update({
  id: '/agent/_chat',
  path: '/agent',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentConnectionsRoute =
  AppAdminAgentConnectionsRouteImport.update({
    id: '/agent/connections',
    path: '/agent/connections',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentJudgeRouteRoute = AppAdminAgentJudgeRouteRouteImport.update({
  id: '/agent/judge',
  path: '/agent/judge',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentSkillsRoute = AppAdminAgentSkillsRouteImport.update({
  id: '/agent/skills',
  path: '/agent/skills',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentV3AutomationsRoute =
  AppAdminAgentV3AutomationsRouteImport.update({
    id: '/agent/v3-automations',
    path: '/agent/v3-automations',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentVirtualizationRoute =
  AppAdminAgentVirtualizationRouteImport.update({
    id: '/agent/virtualization',
    path: '/agent/virtualization',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAutoCalloutBoardIndexRoute =
  AppAdminAutoCalloutBoardIndexRouteImport.update({
    id: '/auto-callout-board/',
    path: '/auto-callout-board/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/auto-callout-board/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminAutomationsIndexRoute =
  AppAdminAutomationsIndexRouteImport.update({
    id: '/automations/',
    path: '/automations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCallsIndexRoute = AppAdminCallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCallsCallIdRoute = AppAdminCallsCallIdRouteImport.update({
  id: '/calls/$callId',
  path: '/calls/$callId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCareCoordinatorsIndexRoute =
  AppAdminCareCoordinatorsIndexRouteImport.update({
    id: '/care-coordinators/',
    path: '/care-coordinators/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCareCoordinatorsCareCoordinatorIdRoute =
  AppAdminCareCoordinatorsCareCoordinatorIdRouteImport.update({
    id: '/care-coordinators/$care-coordinator-id',
    path: '/care-coordinators/$care-coordinator-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCaregiversIndexRoute = AppAdminCaregiversIndexRouteImport.update({
  id: '/caregivers/',
  path: '/caregivers/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminCaregiversCaregiverIdRoute =
  AppAdminCaregiversCaregiverIdRouteImport.update({
    id: '/caregivers/$caregiver-id',
    path: '/caregivers/$caregiver-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminClientsIndexRoute = AppAdminClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminClientsClientIdRoute = AppAdminClientsClientIdRouteImport.update({
  id: '/clients/$client-id',
  path: '/clients/$client-id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminExtensionLabIndexRoute =
  AppAdminExtensionLabIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminExtensionLabRouteRoute,
  } as any)
const AppAdminFranchisesIndexRoute = AppAdminFranchisesIndexRouteImport.update({
  id: '/franchises/',
  path: '/franchises/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminOrgDistributionsIndexRoute =
  AppAdminOrgDistributionsIndexRouteImport.update({
    id: '/org-distributions/',
    path: '/org-distributions/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrganizationAttributesIndexRoute =
  AppAdminOrganizationAttributesIndexRouteImport.update({
    id: '/organization-attributes/',
    path: '/organization-attributes/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOrganizationsIndexRoute =
  AppAdminOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/organizations/index.lazy').then((d) => d.Route),
  )
const AppAdminOrganizationsOrganizationIdRoute =
  AppAdminOrganizationsOrganizationIdRouteImport.update({
    id: '/organizations/$organization-id',
    path: '/organizations/$organization-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminOutboxIndexRoute = AppAdminOutboxIndexRouteImport.update({
  id: '/outbox/',
  path: '/outbox/',
  getParentRoute: () => AppAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/admin/outbox/index.lazy').then((d) => d.Route),
)
const AppAdminRecommendationExplorerIndexRoute =
  AppAdminRecommendationExplorerIndexRouteImport.update({
    id: '/recommendation-explorer/',
    path: '/recommendation-explorer/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminRevenueIndexRoute = AppAdminRevenueIndexRouteImport.update({
  id: '/revenue/',
  path: '/revenue/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminRevenueAccountIdRoute =
  AppAdminRevenueAccountIdRouteImport.update({
    id: '/revenue/$account-id',
    path: '/revenue/$account-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminRevenueAccountsRoute = AppAdminRevenueAccountsRouteImport.update({
  id: '/revenue/accounts',
  path: '/revenue/accounts',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSalesAgreementsRoute = AppAdminSalesAgreementsRouteImport.update({
  id: '/sales/agreements',
  path: '/sales/agreements',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSandboxIndexRoute = AppAdminSandboxIndexRouteImport.update({
  id: '/sandbox/',
  path: '/sandbox/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminSandboxOrganizationIdRoute =
  AppAdminSandboxOrganizationIdRouteImport.update({
    id: '/sandbox/$organizationId',
    path: '/sandbox/$organizationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminShiftsIndexRoute = AppAdminShiftsIndexRouteImport.update({
  id: '/shifts/',
  path: '/shifts/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminShiftsShiftIdRoute = AppAdminShiftsShiftIdRouteImport.update({
  id: '/shifts/$shift-id',
  path: '/shifts/$shift-id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUsersIndexRoute = AppAdminUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminUsersUserIdRoute = AppAdminUsersUserIdRouteImport.update({
  id: '/users/$user-id',
  path: '/users/$user-id',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminV3AgentIndexRoute = AppAdminV3AgentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminV3AgentRouteRoute,
} as any)
const AppAdminV3AgentRunIdRoute = AppAdminV3AgentRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AppAdminV3AgentRouteRoute,
} as any)
const AppAdminV3AgentAutomationsRoute =
  AppAdminV3AgentAutomationsRouteImport.update({
    id: '/automations',
    path: '/automations',
    getParentRoute: () => AppAdminV3AgentRouteRoute,
  } as any)
const AppAdminV3AgentJudgeRouteRoute =
  AppAdminV3AgentJudgeRouteRouteImport.update({
    id: '/judge',
    path: '/judge',
    getParentRoute: () => AppAdminV3AgentRouteRoute,
  } as any)
const AppAdminV3AgentNewRoute = AppAdminV3AgentNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminV3AgentRouteRoute,
} as any)
const AppAdminV3AgentSkillsRoute = AppAdminV3AgentSkillsRouteImport.update({
  id: '/skills',
  path: '/skills',
  getParentRoute: () => AppAdminV3AgentRouteRoute,
} as any)
const AppAdminVoiceConfigIndexRoute =
  AppAdminVoiceConfigIndexRouteImport.update({
    id: '/voice-config/',
    path: '/voice-config/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceConfigOrganizationIdRoute =
  AppAdminVoiceConfigOrganizationIdRouteImport.update({
    id: '/voice-config/$organization-id',
    path: '/voice-config/$organization-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsIndexRoute = AppAdminVoiceEvalsIndexRouteImport.update({
  id: '/voice-evals/',
  path: '/voice-evals/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceEvalsCasesRoute = AppAdminVoiceEvalsCasesRouteImport.update({
  id: '/voice-evals/cases',
  path: '/voice-evals/cases',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceEvalsCatalogRoute =
  AppAdminVoiceEvalsCatalogRouteImport.update({
    id: '/voice-evals/catalog',
    path: '/voice-evals/catalog',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsCompareRoute =
  AppAdminVoiceEvalsCompareRouteImport.update({
    id: '/voice-evals/compare',
    path: '/voice-evals/compare',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceEvalsCompareCaseRoute =
  AppAdminVoiceEvalsCompareCaseRouteImport.update({
    id: '/voice-evals/compare-case',
    path: '/voice-evals/compare-case',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoicePlaygroundIndexRoute =
  AppAdminVoicePlaygroundIndexRouteImport.update({
    id: '/voice-playground/',
    path: '/voice-playground/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/voice-playground/index.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminVoicePlaygroundCallIdRoute =
  AppAdminVoicePlaygroundCallIdRouteImport.update({
    id: '/voice-playground/$call-id',
    path: '/voice-playground/$call-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoiceQaIndexRoute = AppAdminVoiceQaIndexRouteImport.update({
  id: '/voice-qa/',
  path: '/voice-qa/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceQaCallIdRoute = AppAdminVoiceQaCallIdRouteImport.update({
  id: '/voice-qa/$callId',
  path: '/voice-qa/$callId',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminVoiceQaShadowComparisonRoute =
  AppAdminVoiceQaShadowComparisonRouteImport.update({
    id: '/voice-qa/shadow-comparison',
    path: '/voice-qa/shadow-comparison',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminVoipIndexRoute = AppAdminVoipIndexRouteImport.update({
  id: '/voip/',
  path: '/voip/',
  getParentRoute: () => AppAdminRouteRoute,
} as any).lazy(() =>
  import('./routes/_app/admin/voip/index.lazy').then((d) => d.Route),
)
const AppAdminVoipOrganizationIdRoute =
  AppAdminVoipOrganizationIdRouteImport.update({
    id: '/voip/$organization-id',
    path: '/voip/$organization-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppSettingsNotificationsIndexRoute =
  AppSettingsNotificationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsNotificationsRouteRoute,
  } as any)
const AppSettingsNotificationsChannelRoute =
  AppSettingsNotificationsChannelRouteImport.update({
    id: '/$channel',
    path: '/$channel',
    getParentRoute: () => AppSettingsNotificationsRouteRoute,
  } as any)
const AppSettingsTeamMembersMemberUserIdRoute =
  AppSettingsTeamMembersMemberUserIdRouteImport.update({
    id: '/team-members_/$memberUserId',
    path: '/team-members/$memberUserId',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsTeamMembersBulkRoute =
  AppSettingsTeamMembersBulkRouteImport.update({
    id: '/team-members_/bulk',
    path: '/team-members/bulk',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsTeamMembersDefaultsRoute =
  AppSettingsTeamMembersDefaultsRouteImport.update({
    id: '/team-members_/defaults',
    path: '/team-members/defaults',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppagentAgentRunsRunIdRoute = AppagentAgentRunsRunIdRouteImport.update({
  id: '/runs/$runId',
  path: '/runs/$runId',
  getParentRoute: () => AppagentAgentRoute,
} as any)
const AppmainOutreachesMessageMessageIdRoute =
  AppmainOutreachesMessageMessageIdRouteImport.update({
    id: '/outreaches/message/$message-id',
    path: '/outreaches/message/$message-id',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesMessageCreateRoute =
  AppmainOutreachesMessageCreateRouteImport.update({
    id: '/outreaches/message/create',
    path: '/outreaches/message/create',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesSurveySurveyIdRoute =
  AppmainOutreachesSurveySurveyIdRouteImport.update({
    id: '/outreaches/survey/$survey-id',
    path: '/outreaches/survey/$survey-id',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppmainOutreachesSurveyCreateRoute =
  AppmainOutreachesSurveyCreateRouteImport.update({
    id: '/outreaches/survey/create',
    path: '/outreaches/survey/create',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppAdminAgentTracesRunRunIdRoute =
  AppAdminAgentTracesRunRunIdRouteImport.update({
    id: '/agent-traces/run/$runId',
    path: '/agent-traces/run/$runId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/agent-traces/run/$runId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminAgentChatIndexRoute = AppAdminAgentChatIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminAgentChatRouteRoute,
} as any)
const AppAdminAgentChatRunIdRoute = AppAdminAgentChatRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => AppAdminAgentChatRouteRoute,
} as any)
const AppAdminAgentChatNewRoute = AppAdminAgentChatNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AppAdminAgentChatRouteRoute,
} as any)
const AppAdminAgentActionsIndexRoute =
  AppAdminAgentActionsIndexRouteImport.update({
    id: '/agent/actions/',
    path: '/agent/actions/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentActionsAuditIdRoute =
  AppAdminAgentActionsAuditIdRouteImport.update({
    id: '/agent/actions/$audit-id',
    path: '/agent/actions/$audit-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsIndexRoute =
  AppAdminAgentAutomationsIndexRouteImport.update({
    id: '/agent/automations/',
    path: '/agent/automations/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsListRoute =
  AppAdminAgentAutomationsListRouteImport.update({
    id: '/agent/automations/list',
    path: '/agent/automations/list',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsRunsRoute =
  AppAdminAgentAutomationsRunsRouteImport.update({
    id: '/agent/automations/runs',
    path: '/agent/automations/runs',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentJudgeIndexRoute = AppAdminAgentJudgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAdminAgentJudgeRouteRoute,
} as any)
const AppAdminAgentPagesIndexRoute = AppAdminAgentPagesIndexRouteImport.update({
  id: '/agent/pages/',
  path: '/agent/pages/',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentPagesSlugRoute = AppAdminAgentPagesSlugRouteImport.update({
  id: '/agent/pages/$slug',
  path: '/agent/pages/$slug',
  getParentRoute: () => AppAdminRouteRoute,
} as any)
const AppAdminAgentScratchpadIndexRoute =
  AppAdminAgentScratchpadIndexRouteImport.update({
    id: '/agent/scratchpad/',
    path: '/agent/scratchpad/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentScratchpadNoteIdRoute =
  AppAdminAgentScratchpadNoteIdRouteImport.update({
    id: '/agent/scratchpad/$note-id',
    path: '/agent/scratchpad/$note-id',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAutomationsOrganizationIdAutomationIdRoute =
  AppAdminAutomationsOrganizationIdAutomationIdRouteImport.update({
    id: '/automations/$organizationId/$automationId',
    path: '/automations/$organizationId/$automationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute =
  AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRouteImport.update({
    id: '/caregiver-sms-shadow/$organizationId/$sourceMessageId',
    path: '/caregiver-sms-shadow/$organizationId/$sourceMessageId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any).lazy(() =>
    import('./routes/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId.lazy').then(
      (d) => d.Route,
    ),
  )
const AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route =
  AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125RouteImport.update(
    {
      id: '/ehr-contracts/{-$vendor}/{-$endpoint}',
      path: '/ehr-contracts/{-$vendor}/{-$endpoint}',
      getParentRoute: () => AppAdminRouteRoute,
    } as any,
  )
const AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route =
  AppAdminOrganizationAttributesTabChar123OrganizationIdChar125RouteImport.update(
    {
      id: '/organization-attributes/$tab/{-$organizationId}',
      path: '/organization-attributes/$tab/{-$organizationId}',
      getParentRoute: () => AppAdminRouteRoute,
    } as any,
  )
const AppAdminV3AgentJudgeIndexRoute =
  AppAdminV3AgentJudgeIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminV3AgentJudgeRouteRoute,
  } as any)
const AppAdminV3AgentScratchpadIndexRoute =
  AppAdminV3AgentScratchpadIndexRouteImport.update({
    id: '/scratchpad/',
    path: '/scratchpad/',
    getParentRoute: () => AppAdminV3AgentRouteRoute,
  } as any)
const AppAdminV3AgentScratchpadNoteIdRoute =
  AppAdminV3AgentScratchpadNoteIdRouteImport.update({
    id: '/scratchpad/$note-id',
    path: '/scratchpad/$note-id',
    getParentRoute: () => AppAdminV3AgentRouteRoute,
  } as any)
const AppSettingsTeamMembersMemberUserIdIndexRoute =
  AppSettingsTeamMembersMemberUserIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppSettingsTeamMembersMemberUserIdRoute,
  } as any)
const AppmainExtensionReviewCalendarPhpUnassignedRoute =
  AppmainExtensionReviewCalendarPhpUnassignedRouteImport.update({
    id: '/extension-review/calendar/php/unassigned',
    path: '/extension-review/calendar/php/unassigned',
    getParentRoute: () => AppmainRouteRoute,
  } as any)
const AppAdminAgentAutomationsOrganizationIdAutomationIdRoute =
  AppAdminAgentAutomationsOrganizationIdAutomationIdRouteImport.update({
    id: '/agent/automations/$organizationId/$automationId',
    path: '/agent/automations/$organizationId/$automationId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsGroupsAutomationGroupIdRoute =
  AppAdminAgentAutomationsGroupsAutomationGroupIdRouteImport.update({
    id: '/agent/automations/groups/$automationGroupId',
    path: '/agent/automations/groups/$automationGroupId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentJudgeTraceRunIdRoute =
  AppAdminAgentJudgeTraceRunIdRouteImport.update({
    id: '/trace/$runId',
    path: '/trace/$runId',
    getParentRoute: () => AppAdminAgentJudgeRouteRoute,
  } as any)
const AppAdminAutomationsOrganizationIdAutomationIdIndexRoute =
  AppAdminAutomationsOrganizationIdAutomationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppAdminAutomationsOrganizationIdAutomationIdRoute,
  } as any)
const AppAdminV3AgentJudgeTraceRunIdRoute =
  AppAdminV3AgentJudgeTraceRunIdRouteImport.update({
    id: '/trace/$runId',
    path: '/trace/$runId',
    getParentRoute: () => AppAdminV3AgentJudgeRouteRoute,
  } as any)
const AppAdminVoiceEvalsRunsRunIdIndexRoute =
  AppAdminVoiceEvalsRunsRunIdIndexRouteImport.update({
    id: '/voice-evals/runs/$runId/',
    path: '/voice-evals/runs/$runId/',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute =
  AppSettingsTeamMembersMemberUserIdNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AppSettingsTeamMembersMemberUserIdRoute,
  } as any)
const AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute =
  AppSettingsTeamMembersMemberUserIdNotificationsChannelRouteImport.update({
    id: '/notifications/$channel',
    path: '/notifications/$channel',
    getParentRoute: () => AppSettingsTeamMembersMemberUserIdRoute,
  } as any)
const AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute =
  AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () =>
      AppAdminAgentAutomationsOrganizationIdAutomationIdRoute,
  } as any)
const AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute =
  AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport.update(
    {
      id: '/runs/$automationRunId',
      path: '/runs/$automationRunId',
      getParentRoute: () => AppAdminAutomationsOrganizationIdAutomationIdRoute,
    } as any,
  )
const AppAdminExtensionLabEhrProviderEntityExternalIdRoute =
  AppAdminExtensionLabEhrProviderEntityExternalIdRouteImport.update({
    id: '/ehr/$provider/$entity/$externalId',
    path: '/ehr/$provider/$entity/$externalId',
    getParentRoute: () => AppAdminExtensionLabRouteRoute,
  } as any)
const AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute =
  AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRouteImport.update({
    id: '/voice-evals/runs/$runId/cases/$caseResultId',
    path: '/voice-evals/runs/$runId/cases/$caseResultId',
    getParentRoute: () => AppAdminRouteRoute,
  } as any)
const AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute =
  AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport.update(
    {
      id: '/runs/$automationRunId',
      path: '/runs/$automationRunId',
      getParentRoute: () =>
        AppAdminAgentAutomationsOrganizationIdAutomationIdRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof AppmainIndexRoute
  '/phoebe-thinking-tips-mockup': typeof PhoebeThinkingTipsMockupRoute
  '/teach-phoebe-feedback-tags-mockup': typeof TeachPhoebeFeedbackTagsMockupRoute
  '/admin': typeof AppAdminRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/$organization-id/demo': typeof OrganizationIdDemoRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/error': typeof AuthErrorRoute
  '/intro-call-booked': typeof AuthIntroCallBookedRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-out': typeof AuthSignOutRoute
  '/sign-up': typeof AuthSignUpRoute
  '/chrome-extension/privacy': typeof ChromeExtensionPrivacyRoute
  '/outreaches/phoebe-thinking-tips-mockup': typeof OutreachesPhoebeThinkingTipsMockupRoute
  '/r/$code': typeof RCodeRoute
  '/simulator-world/display': typeof SimulatorWorldDisplayRoute
  '/slack-agent-v3/link': typeof SlackAgentV3LinkRoute
  '/extension': typeof AppextensionExtensionRouteRoute
  '/extension-local': typeof AppextensionExtensionLocalRouteRoute
  '/admin/extension-lab': typeof AppAdminExtensionLabRouteRouteWithChildren
  '/admin/v3-agent': typeof AppAdminV3AgentRouteRouteWithChildren
  '/settings/notifications': typeof AppSettingsNotificationsRouteRouteWithChildren
  '/agent': typeof AppagentAgentRouteWithChildren
  '/activity': typeof AppmainActivityRoute
  '/activity-board': typeof AppmainActivityBoardRoute
  '/authorizations': typeof AppmainAuthorizationsRoute
  '/callouts': typeof AppmainCalloutsRoute
  '/caregivers': typeof AppmainCaregiversRoute
  '/clients': typeof AppmainClientsRoute
  '/coverage': typeof AppmainCoverageRoute
  '/dry-run-report': typeof AppmainDryRunReportRoute
  '/financials': typeof AppmainFinancialsRoute
  '/home': typeof AppmainHomeRoute
  '/leaderboard': typeof AppmainLeaderboardRoute
  '/learn-phoebe': typeof AppmainLearnPhoebeRoute
  '/metrics': typeof AppmainMetricsRoute
  '/phone': typeof AppmainPhoneRoute
  '/playbooks': typeof AppmainPlaybooksRoute
  '/referrals': typeof AppmainReferralsRoute
  '/teach-phoebe': typeof AppmainTeachPhoebeRoute
  '/training': typeof AppmainTrainingRouteWithChildren
  '/voice-calls': typeof AppmainVoiceCallsRoute
  '/admin/agent-tools': typeof AppAdminAgentToolsRoute
  '/admin/amd-live': typeof AppAdminAmdLiveRoute
  '/admin/care-plan-previewer': typeof AppAdminCarePlanPreviewerRoute
  '/admin/dashboard-usage': typeof AppAdminDashboardUsageRoute
  '/admin/data-quality': typeof AppAdminDataQualityRoute
  '/admin/data-sync': typeof AppAdminDataSyncRoute
  '/admin/demo-org': typeof AppAdminDemoOrgRoute
  '/admin/design-kit': typeof AppAdminDesignKitRoute
  '/admin/document-ingestion': typeof AppAdminDocumentIngestionRoute
  '/admin/flags': typeof AppAdminFlagsRoute
  '/admin/imessage': typeof AppAdminImessageRoute
  '/admin/llm-spend': typeof AppAdminLlmSpendRoute
  '/admin/message-queue': typeof AppAdminMessageQueueRoute
  '/admin/notifications-lab': typeof AppAdminNotificationsLabRoute
  '/admin/org-snapshots': typeof AppAdminOrgSnapshotsRoute
  '/admin/organization-default-settings': typeof AppAdminOrganizationDefaultSettingsRoute
  '/admin/outreach-observability': typeof AppAdminOutreachObservabilityRoute
  '/admin/outreaches': typeof AppAdminOutreachesRoute
  '/admin/prompt-rollout': typeof AppAdminPromptRolloutRoute
  '/admin/quality-scoreboard': typeof AppAdminQualityScoreboardRoute
  '/admin/report-generator': typeof AppAdminReportGeneratorRoute
  '/admin/search': typeof AppAdminSearchRoute
  '/admin/shift-assignment-health': typeof AppAdminShiftAssignmentHealthRoute
  '/admin/simulator-world': typeof AppAdminSimulatorWorldRoute
  '/admin/sync-settings': typeof AppAdminSyncSettingsRoute
  '/admin/tag-matching': typeof AppAdminTagMatchingRoute
  '/admin/tam-map': typeof AppAdminTamMapRoute
  '/admin/ui-components': typeof AppAdminUiComponentsRoute
  '/admin/v3-event-components': typeof AppAdminV3EventComponentsRoute
  '/admin/voice': typeof AppAdminVoiceRoute
  '/admin/voice-latency': typeof AppAdminVoiceLatencyRoute
  '/admin/wbr': typeof AppAdminWbrRoute
  '/internal/agreements': typeof AppInternalAgreementsRoute
  '/settings/activity-feed': typeof AppSettingsActivityFeedRoute
  '/settings/agency-context': typeof AppSettingsAgencyContextRoute
  '/settings/agent-rules': typeof AppSettingsAgentRulesRoute
  '/settings/auto-assign': typeof AppSettingsAutoAssignRoute
  '/settings/auto-draft': typeof AppSettingsAutoDraftRoute
  '/settings/auto-reply-settings': typeof AppSettingsAutoReplySettingsRoute
  '/settings/auto-send': typeof AppSettingsAutoSendRoute
  '/settings/automation-schedule': typeof AppSettingsAutomationScheduleRoute
  '/settings/automations': typeof AppSettingsAutomationsRoute
  '/settings/call-routing': typeof AppSettingsCallRoutingRoute
  '/settings/call-templates': typeof AppSettingsCallTemplatesRoute
  '/settings/cancellations': typeof AppSettingsCancellationsRoute
  '/settings/care-coordinators': typeof AppSettingsCareCoordinatorsRoute
  '/settings/caregiver-engagement': typeof AppSettingsCaregiverEngagementRoute
  '/settings/caregiver-tags': typeof AppSettingsCaregiverTagsRoute
  '/settings/change-history': typeof AppSettingsChangeHistoryRoute
  '/settings/chrome-extension': typeof AppSettingsChromeExtensionRoute
  '/settings/client-communication': typeof AppSettingsClientCommunicationRoute
  '/settings/clock-in-out': typeof AppSettingsClockInOutRoute
  '/settings/clock-in-templates': typeof AppSettingsClockInTemplatesRoute
  '/settings/configurations': typeof AppSettingsConfigurationsRoute
  '/settings/confirmation-messages': typeof AppSettingsConfirmationMessagesRoute
  '/settings/daily-digest': typeof AppSettingsDailyDigestRoute
  '/settings/data-sync': typeof AppSettingsDataSyncRoute
  '/settings/early-access': typeof AppSettingsEarlyAccessRoute
  '/settings/help-center': typeof AppSettingsHelpCenterRoute
  '/settings/off-hours': typeof AppSettingsOffHoursRoute
  '/settings/offices': typeof AppSettingsOfficesRoute
  '/settings/open-shift-responses': typeof AppSettingsOpenShiftResponsesRoute
  '/settings/other-templates': typeof AppSettingsOtherTemplatesRoute
  '/settings/outreach-automation': typeof AppSettingsOutreachAutomationRoute
  '/settings/outreach-templates': typeof AppSettingsOutreachTemplatesRoute
  '/settings/phoebe': typeof AppSettingsPhoebeRoute
  '/settings/phone': typeof AppSettingsPhoneRoute
  '/settings/phone-instructions': typeof AppSettingsPhoneInstructionsRoute
  '/settings/phone-numbers': typeof AppSettingsPhoneNumbersRoute
  '/settings/phone-try': typeof AppSettingsPhoneTryRoute
  '/settings/pronunciations': typeof AppSettingsPronunciationsRoute
  '/settings/quiet-hours': typeof AppSettingsQuietHoursRoute
  '/settings/recommendations': typeof AppSettingsRecommendationsRoute
  '/settings/shift-confirmation-skip-allow-lists': typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  '/settings/shift-confirmations': typeof AppSettingsShiftConfirmationsRoute
  '/settings/skip-allow-lists': typeof AppSettingsSkipAllowListsRoute
  '/settings/slack': typeof AppSettingsSlackRoute
  '/settings/tag-matching': typeof AppSettingsTagMatchingRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/team-coverage': typeof AppSettingsTeamCoverageRoute
  '/settings/team-members': typeof AppSettingsTeamMembersRoute
  '/settings/teams': typeof AppSettingsTeamsRoute
  '/slack/link': typeof AppSlackLinkRoute
  '/admin/': typeof AppAdminIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/admin/agent': typeof AppAdminAgentChatRouteRouteWithChildren
  '/admin/agent/judge': typeof AppAdminAgentJudgeRouteRouteWithChildren
  '/admin/v3-agent/judge': typeof AppAdminV3AgentJudgeRouteRouteWithChildren
  '/automations/$automationId': typeof AppmainAutomationsAutomationIdRoute
  '/outreaches/$callout-id': typeof AppmainOutreachesCalloutIdRoute
  '/routines/$routineId': typeof AppmainRoutinesRoutineIdRoute
  '/shifts/$shift-id': typeof AppmainShiftsShiftIdRoute
  '/surveys/$survey-id': typeof AppmainSurveysSurveyIdRoute
  '/surveys/create': typeof AppmainSurveysCreateRoute
  '/training/announcement': typeof AppmainTrainingAnnouncementRoute
  '/training/client-onboarding': typeof AppmainTrainingClientOnboardingRoute
  '/training/demo': typeof AppmainTrainingDemoRoute
  '/training/onboarding': typeof AppmainTrainingOnboardingRoute
  '/admin/accounts/$accountId': typeof AppAdminAccountsAccountIdRoute
  '/admin/agent-notes/$note-id': typeof AppAdminAgentNotesNoteIdRoute
  '/admin/agent-traces/$conversationId': typeof AppAdminAgentTracesConversationIdRoute
  '/admin/agent-traces/caregiver': typeof AppAdminAgentTracesCaregiverRoute
  '/admin/agent-traces/client': typeof AppAdminAgentTracesClientRoute
  '/admin/agent-traces/continual': typeof AppAdminAgentTracesContinualRoute
  '/admin/agent-traces/ephemeral': typeof AppAdminAgentTracesEphemeralRoute
  '/admin/agent-traces/prompts': typeof AppAdminAgentTracesPromptsRoute
  '/admin/agent/connections': typeof AppAdminAgentConnectionsRoute
  '/admin/agent/skills': typeof AppAdminAgentSkillsRoute
  '/admin/agent/v3-automations': typeof AppAdminAgentV3AutomationsRoute
  '/admin/agent/virtualization': typeof AppAdminAgentVirtualizationRoute
  '/admin/calls/$callId': typeof AppAdminCallsCallIdRoute
  '/admin/care-coordinators/$care-coordinator-id': typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  '/admin/caregivers/$caregiver-id': typeof AppAdminCaregiversCaregiverIdRoute
  '/admin/clients/$client-id': typeof AppAdminClientsClientIdRoute
  '/admin/organizations/$organization-id': typeof AppAdminOrganizationsOrganizationIdRoute
  '/admin/revenue/$account-id': typeof AppAdminRevenueAccountIdRoute
  '/admin/revenue/accounts': typeof AppAdminRevenueAccountsRoute
  '/admin/sales/agreements': typeof AppAdminSalesAgreementsRoute
  '/admin/sandbox/$organizationId': typeof AppAdminSandboxOrganizationIdRoute
  '/admin/shifts/$shift-id': typeof AppAdminShiftsShiftIdRoute
  '/admin/users/$user-id': typeof AppAdminUsersUserIdRoute
  '/admin/v3-agent/$runId': typeof AppAdminV3AgentRunIdRoute
  '/admin/v3-agent/automations': typeof AppAdminV3AgentAutomationsRoute
  '/admin/v3-agent/new': typeof AppAdminV3AgentNewRoute
  '/admin/v3-agent/skills': typeof AppAdminV3AgentSkillsRoute
  '/admin/voice-config/$organization-id': typeof AppAdminVoiceConfigOrganizationIdRoute
  '/admin/voice-evals/cases': typeof AppAdminVoiceEvalsCasesRoute
  '/admin/voice-evals/catalog': typeof AppAdminVoiceEvalsCatalogRoute
  '/admin/voice-evals/compare': typeof AppAdminVoiceEvalsCompareRoute
  '/admin/voice-evals/compare-case': typeof AppAdminVoiceEvalsCompareCaseRoute
  '/admin/voice-playground/$call-id': typeof AppAdminVoicePlaygroundCallIdRoute
  '/admin/voice-qa/$callId': typeof AppAdminVoiceQaCallIdRoute
  '/admin/voice-qa/shadow-comparison': typeof AppAdminVoiceQaShadowComparisonRoute
  '/admin/voip/$organization-id': typeof AppAdminVoipOrganizationIdRoute
  '/settings/notifications/$channel': typeof AppSettingsNotificationsChannelRoute
  '/settings/team-members/$memberUserId': typeof AppSettingsTeamMembersMemberUserIdRouteWithChildren
  '/settings/team-members/bulk': typeof AppSettingsTeamMembersBulkRoute
  '/settings/team-members/defaults': typeof AppSettingsTeamMembersDefaultsRoute
  '/agent/': typeof AppagentAgentIndexRoute
  '/automations/': typeof AppmainAutomationsIndexRoute
  '/calendar/': typeof AppmainCalendarIndexRoute
  '/conversations/': typeof AppmainConversationsIndexRoute
  '/outreaches/': typeof AppmainOutreachesIndexRoute
  '/routines/': typeof AppmainRoutinesIndexRoute
  '/scheduled/': typeof AppmainScheduledIndexRoute
  '/shifts/': typeof AppmainShiftsIndexRoute
  '/surveys/': typeof AppmainSurveysIndexRoute
  '/training/': typeof AppmainTrainingIndexRoute
  '/admin/access-tokens/': typeof AppAdminAccessTokensIndexRoute
  '/admin/accounts/': typeof AppAdminAccountsIndexRoute
  '/admin/agent-notes/': typeof AppAdminAgentNotesIndexRoute
  '/admin/agent-traces/': typeof AppAdminAgentTracesIndexRoute
  '/admin/auto-callout-board/': typeof AppAdminAutoCalloutBoardIndexRoute
  '/admin/automations/': typeof AppAdminAutomationsIndexRoute
  '/admin/calls/': typeof AppAdminCallsIndexRoute
  '/admin/care-coordinators/': typeof AppAdminCareCoordinatorsIndexRoute
  '/admin/caregivers/': typeof AppAdminCaregiversIndexRoute
  '/admin/clients/': typeof AppAdminClientsIndexRoute
  '/admin/extension-lab/': typeof AppAdminExtensionLabIndexRoute
  '/admin/franchises/': typeof AppAdminFranchisesIndexRoute
  '/admin/org-distributions/': typeof AppAdminOrgDistributionsIndexRoute
  '/admin/organization-attributes/': typeof AppAdminOrganizationAttributesIndexRoute
  '/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/admin/outbox/': typeof AppAdminOutboxIndexRoute
  '/admin/recommendation-explorer/': typeof AppAdminRecommendationExplorerIndexRoute
  '/admin/revenue/': typeof AppAdminRevenueIndexRoute
  '/admin/sandbox/': typeof AppAdminSandboxIndexRoute
  '/admin/shifts/': typeof AppAdminShiftsIndexRoute
  '/admin/users/': typeof AppAdminUsersIndexRoute
  '/admin/v3-agent/': typeof AppAdminV3AgentIndexRoute
  '/admin/voice-config/': typeof AppAdminVoiceConfigIndexRoute
  '/admin/voice-evals/': typeof AppAdminVoiceEvalsIndexRoute
  '/admin/voice-playground/': typeof AppAdminVoicePlaygroundIndexRoute
  '/admin/voice-qa/': typeof AppAdminVoiceQaIndexRoute
  '/admin/voip/': typeof AppAdminVoipIndexRoute
  '/settings/notifications/': typeof AppSettingsNotificationsIndexRoute
  '/agent/runs/$runId': typeof AppagentAgentRunsRunIdRoute
  '/outreaches/message/$message-id': typeof AppmainOutreachesMessageMessageIdRoute
  '/outreaches/message/create': typeof AppmainOutreachesMessageCreateRoute
  '/outreaches/survey/$survey-id': typeof AppmainOutreachesSurveySurveyIdRoute
  '/outreaches/survey/create': typeof AppmainOutreachesSurveyCreateRoute
  '/admin/agent-traces/run/$runId': typeof AppAdminAgentTracesRunRunIdRoute
  '/admin/agent/$runId': typeof AppAdminAgentChatRunIdRoute
  '/admin/agent/new': typeof AppAdminAgentChatNewRoute
  '/admin/agent/actions/$audit-id': typeof AppAdminAgentActionsAuditIdRoute
  '/admin/agent/automations/list': typeof AppAdminAgentAutomationsListRoute
  '/admin/agent/automations/runs': typeof AppAdminAgentAutomationsRunsRoute
  '/admin/agent/pages/$slug': typeof AppAdminAgentPagesSlugRoute
  '/admin/agent/scratchpad/$note-id': typeof AppAdminAgentScratchpadNoteIdRoute
  '/admin/automations/$organizationId/$automationId': typeof AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId': typeof AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute
  '/admin/ehr-contracts/{-$vendor}/{-$endpoint}': typeof AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route
  '/admin/organization-attributes/$tab/{-$organizationId}': typeof AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route
  '/admin/v3-agent/scratchpad/$note-id': typeof AppAdminV3AgentScratchpadNoteIdRoute
  '/admin/agent/': typeof AppAdminAgentChatIndexRoute
  '/admin/agent/actions/': typeof AppAdminAgentActionsIndexRoute
  '/admin/agent/automations/': typeof AppAdminAgentAutomationsIndexRoute
  '/admin/agent/judge/': typeof AppAdminAgentJudgeIndexRoute
  '/admin/agent/pages/': typeof AppAdminAgentPagesIndexRoute
  '/admin/agent/scratchpad/': typeof AppAdminAgentScratchpadIndexRoute
  '/admin/v3-agent/judge/': typeof AppAdminV3AgentJudgeIndexRoute
  '/admin/v3-agent/scratchpad/': typeof AppAdminV3AgentScratchpadIndexRoute
  '/settings/team-members/$memberUserId/': typeof AppSettingsTeamMembersMemberUserIdIndexRoute
  '/extension-review/calendar/php/unassigned': typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
  '/admin/agent/automations/$organizationId/$automationId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/admin/agent/automations/groups/$automationGroupId': typeof AppAdminAgentAutomationsGroupsAutomationGroupIdRoute
  '/admin/agent/judge/trace/$runId': typeof AppAdminAgentJudgeTraceRunIdRoute
  '/admin/v3-agent/judge/trace/$runId': typeof AppAdminV3AgentJudgeTraceRunIdRoute
  '/settings/team-members/$memberUserId/notifications/$channel': typeof AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute
  '/admin/automations/$organizationId/$automationId/': typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/voice-evals/runs/$runId/': typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  '/settings/team-members/$memberUserId/notifications/': typeof AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute
  '/admin/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
  '/admin/extension-lab/ehr/$provider/$entity/$externalId': typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
  '/admin/voice-evals/runs/$runId/cases/$caseResultId': typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
  '/admin/agent/automations/$organizationId/$automationId/': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AppmainIndexRoute
  '/phoebe-thinking-tips-mockup': typeof PhoebeThinkingTipsMockupRoute
  '/teach-phoebe-feedback-tags-mockup': typeof TeachPhoebeFeedbackTagsMockupRoute
  '/$organization-id/demo': typeof OrganizationIdDemoRoute
  '/accept-invitation': typeof AuthAcceptInvitationRoute
  '/change-password': typeof AuthChangePasswordRoute
  '/error': typeof AuthErrorRoute
  '/intro-call-booked': typeof AuthIntroCallBookedRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/sign-in': typeof AuthSignInRoute
  '/sign-out': typeof AuthSignOutRoute
  '/sign-up': typeof AuthSignUpRoute
  '/chrome-extension/privacy': typeof ChromeExtensionPrivacyRoute
  '/outreaches/phoebe-thinking-tips-mockup': typeof OutreachesPhoebeThinkingTipsMockupRoute
  '/r/$code': typeof RCodeRoute
  '/simulator-world/display': typeof SimulatorWorldDisplayRoute
  '/slack-agent-v3/link': typeof SlackAgentV3LinkRoute
  '/extension': typeof AppextensionExtensionRouteRoute
  '/extension-local': typeof AppextensionExtensionLocalRouteRoute
  '/activity': typeof AppmainActivityRoute
  '/activity-board': typeof AppmainActivityBoardRoute
  '/authorizations': typeof AppmainAuthorizationsRoute
  '/callouts': typeof AppmainCalloutsRoute
  '/caregivers': typeof AppmainCaregiversRoute
  '/clients': typeof AppmainClientsRoute
  '/coverage': typeof AppmainCoverageRoute
  '/dry-run-report': typeof AppmainDryRunReportRoute
  '/financials': typeof AppmainFinancialsRoute
  '/home': typeof AppmainHomeRoute
  '/leaderboard': typeof AppmainLeaderboardRoute
  '/learn-phoebe': typeof AppmainLearnPhoebeRoute
  '/metrics': typeof AppmainMetricsRoute
  '/phone': typeof AppmainPhoneRoute
  '/playbooks': typeof AppmainPlaybooksRoute
  '/referrals': typeof AppmainReferralsRoute
  '/teach-phoebe': typeof AppmainTeachPhoebeRoute
  '/voice-calls': typeof AppmainVoiceCallsRoute
  '/admin/agent-tools': typeof AppAdminAgentToolsRoute
  '/admin/amd-live': typeof AppAdminAmdLiveRoute
  '/admin/care-plan-previewer': typeof AppAdminCarePlanPreviewerRoute
  '/admin/dashboard-usage': typeof AppAdminDashboardUsageRoute
  '/admin/data-quality': typeof AppAdminDataQualityRoute
  '/admin/data-sync': typeof AppAdminDataSyncRoute
  '/admin/demo-org': typeof AppAdminDemoOrgRoute
  '/admin/design-kit': typeof AppAdminDesignKitRoute
  '/admin/document-ingestion': typeof AppAdminDocumentIngestionRoute
  '/admin/flags': typeof AppAdminFlagsRoute
  '/admin/imessage': typeof AppAdminImessageRoute
  '/admin/llm-spend': typeof AppAdminLlmSpendRoute
  '/admin/message-queue': typeof AppAdminMessageQueueRoute
  '/admin/notifications-lab': typeof AppAdminNotificationsLabRoute
  '/admin/org-snapshots': typeof AppAdminOrgSnapshotsRoute
  '/admin/organization-default-settings': typeof AppAdminOrganizationDefaultSettingsRoute
  '/admin/outreach-observability': typeof AppAdminOutreachObservabilityRoute
  '/admin/outreaches': typeof AppAdminOutreachesRoute
  '/admin/prompt-rollout': typeof AppAdminPromptRolloutRoute
  '/admin/quality-scoreboard': typeof AppAdminQualityScoreboardRoute
  '/admin/report-generator': typeof AppAdminReportGeneratorRoute
  '/admin/search': typeof AppAdminSearchRoute
  '/admin/shift-assignment-health': typeof AppAdminShiftAssignmentHealthRoute
  '/admin/simulator-world': typeof AppAdminSimulatorWorldRoute
  '/admin/sync-settings': typeof AppAdminSyncSettingsRoute
  '/admin/tag-matching': typeof AppAdminTagMatchingRoute
  '/admin/tam-map': typeof AppAdminTamMapRoute
  '/admin/ui-components': typeof AppAdminUiComponentsRoute
  '/admin/v3-event-components': typeof AppAdminV3EventComponentsRoute
  '/admin/voice': typeof AppAdminVoiceRoute
  '/admin/voice-latency': typeof AppAdminVoiceLatencyRoute
  '/admin/wbr': typeof AppAdminWbrRoute
  '/internal/agreements': typeof AppInternalAgreementsRoute
  '/settings/activity-feed': typeof AppSettingsActivityFeedRoute
  '/settings/agency-context': typeof AppSettingsAgencyContextRoute
  '/settings/agent-rules': typeof AppSettingsAgentRulesRoute
  '/settings/auto-assign': typeof AppSettingsAutoAssignRoute
  '/settings/auto-draft': typeof AppSettingsAutoDraftRoute
  '/settings/auto-reply-settings': typeof AppSettingsAutoReplySettingsRoute
  '/settings/auto-send': typeof AppSettingsAutoSendRoute
  '/settings/automation-schedule': typeof AppSettingsAutomationScheduleRoute
  '/settings/automations': typeof AppSettingsAutomationsRoute
  '/settings/call-routing': typeof AppSettingsCallRoutingRoute
  '/settings/call-templates': typeof AppSettingsCallTemplatesRoute
  '/settings/cancellations': typeof AppSettingsCancellationsRoute
  '/settings/care-coordinators': typeof AppSettingsCareCoordinatorsRoute
  '/settings/caregiver-engagement': typeof AppSettingsCaregiverEngagementRoute
  '/settings/caregiver-tags': typeof AppSettingsCaregiverTagsRoute
  '/settings/change-history': typeof AppSettingsChangeHistoryRoute
  '/settings/chrome-extension': typeof AppSettingsChromeExtensionRoute
  '/settings/client-communication': typeof AppSettingsClientCommunicationRoute
  '/settings/clock-in-out': typeof AppSettingsClockInOutRoute
  '/settings/clock-in-templates': typeof AppSettingsClockInTemplatesRoute
  '/settings/configurations': typeof AppSettingsConfigurationsRoute
  '/settings/confirmation-messages': typeof AppSettingsConfirmationMessagesRoute
  '/settings/daily-digest': typeof AppSettingsDailyDigestRoute
  '/settings/data-sync': typeof AppSettingsDataSyncRoute
  '/settings/early-access': typeof AppSettingsEarlyAccessRoute
  '/settings/help-center': typeof AppSettingsHelpCenterRoute
  '/settings/off-hours': typeof AppSettingsOffHoursRoute
  '/settings/offices': typeof AppSettingsOfficesRoute
  '/settings/open-shift-responses': typeof AppSettingsOpenShiftResponsesRoute
  '/settings/other-templates': typeof AppSettingsOtherTemplatesRoute
  '/settings/outreach-automation': typeof AppSettingsOutreachAutomationRoute
  '/settings/outreach-templates': typeof AppSettingsOutreachTemplatesRoute
  '/settings/phoebe': typeof AppSettingsPhoebeRoute
  '/settings/phone': typeof AppSettingsPhoneRoute
  '/settings/phone-instructions': typeof AppSettingsPhoneInstructionsRoute
  '/settings/phone-numbers': typeof AppSettingsPhoneNumbersRoute
  '/settings/phone-try': typeof AppSettingsPhoneTryRoute
  '/settings/pronunciations': typeof AppSettingsPronunciationsRoute
  '/settings/quiet-hours': typeof AppSettingsQuietHoursRoute
  '/settings/recommendations': typeof AppSettingsRecommendationsRoute
  '/settings/shift-confirmation-skip-allow-lists': typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  '/settings/shift-confirmations': typeof AppSettingsShiftConfirmationsRoute
  '/settings/skip-allow-lists': typeof AppSettingsSkipAllowListsRoute
  '/settings/slack': typeof AppSettingsSlackRoute
  '/settings/tag-matching': typeof AppSettingsTagMatchingRoute
  '/settings/tags': typeof AppSettingsTagsRoute
  '/settings/team-coverage': typeof AppSettingsTeamCoverageRoute
  '/settings/team-members': typeof AppSettingsTeamMembersRoute
  '/settings/teams': typeof AppSettingsTeamsRoute
  '/slack/link': typeof AppSlackLinkRoute
  '/admin': typeof AppAdminIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/automations/$automationId': typeof AppmainAutomationsAutomationIdRoute
  '/outreaches/$callout-id': typeof AppmainOutreachesCalloutIdRoute
  '/routines/$routineId': typeof AppmainRoutinesRoutineIdRoute
  '/shifts/$shift-id': typeof AppmainShiftsShiftIdRoute
  '/surveys/$survey-id': typeof AppmainSurveysSurveyIdRoute
  '/surveys/create': typeof AppmainSurveysCreateRoute
  '/training/announcement': typeof AppmainTrainingAnnouncementRoute
  '/training/client-onboarding': typeof AppmainTrainingClientOnboardingRoute
  '/training/demo': typeof AppmainTrainingDemoRoute
  '/training/onboarding': typeof AppmainTrainingOnboardingRoute
  '/admin/accounts/$accountId': typeof AppAdminAccountsAccountIdRoute
  '/admin/agent-notes/$note-id': typeof AppAdminAgentNotesNoteIdRoute
  '/admin/agent-traces/$conversationId': typeof AppAdminAgentTracesConversationIdRoute
  '/admin/agent-traces/caregiver': typeof AppAdminAgentTracesCaregiverRoute
  '/admin/agent-traces/client': typeof AppAdminAgentTracesClientRoute
  '/admin/agent-traces/continual': typeof AppAdminAgentTracesContinualRoute
  '/admin/agent-traces/ephemeral': typeof AppAdminAgentTracesEphemeralRoute
  '/admin/agent-traces/prompts': typeof AppAdminAgentTracesPromptsRoute
  '/admin/agent/connections': typeof AppAdminAgentConnectionsRoute
  '/admin/agent/skills': typeof AppAdminAgentSkillsRoute
  '/admin/agent/v3-automations': typeof AppAdminAgentV3AutomationsRoute
  '/admin/agent/virtualization': typeof AppAdminAgentVirtualizationRoute
  '/admin/calls/$callId': typeof AppAdminCallsCallIdRoute
  '/admin/care-coordinators/$care-coordinator-id': typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  '/admin/caregivers/$caregiver-id': typeof AppAdminCaregiversCaregiverIdRoute
  '/admin/clients/$client-id': typeof AppAdminClientsClientIdRoute
  '/admin/organizations/$organization-id': typeof AppAdminOrganizationsOrganizationIdRoute
  '/admin/revenue/$account-id': typeof AppAdminRevenueAccountIdRoute
  '/admin/revenue/accounts': typeof AppAdminRevenueAccountsRoute
  '/admin/sales/agreements': typeof AppAdminSalesAgreementsRoute
  '/admin/sandbox/$organizationId': typeof AppAdminSandboxOrganizationIdRoute
  '/admin/shifts/$shift-id': typeof AppAdminShiftsShiftIdRoute
  '/admin/users/$user-id': typeof AppAdminUsersUserIdRoute
  '/admin/v3-agent/$runId': typeof AppAdminV3AgentRunIdRoute
  '/admin/v3-agent/automations': typeof AppAdminV3AgentAutomationsRoute
  '/admin/v3-agent/new': typeof AppAdminV3AgentNewRoute
  '/admin/v3-agent/skills': typeof AppAdminV3AgentSkillsRoute
  '/admin/voice-config/$organization-id': typeof AppAdminVoiceConfigOrganizationIdRoute
  '/admin/voice-evals/cases': typeof AppAdminVoiceEvalsCasesRoute
  '/admin/voice-evals/catalog': typeof AppAdminVoiceEvalsCatalogRoute
  '/admin/voice-evals/compare': typeof AppAdminVoiceEvalsCompareRoute
  '/admin/voice-evals/compare-case': typeof AppAdminVoiceEvalsCompareCaseRoute
  '/admin/voice-playground/$call-id': typeof AppAdminVoicePlaygroundCallIdRoute
  '/admin/voice-qa/$callId': typeof AppAdminVoiceQaCallIdRoute
  '/admin/voice-qa/shadow-comparison': typeof AppAdminVoiceQaShadowComparisonRoute
  '/admin/voip/$organization-id': typeof AppAdminVoipOrganizationIdRoute
  '/settings/notifications/$channel': typeof AppSettingsNotificationsChannelRoute
  '/settings/team-members/bulk': typeof AppSettingsTeamMembersBulkRoute
  '/settings/team-members/defaults': typeof AppSettingsTeamMembersDefaultsRoute
  '/agent': typeof AppagentAgentIndexRoute
  '/automations': typeof AppmainAutomationsIndexRoute
  '/calendar': typeof AppmainCalendarIndexRoute
  '/conversations': typeof AppmainConversationsIndexRoute
  '/outreaches': typeof AppmainOutreachesIndexRoute
  '/routines': typeof AppmainRoutinesIndexRoute
  '/scheduled': typeof AppmainScheduledIndexRoute
  '/shifts': typeof AppmainShiftsIndexRoute
  '/surveys': typeof AppmainSurveysIndexRoute
  '/training': typeof AppmainTrainingIndexRoute
  '/admin/access-tokens': typeof AppAdminAccessTokensIndexRoute
  '/admin/accounts': typeof AppAdminAccountsIndexRoute
  '/admin/agent-notes': typeof AppAdminAgentNotesIndexRoute
  '/admin/agent-traces': typeof AppAdminAgentTracesIndexRoute
  '/admin/auto-callout-board': typeof AppAdminAutoCalloutBoardIndexRoute
  '/admin/automations': typeof AppAdminAutomationsIndexRoute
  '/admin/calls': typeof AppAdminCallsIndexRoute
  '/admin/care-coordinators': typeof AppAdminCareCoordinatorsIndexRoute
  '/admin/caregivers': typeof AppAdminCaregiversIndexRoute
  '/admin/clients': typeof AppAdminClientsIndexRoute
  '/admin/extension-lab': typeof AppAdminExtensionLabIndexRoute
  '/admin/franchises': typeof AppAdminFranchisesIndexRoute
  '/admin/org-distributions': typeof AppAdminOrgDistributionsIndexRoute
  '/admin/organization-attributes': typeof AppAdminOrganizationAttributesIndexRoute
  '/admin/organizations': typeof AppAdminOrganizationsIndexRoute
  '/admin/outbox': typeof AppAdminOutboxIndexRoute
  '/admin/recommendation-explorer': typeof AppAdminRecommendationExplorerIndexRoute
  '/admin/revenue': typeof AppAdminRevenueIndexRoute
  '/admin/sandbox': typeof AppAdminSandboxIndexRoute
  '/admin/shifts': typeof AppAdminShiftsIndexRoute
  '/admin/users': typeof AppAdminUsersIndexRoute
  '/admin/v3-agent': typeof AppAdminV3AgentIndexRoute
  '/admin/voice-config': typeof AppAdminVoiceConfigIndexRoute
  '/admin/voice-evals': typeof AppAdminVoiceEvalsIndexRoute
  '/admin/voice-playground': typeof AppAdminVoicePlaygroundIndexRoute
  '/admin/voice-qa': typeof AppAdminVoiceQaIndexRoute
  '/admin/voip': typeof AppAdminVoipIndexRoute
  '/settings/notifications': typeof AppSettingsNotificationsIndexRoute
  '/agent/runs/$runId': typeof AppagentAgentRunsRunIdRoute
  '/outreaches/message/$message-id': typeof AppmainOutreachesMessageMessageIdRoute
  '/outreaches/message/create': typeof AppmainOutreachesMessageCreateRoute
  '/outreaches/survey/$survey-id': typeof AppmainOutreachesSurveySurveyIdRoute
  '/outreaches/survey/create': typeof AppmainOutreachesSurveyCreateRoute
  '/admin/agent-traces/run/$runId': typeof AppAdminAgentTracesRunRunIdRoute
  '/admin/agent/$runId': typeof AppAdminAgentChatRunIdRoute
  '/admin/agent/new': typeof AppAdminAgentChatNewRoute
  '/admin/agent/actions/$audit-id': typeof AppAdminAgentActionsAuditIdRoute
  '/admin/agent/automations/list': typeof AppAdminAgentAutomationsListRoute
  '/admin/agent/automations/runs': typeof AppAdminAgentAutomationsRunsRoute
  '/admin/agent/pages/$slug': typeof AppAdminAgentPagesSlugRoute
  '/admin/agent/scratchpad/$note-id': typeof AppAdminAgentScratchpadNoteIdRoute
  '/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId': typeof AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute
  '/admin/ehr-contracts/{-$vendor}/{-$endpoint}': typeof AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route
  '/admin/organization-attributes/$tab/{-$organizationId}': typeof AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route
  '/admin/v3-agent/scratchpad/$note-id': typeof AppAdminV3AgentScratchpadNoteIdRoute
  '/admin/agent': typeof AppAdminAgentChatIndexRoute
  '/admin/agent/actions': typeof AppAdminAgentActionsIndexRoute
  '/admin/agent/automations': typeof AppAdminAgentAutomationsIndexRoute
  '/admin/agent/judge': typeof AppAdminAgentJudgeIndexRoute
  '/admin/agent/pages': typeof AppAdminAgentPagesIndexRoute
  '/admin/agent/scratchpad': typeof AppAdminAgentScratchpadIndexRoute
  '/admin/v3-agent/judge': typeof AppAdminV3AgentJudgeIndexRoute
  '/admin/v3-agent/scratchpad': typeof AppAdminV3AgentScratchpadIndexRoute
  '/settings/team-members/$memberUserId': typeof AppSettingsTeamMembersMemberUserIdIndexRoute
  '/extension-review/calendar/php/unassigned': typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
  '/admin/agent/automations/groups/$automationGroupId': typeof AppAdminAgentAutomationsGroupsAutomationGroupIdRoute
  '/admin/agent/judge/trace/$runId': typeof AppAdminAgentJudgeTraceRunIdRoute
  '/admin/v3-agent/judge/trace/$runId': typeof AppAdminV3AgentJudgeTraceRunIdRoute
  '/settings/team-members/$memberUserId/notifications/$channel': typeof AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute
  '/admin/automations/$organizationId/$automationId': typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/voice-evals/runs/$runId': typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  '/settings/team-members/$memberUserId/notifications': typeof AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute
  '/admin/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
  '/admin/extension-lab/ehr/$provider/$entity/$externalId': typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
  '/admin/voice-evals/runs/$runId/cases/$caseResultId': typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
  '/admin/agent/automations/$organizationId/$automationId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteRouteWithChildren
  '/_auth': typeof AuthRouteRouteWithChildren
  '/phoebe-thinking-tips-mockup': typeof PhoebeThinkingTipsMockupRoute
  '/teach-phoebe-feedback-tags-mockup': typeof TeachPhoebeFeedbackTagsMockupRoute
  '/_app/(agent)': typeof AppagentRouteRouteWithChildren
  '/_app/(extension)': typeof AppextensionRouteRouteWithChildren
  '/_app/(main)': typeof AppmainRouteRouteWithChildren
  '/_app/admin': typeof AppAdminRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/$organization-id/demo': typeof OrganizationIdDemoRoute
  '/_auth/accept-invitation': typeof AuthAcceptInvitationRoute
  '/_auth/change-password': typeof AuthChangePasswordRoute
  '/_auth/error': typeof AuthErrorRoute
  '/_auth/intro-call-booked': typeof AuthIntroCallBookedRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/sign-in': typeof AuthSignInRoute
  '/_auth/sign-out': typeof AuthSignOutRoute
  '/_auth/sign-up': typeof AuthSignUpRoute
  '/chrome-extension/privacy': typeof ChromeExtensionPrivacyRoute
  '/outreaches/phoebe-thinking-tips-mockup': typeof OutreachesPhoebeThinkingTipsMockupRoute
  '/r/$code': typeof RCodeRoute
  '/simulator-world/display': typeof SimulatorWorldDisplayRoute
  '/slack-agent-v3/link': typeof SlackAgentV3LinkRoute
  '/_app/(extension)/extension': typeof AppextensionExtensionRouteRoute
  '/_app/(extension)/extension-local': typeof AppextensionExtensionLocalRouteRoute
  '/_app/admin/extension-lab': typeof AppAdminExtensionLabRouteRouteWithChildren
  '/_app/admin/v3-agent': typeof AppAdminV3AgentRouteRouteWithChildren
  '/_app/settings/notifications': typeof AppSettingsNotificationsRouteRouteWithChildren
  '/_app/(agent)/agent': typeof AppagentAgentRouteWithChildren
  '/_app/(main)/activity': typeof AppmainActivityRoute
  '/_app/(main)/activity-board': typeof AppmainActivityBoardRoute
  '/_app/(main)/authorizations': typeof AppmainAuthorizationsRoute
  '/_app/(main)/callouts': typeof AppmainCalloutsRoute
  '/_app/(main)/caregivers': typeof AppmainCaregiversRoute
  '/_app/(main)/clients': typeof AppmainClientsRoute
  '/_app/(main)/coverage': typeof AppmainCoverageRoute
  '/_app/(main)/dry-run-report': typeof AppmainDryRunReportRoute
  '/_app/(main)/financials': typeof AppmainFinancialsRoute
  '/_app/(main)/home': typeof AppmainHomeRoute
  '/_app/(main)/leaderboard': typeof AppmainLeaderboardRoute
  '/_app/(main)/learn-phoebe': typeof AppmainLearnPhoebeRoute
  '/_app/(main)/metrics': typeof AppmainMetricsRoute
  '/_app/(main)/phone': typeof AppmainPhoneRoute
  '/_app/(main)/playbooks': typeof AppmainPlaybooksRoute
  '/_app/(main)/referrals': typeof AppmainReferralsRoute
  '/_app/(main)/teach-phoebe': typeof AppmainTeachPhoebeRoute
  '/_app/(main)/training': typeof AppmainTrainingRouteWithChildren
  '/_app/(main)/voice-calls': typeof AppmainVoiceCallsRoute
  '/_app/admin/agent-tools': typeof AppAdminAgentToolsRoute
  '/_app/admin/amd-live': typeof AppAdminAmdLiveRoute
  '/_app/admin/care-plan-previewer': typeof AppAdminCarePlanPreviewerRoute
  '/_app/admin/dashboard-usage': typeof AppAdminDashboardUsageRoute
  '/_app/admin/data-quality': typeof AppAdminDataQualityRoute
  '/_app/admin/data-sync': typeof AppAdminDataSyncRoute
  '/_app/admin/demo-org': typeof AppAdminDemoOrgRoute
  '/_app/admin/design-kit': typeof AppAdminDesignKitRoute
  '/_app/admin/document-ingestion': typeof AppAdminDocumentIngestionRoute
  '/_app/admin/flags': typeof AppAdminFlagsRoute
  '/_app/admin/imessage': typeof AppAdminImessageRoute
  '/_app/admin/llm-spend': typeof AppAdminLlmSpendRoute
  '/_app/admin/message-queue': typeof AppAdminMessageQueueRoute
  '/_app/admin/notifications-lab': typeof AppAdminNotificationsLabRoute
  '/_app/admin/org-snapshots': typeof AppAdminOrgSnapshotsRoute
  '/_app/admin/organization-default-settings': typeof AppAdminOrganizationDefaultSettingsRoute
  '/_app/admin/outreach-observability': typeof AppAdminOutreachObservabilityRoute
  '/_app/admin/outreaches': typeof AppAdminOutreachesRoute
  '/_app/admin/prompt-rollout': typeof AppAdminPromptRolloutRoute
  '/_app/admin/quality-scoreboard': typeof AppAdminQualityScoreboardRoute
  '/_app/admin/report-generator': typeof AppAdminReportGeneratorRoute
  '/_app/admin/search': typeof AppAdminSearchRoute
  '/_app/admin/shift-assignment-health': typeof AppAdminShiftAssignmentHealthRoute
  '/_app/admin/simulator-world': typeof AppAdminSimulatorWorldRoute
  '/_app/admin/sync-settings': typeof AppAdminSyncSettingsRoute
  '/_app/admin/tag-matching': typeof AppAdminTagMatchingRoute
  '/_app/admin/tam-map': typeof AppAdminTamMapRoute
  '/_app/admin/ui-components': typeof AppAdminUiComponentsRoute
  '/_app/admin/v3-event-components': typeof AppAdminV3EventComponentsRoute
  '/_app/admin/voice': typeof AppAdminVoiceRoute
  '/_app/admin/voice-latency': typeof AppAdminVoiceLatencyRoute
  '/_app/admin/wbr': typeof AppAdminWbrRoute
  '/_app/internal/agreements': typeof AppInternalAgreementsRoute
  '/_app/settings/activity-feed': typeof AppSettingsActivityFeedRoute
  '/_app/settings/agency-context': typeof AppSettingsAgencyContextRoute
  '/_app/settings/agent-rules': typeof AppSettingsAgentRulesRoute
  '/_app/settings/auto-assign': typeof AppSettingsAutoAssignRoute
  '/_app/settings/auto-draft': typeof AppSettingsAutoDraftRoute
  '/_app/settings/auto-reply-settings': typeof AppSettingsAutoReplySettingsRoute
  '/_app/settings/auto-send': typeof AppSettingsAutoSendRoute
  '/_app/settings/automation-schedule': typeof AppSettingsAutomationScheduleRoute
  '/_app/settings/automations': typeof AppSettingsAutomationsRoute
  '/_app/settings/call-routing': typeof AppSettingsCallRoutingRoute
  '/_app/settings/call-templates': typeof AppSettingsCallTemplatesRoute
  '/_app/settings/cancellations': typeof AppSettingsCancellationsRoute
  '/_app/settings/care-coordinators': typeof AppSettingsCareCoordinatorsRoute
  '/_app/settings/caregiver-engagement': typeof AppSettingsCaregiverEngagementRoute
  '/_app/settings/caregiver-tags': typeof AppSettingsCaregiverTagsRoute
  '/_app/settings/change-history': typeof AppSettingsChangeHistoryRoute
  '/_app/settings/chrome-extension': typeof AppSettingsChromeExtensionRoute
  '/_app/settings/client-communication': typeof AppSettingsClientCommunicationRoute
  '/_app/settings/clock-in-out': typeof AppSettingsClockInOutRoute
  '/_app/settings/clock-in-templates': typeof AppSettingsClockInTemplatesRoute
  '/_app/settings/configurations': typeof AppSettingsConfigurationsRoute
  '/_app/settings/confirmation-messages': typeof AppSettingsConfirmationMessagesRoute
  '/_app/settings/daily-digest': typeof AppSettingsDailyDigestRoute
  '/_app/settings/data-sync': typeof AppSettingsDataSyncRoute
  '/_app/settings/early-access': typeof AppSettingsEarlyAccessRoute
  '/_app/settings/help-center': typeof AppSettingsHelpCenterRoute
  '/_app/settings/off-hours': typeof AppSettingsOffHoursRoute
  '/_app/settings/offices': typeof AppSettingsOfficesRoute
  '/_app/settings/open-shift-responses': typeof AppSettingsOpenShiftResponsesRoute
  '/_app/settings/other-templates': typeof AppSettingsOtherTemplatesRoute
  '/_app/settings/outreach-automation': typeof AppSettingsOutreachAutomationRoute
  '/_app/settings/outreach-templates': typeof AppSettingsOutreachTemplatesRoute
  '/_app/settings/phoebe': typeof AppSettingsPhoebeRoute
  '/_app/settings/phone': typeof AppSettingsPhoneRoute
  '/_app/settings/phone-instructions': typeof AppSettingsPhoneInstructionsRoute
  '/_app/settings/phone-numbers': typeof AppSettingsPhoneNumbersRoute
  '/_app/settings/phone-try': typeof AppSettingsPhoneTryRoute
  '/_app/settings/pronunciations': typeof AppSettingsPronunciationsRoute
  '/_app/settings/quiet-hours': typeof AppSettingsQuietHoursRoute
  '/_app/settings/recommendations': typeof AppSettingsRecommendationsRoute
  '/_app/settings/shift-confirmation-skip-allow-lists': typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  '/_app/settings/shift-confirmations': typeof AppSettingsShiftConfirmationsRoute
  '/_app/settings/skip-allow-lists': typeof AppSettingsSkipAllowListsRoute
  '/_app/settings/slack': typeof AppSettingsSlackRoute
  '/_app/settings/tag-matching': typeof AppSettingsTagMatchingRoute
  '/_app/settings/tags': typeof AppSettingsTagsRoute
  '/_app/settings/team-coverage': typeof AppSettingsTeamCoverageRoute
  '/_app/settings/team-members': typeof AppSettingsTeamMembersRoute
  '/_app/settings/teams': typeof AppSettingsTeamsRoute
  '/_app/slack/link': typeof AppSlackLinkRoute
  '/_app/(main)/': typeof AppmainIndexRoute
  '/_app/admin/': typeof AppAdminIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/admin/agent/_chat': typeof AppAdminAgentChatRouteRouteWithChildren
  '/_app/admin/agent/judge': typeof AppAdminAgentJudgeRouteRouteWithChildren
  '/_app/admin/v3-agent/judge': typeof AppAdminV3AgentJudgeRouteRouteWithChildren
  '/_app/(main)/automations/$automationId': typeof AppmainAutomationsAutomationIdRoute
  '/_app/(main)/outreaches/$callout-id': typeof AppmainOutreachesCalloutIdRoute
  '/_app/(main)/routines/$routineId': typeof AppmainRoutinesRoutineIdRoute
  '/_app/(main)/shifts/$shift-id': typeof AppmainShiftsShiftIdRoute
  '/_app/(main)/surveys/$survey-id': typeof AppmainSurveysSurveyIdRoute
  '/_app/(main)/surveys/create': typeof AppmainSurveysCreateRoute
  '/_app/(main)/training/announcement': typeof AppmainTrainingAnnouncementRoute
  '/_app/(main)/training/client-onboarding': typeof AppmainTrainingClientOnboardingRoute
  '/_app/(main)/training/demo': typeof AppmainTrainingDemoRoute
  '/_app/(main)/training/onboarding': typeof AppmainTrainingOnboardingRoute
  '/_app/admin/accounts/$accountId': typeof AppAdminAccountsAccountIdRoute
  '/_app/admin/agent-notes/$note-id': typeof AppAdminAgentNotesNoteIdRoute
  '/_app/admin/agent-traces/$conversationId': typeof AppAdminAgentTracesConversationIdRoute
  '/_app/admin/agent-traces/caregiver': typeof AppAdminAgentTracesCaregiverRoute
  '/_app/admin/agent-traces/client': typeof AppAdminAgentTracesClientRoute
  '/_app/admin/agent-traces/continual': typeof AppAdminAgentTracesContinualRoute
  '/_app/admin/agent-traces/ephemeral': typeof AppAdminAgentTracesEphemeralRoute
  '/_app/admin/agent-traces/prompts': typeof AppAdminAgentTracesPromptsRoute
  '/_app/admin/agent/connections': typeof AppAdminAgentConnectionsRoute
  '/_app/admin/agent/skills': typeof AppAdminAgentSkillsRoute
  '/_app/admin/agent/v3-automations': typeof AppAdminAgentV3AutomationsRoute
  '/_app/admin/agent/virtualization': typeof AppAdminAgentVirtualizationRoute
  '/_app/admin/calls/$callId': typeof AppAdminCallsCallIdRoute
  '/_app/admin/care-coordinators/$care-coordinator-id': typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  '/_app/admin/caregivers/$caregiver-id': typeof AppAdminCaregiversCaregiverIdRoute
  '/_app/admin/clients/$client-id': typeof AppAdminClientsClientIdRoute
  '/_app/admin/organizations/$organization-id': typeof AppAdminOrganizationsOrganizationIdRoute
  '/_app/admin/revenue/$account-id': typeof AppAdminRevenueAccountIdRoute
  '/_app/admin/revenue/accounts': typeof AppAdminRevenueAccountsRoute
  '/_app/admin/sales/agreements': typeof AppAdminSalesAgreementsRoute
  '/_app/admin/sandbox/$organizationId': typeof AppAdminSandboxOrganizationIdRoute
  '/_app/admin/shifts/$shift-id': typeof AppAdminShiftsShiftIdRoute
  '/_app/admin/users/$user-id': typeof AppAdminUsersUserIdRoute
  '/_app/admin/v3-agent/$runId': typeof AppAdminV3AgentRunIdRoute
  '/_app/admin/v3-agent/automations': typeof AppAdminV3AgentAutomationsRoute
  '/_app/admin/v3-agent/new': typeof AppAdminV3AgentNewRoute
  '/_app/admin/v3-agent/skills': typeof AppAdminV3AgentSkillsRoute
  '/_app/admin/voice-config/$organization-id': typeof AppAdminVoiceConfigOrganizationIdRoute
  '/_app/admin/voice-evals/cases': typeof AppAdminVoiceEvalsCasesRoute
  '/_app/admin/voice-evals/catalog': typeof AppAdminVoiceEvalsCatalogRoute
  '/_app/admin/voice-evals/compare': typeof AppAdminVoiceEvalsCompareRoute
  '/_app/admin/voice-evals/compare-case': typeof AppAdminVoiceEvalsCompareCaseRoute
  '/_app/admin/voice-playground/$call-id': typeof AppAdminVoicePlaygroundCallIdRoute
  '/_app/admin/voice-qa/$callId': typeof AppAdminVoiceQaCallIdRoute
  '/_app/admin/voice-qa/shadow-comparison': typeof AppAdminVoiceQaShadowComparisonRoute
  '/_app/admin/voip/$organization-id': typeof AppAdminVoipOrganizationIdRoute
  '/_app/settings/notifications/$channel': typeof AppSettingsNotificationsChannelRoute
  '/_app/settings/team-members_/$memberUserId': typeof AppSettingsTeamMembersMemberUserIdRouteWithChildren
  '/_app/settings/team-members_/bulk': typeof AppSettingsTeamMembersBulkRoute
  '/_app/settings/team-members_/defaults': typeof AppSettingsTeamMembersDefaultsRoute
  '/_app/(agent)/agent/': typeof AppagentAgentIndexRoute
  '/_app/(main)/automations/': typeof AppmainAutomationsIndexRoute
  '/_app/(main)/calendar/': typeof AppmainCalendarIndexRoute
  '/_app/(main)/conversations/': typeof AppmainConversationsIndexRoute
  '/_app/(main)/outreaches/': typeof AppmainOutreachesIndexRoute
  '/_app/(main)/routines/': typeof AppmainRoutinesIndexRoute
  '/_app/(main)/scheduled/': typeof AppmainScheduledIndexRoute
  '/_app/(main)/shifts/': typeof AppmainShiftsIndexRoute
  '/_app/(main)/surveys/': typeof AppmainSurveysIndexRoute
  '/_app/(main)/training/': typeof AppmainTrainingIndexRoute
  '/_app/admin/access-tokens/': typeof AppAdminAccessTokensIndexRoute
  '/_app/admin/accounts/': typeof AppAdminAccountsIndexRoute
  '/_app/admin/agent-notes/': typeof AppAdminAgentNotesIndexRoute
  '/_app/admin/agent-traces/': typeof AppAdminAgentTracesIndexRoute
  '/_app/admin/auto-callout-board/': typeof AppAdminAutoCalloutBoardIndexRoute
  '/_app/admin/automations/': typeof AppAdminAutomationsIndexRoute
  '/_app/admin/calls/': typeof AppAdminCallsIndexRoute
  '/_app/admin/care-coordinators/': typeof AppAdminCareCoordinatorsIndexRoute
  '/_app/admin/caregivers/': typeof AppAdminCaregiversIndexRoute
  '/_app/admin/clients/': typeof AppAdminClientsIndexRoute
  '/_app/admin/extension-lab/': typeof AppAdminExtensionLabIndexRoute
  '/_app/admin/franchises/': typeof AppAdminFranchisesIndexRoute
  '/_app/admin/org-distributions/': typeof AppAdminOrgDistributionsIndexRoute
  '/_app/admin/organization-attributes/': typeof AppAdminOrganizationAttributesIndexRoute
  '/_app/admin/organizations/': typeof AppAdminOrganizationsIndexRoute
  '/_app/admin/outbox/': typeof AppAdminOutboxIndexRoute
  '/_app/admin/recommendation-explorer/': typeof AppAdminRecommendationExplorerIndexRoute
  '/_app/admin/revenue/': typeof AppAdminRevenueIndexRoute
  '/_app/admin/sandbox/': typeof AppAdminSandboxIndexRoute
  '/_app/admin/shifts/': typeof AppAdminShiftsIndexRoute
  '/_app/admin/users/': typeof AppAdminUsersIndexRoute
  '/_app/admin/v3-agent/': typeof AppAdminV3AgentIndexRoute
  '/_app/admin/voice-config/': typeof AppAdminVoiceConfigIndexRoute
  '/_app/admin/voice-evals/': typeof AppAdminVoiceEvalsIndexRoute
  '/_app/admin/voice-playground/': typeof AppAdminVoicePlaygroundIndexRoute
  '/_app/admin/voice-qa/': typeof AppAdminVoiceQaIndexRoute
  '/_app/admin/voip/': typeof AppAdminVoipIndexRoute
  '/_app/settings/notifications/': typeof AppSettingsNotificationsIndexRoute
  '/_app/(agent)/agent/runs/$runId': typeof AppagentAgentRunsRunIdRoute
  '/_app/(main)/outreaches/message/$message-id': typeof AppmainOutreachesMessageMessageIdRoute
  '/_app/(main)/outreaches/message/create': typeof AppmainOutreachesMessageCreateRoute
  '/_app/(main)/outreaches/survey/$survey-id': typeof AppmainOutreachesSurveySurveyIdRoute
  '/_app/(main)/outreaches/survey/create': typeof AppmainOutreachesSurveyCreateRoute
  '/_app/admin/agent-traces/run/$runId': typeof AppAdminAgentTracesRunRunIdRoute
  '/_app/admin/agent/_chat/$runId': typeof AppAdminAgentChatRunIdRoute
  '/_app/admin/agent/_chat/new': typeof AppAdminAgentChatNewRoute
  '/_app/admin/agent/actions/$audit-id': typeof AppAdminAgentActionsAuditIdRoute
  '/_app/admin/agent/automations/list': typeof AppAdminAgentAutomationsListRoute
  '/_app/admin/agent/automations/runs': typeof AppAdminAgentAutomationsRunsRoute
  '/_app/admin/agent/pages/$slug': typeof AppAdminAgentPagesSlugRoute
  '/_app/admin/agent/scratchpad/$note-id': typeof AppAdminAgentScratchpadNoteIdRoute
  '/_app/admin/automations/$organizationId/$automationId': typeof AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId': typeof AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute
  '/_app/admin/ehr-contracts/{-$vendor}/{-$endpoint}': typeof AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route
  '/_app/admin/organization-attributes/$tab/{-$organizationId}': typeof AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route
  '/_app/admin/v3-agent/scratchpad/$note-id': typeof AppAdminV3AgentScratchpadNoteIdRoute
  '/_app/admin/agent/_chat/': typeof AppAdminAgentChatIndexRoute
  '/_app/admin/agent/actions/': typeof AppAdminAgentActionsIndexRoute
  '/_app/admin/agent/automations/': typeof AppAdminAgentAutomationsIndexRoute
  '/_app/admin/agent/judge/': typeof AppAdminAgentJudgeIndexRoute
  '/_app/admin/agent/pages/': typeof AppAdminAgentPagesIndexRoute
  '/_app/admin/agent/scratchpad/': typeof AppAdminAgentScratchpadIndexRoute
  '/_app/admin/v3-agent/judge/': typeof AppAdminV3AgentJudgeIndexRoute
  '/_app/admin/v3-agent/scratchpad/': typeof AppAdminV3AgentScratchpadIndexRoute
  '/_app/settings/team-members_/$memberUserId/': typeof AppSettingsTeamMembersMemberUserIdIndexRoute
  '/_app/(main)/extension-review/calendar/php/unassigned': typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
  '/_app/admin/agent/automations/$organizationId/$automationId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren
  '/_app/admin/agent/automations/groups/$automationGroupId': typeof AppAdminAgentAutomationsGroupsAutomationGroupIdRoute
  '/_app/admin/agent/judge/trace/$runId': typeof AppAdminAgentJudgeTraceRunIdRoute
  '/_app/admin/v3-agent/judge/trace/$runId': typeof AppAdminV3AgentJudgeTraceRunIdRoute
  '/_app/settings/team-members_/$memberUserId/notifications/$channel': typeof AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute
  '/_app/admin/automations/$organizationId/$automationId/': typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  '/_app/admin/voice-evals/runs/$runId/': typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  '/_app/settings/team-members_/$memberUserId/notifications/': typeof AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute
  '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
  '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId': typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
  '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId': typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
  '/_app/admin/agent/automations/$organizationId/$automationId/': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/phoebe-thinking-tips-mockup'
    | '/teach-phoebe-feedback-tags-mockup'
    | '/admin'
    | '/settings'
    | '/$organization-id/demo'
    | '/accept-invitation'
    | '/change-password'
    | '/error'
    | '/intro-call-booked'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/chrome-extension/privacy'
    | '/outreaches/phoebe-thinking-tips-mockup'
    | '/r/$code'
    | '/simulator-world/display'
    | '/slack-agent-v3/link'
    | '/extension'
    | '/extension-local'
    | '/admin/extension-lab'
    | '/admin/v3-agent'
    | '/settings/notifications'
    | '/agent'
    | '/activity'
    | '/activity-board'
    | '/authorizations'
    | '/callouts'
    | '/caregivers'
    | '/clients'
    | '/coverage'
    | '/dry-run-report'
    | '/financials'
    | '/home'
    | '/leaderboard'
    | '/learn-phoebe'
    | '/metrics'
    | '/phone'
    | '/playbooks'
    | '/referrals'
    | '/teach-phoebe'
    | '/training'
    | '/voice-calls'
    | '/admin/agent-tools'
    | '/admin/amd-live'
    | '/admin/care-plan-previewer'
    | '/admin/dashboard-usage'
    | '/admin/data-quality'
    | '/admin/data-sync'
    | '/admin/demo-org'
    | '/admin/design-kit'
    | '/admin/document-ingestion'
    | '/admin/flags'
    | '/admin/imessage'
    | '/admin/llm-spend'
    | '/admin/message-queue'
    | '/admin/notifications-lab'
    | '/admin/org-snapshots'
    | '/admin/organization-default-settings'
    | '/admin/outreach-observability'
    | '/admin/outreaches'
    | '/admin/prompt-rollout'
    | '/admin/quality-scoreboard'
    | '/admin/report-generator'
    | '/admin/search'
    | '/admin/shift-assignment-health'
    | '/admin/simulator-world'
    | '/admin/sync-settings'
    | '/admin/tag-matching'
    | '/admin/tam-map'
    | '/admin/ui-components'
    | '/admin/v3-event-components'
    | '/admin/voice'
    | '/admin/voice-latency'
    | '/admin/wbr'
    | '/internal/agreements'
    | '/settings/activity-feed'
    | '/settings/agency-context'
    | '/settings/agent-rules'
    | '/settings/auto-assign'
    | '/settings/auto-draft'
    | '/settings/auto-reply-settings'
    | '/settings/auto-send'
    | '/settings/automation-schedule'
    | '/settings/automations'
    | '/settings/call-routing'
    | '/settings/call-templates'
    | '/settings/cancellations'
    | '/settings/care-coordinators'
    | '/settings/caregiver-engagement'
    | '/settings/caregiver-tags'
    | '/settings/change-history'
    | '/settings/chrome-extension'
    | '/settings/client-communication'
    | '/settings/clock-in-out'
    | '/settings/clock-in-templates'
    | '/settings/configurations'
    | '/settings/confirmation-messages'
    | '/settings/daily-digest'
    | '/settings/data-sync'
    | '/settings/early-access'
    | '/settings/help-center'
    | '/settings/off-hours'
    | '/settings/offices'
    | '/settings/open-shift-responses'
    | '/settings/other-templates'
    | '/settings/outreach-automation'
    | '/settings/outreach-templates'
    | '/settings/phoebe'
    | '/settings/phone'
    | '/settings/phone-instructions'
    | '/settings/phone-numbers'
    | '/settings/phone-try'
    | '/settings/pronunciations'
    | '/settings/quiet-hours'
    | '/settings/recommendations'
    | '/settings/shift-confirmation-skip-allow-lists'
    | '/settings/shift-confirmations'
    | '/settings/skip-allow-lists'
    | '/settings/slack'
    | '/settings/tag-matching'
    | '/settings/tags'
    | '/settings/team-coverage'
    | '/settings/team-members'
    | '/settings/teams'
    | '/slack/link'
    | '/admin/'
    | '/settings/'
    | '/admin/agent'
    | '/admin/agent/judge'
    | '/admin/v3-agent/judge'
    | '/automations/$automationId'
    | '/outreaches/$callout-id'
    | '/routines/$routineId'
    | '/shifts/$shift-id'
    | '/surveys/$survey-id'
    | '/surveys/create'
    | '/training/announcement'
    | '/training/client-onboarding'
    | '/training/demo'
    | '/training/onboarding'
    | '/admin/accounts/$accountId'
    | '/admin/agent-notes/$note-id'
    | '/admin/agent-traces/$conversationId'
    | '/admin/agent-traces/caregiver'
    | '/admin/agent-traces/client'
    | '/admin/agent-traces/continual'
    | '/admin/agent-traces/ephemeral'
    | '/admin/agent-traces/prompts'
    | '/admin/agent/connections'
    | '/admin/agent/skills'
    | '/admin/agent/v3-automations'
    | '/admin/agent/virtualization'
    | '/admin/calls/$callId'
    | '/admin/care-coordinators/$care-coordinator-id'
    | '/admin/caregivers/$caregiver-id'
    | '/admin/clients/$client-id'
    | '/admin/organizations/$organization-id'
    | '/admin/revenue/$account-id'
    | '/admin/revenue/accounts'
    | '/admin/sales/agreements'
    | '/admin/sandbox/$organizationId'
    | '/admin/shifts/$shift-id'
    | '/admin/users/$user-id'
    | '/admin/v3-agent/$runId'
    | '/admin/v3-agent/automations'
    | '/admin/v3-agent/new'
    | '/admin/v3-agent/skills'
    | '/admin/voice-config/$organization-id'
    | '/admin/voice-evals/cases'
    | '/admin/voice-evals/catalog'
    | '/admin/voice-evals/compare'
    | '/admin/voice-evals/compare-case'
    | '/admin/voice-playground/$call-id'
    | '/admin/voice-qa/$callId'
    | '/admin/voice-qa/shadow-comparison'
    | '/admin/voip/$organization-id'
    | '/settings/notifications/$channel'
    | '/settings/team-members/$memberUserId'
    | '/settings/team-members/bulk'
    | '/settings/team-members/defaults'
    | '/agent/'
    | '/automations/'
    | '/calendar/'
    | '/conversations/'
    | '/outreaches/'
    | '/routines/'
    | '/scheduled/'
    | '/shifts/'
    | '/surveys/'
    | '/training/'
    | '/admin/access-tokens/'
    | '/admin/accounts/'
    | '/admin/agent-notes/'
    | '/admin/agent-traces/'
    | '/admin/auto-callout-board/'
    | '/admin/automations/'
    | '/admin/calls/'
    | '/admin/care-coordinators/'
    | '/admin/caregivers/'
    | '/admin/clients/'
    | '/admin/extension-lab/'
    | '/admin/franchises/'
    | '/admin/org-distributions/'
    | '/admin/organization-attributes/'
    | '/admin/organizations/'
    | '/admin/outbox/'
    | '/admin/recommendation-explorer/'
    | '/admin/revenue/'
    | '/admin/sandbox/'
    | '/admin/shifts/'
    | '/admin/users/'
    | '/admin/v3-agent/'
    | '/admin/voice-config/'
    | '/admin/voice-evals/'
    | '/admin/voice-playground/'
    | '/admin/voice-qa/'
    | '/admin/voip/'
    | '/settings/notifications/'
    | '/agent/runs/$runId'
    | '/outreaches/message/$message-id'
    | '/outreaches/message/create'
    | '/outreaches/survey/$survey-id'
    | '/outreaches/survey/create'
    | '/admin/agent-traces/run/$runId'
    | '/admin/agent/$runId'
    | '/admin/agent/new'
    | '/admin/agent/actions/$audit-id'
    | '/admin/agent/automations/list'
    | '/admin/agent/automations/runs'
    | '/admin/agent/pages/$slug'
    | '/admin/agent/scratchpad/$note-id'
    | '/admin/automations/$organizationId/$automationId'
    | '/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId'
    | '/admin/ehr-contracts/{-$vendor}/{-$endpoint}'
    | '/admin/organization-attributes/$tab/{-$organizationId}'
    | '/admin/v3-agent/scratchpad/$note-id'
    | '/admin/agent/'
    | '/admin/agent/actions/'
    | '/admin/agent/automations/'
    | '/admin/agent/judge/'
    | '/admin/agent/pages/'
    | '/admin/agent/scratchpad/'
    | '/admin/v3-agent/judge/'
    | '/admin/v3-agent/scratchpad/'
    | '/settings/team-members/$memberUserId/'
    | '/extension-review/calendar/php/unassigned'
    | '/admin/agent/automations/$organizationId/$automationId'
    | '/admin/agent/automations/groups/$automationGroupId'
    | '/admin/agent/judge/trace/$runId'
    | '/admin/v3-agent/judge/trace/$runId'
    | '/settings/team-members/$memberUserId/notifications/$channel'
    | '/admin/automations/$organizationId/$automationId/'
    | '/admin/voice-evals/runs/$runId/'
    | '/settings/team-members/$memberUserId/notifications/'
    | '/admin/automations/$organizationId/$automationId/runs/$automationRunId'
    | '/admin/extension-lab/ehr/$provider/$entity/$externalId'
    | '/admin/voice-evals/runs/$runId/cases/$caseResultId'
    | '/admin/agent/automations/$organizationId/$automationId/'
    | '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/phoebe-thinking-tips-mockup'
    | '/teach-phoebe-feedback-tags-mockup'
    | '/$organization-id/demo'
    | '/accept-invitation'
    | '/change-password'
    | '/error'
    | '/intro-call-booked'
    | '/reset-password'
    | '/sign-in'
    | '/sign-out'
    | '/sign-up'
    | '/chrome-extension/privacy'
    | '/outreaches/phoebe-thinking-tips-mockup'
    | '/r/$code'
    | '/simulator-world/display'
    | '/slack-agent-v3/link'
    | '/extension'
    | '/extension-local'
    | '/activity'
    | '/activity-board'
    | '/authorizations'
    | '/callouts'
    | '/caregivers'
    | '/clients'
    | '/coverage'
    | '/dry-run-report'
    | '/financials'
    | '/home'
    | '/leaderboard'
    | '/learn-phoebe'
    | '/metrics'
    | '/phone'
    | '/playbooks'
    | '/referrals'
    | '/teach-phoebe'
    | '/voice-calls'
    | '/admin/agent-tools'
    | '/admin/amd-live'
    | '/admin/care-plan-previewer'
    | '/admin/dashboard-usage'
    | '/admin/data-quality'
    | '/admin/data-sync'
    | '/admin/demo-org'
    | '/admin/design-kit'
    | '/admin/document-ingestion'
    | '/admin/flags'
    | '/admin/imessage'
    | '/admin/llm-spend'
    | '/admin/message-queue'
    | '/admin/notifications-lab'
    | '/admin/org-snapshots'
    | '/admin/organization-default-settings'
    | '/admin/outreach-observability'
    | '/admin/outreaches'
    | '/admin/prompt-rollout'
    | '/admin/quality-scoreboard'
    | '/admin/report-generator'
    | '/admin/search'
    | '/admin/shift-assignment-health'
    | '/admin/simulator-world'
    | '/admin/sync-settings'
    | '/admin/tag-matching'
    | '/admin/tam-map'
    | '/admin/ui-components'
    | '/admin/v3-event-components'
    | '/admin/voice'
    | '/admin/voice-latency'
    | '/admin/wbr'
    | '/internal/agreements'
    | '/settings/activity-feed'
    | '/settings/agency-context'
    | '/settings/agent-rules'
    | '/settings/auto-assign'
    | '/settings/auto-draft'
    | '/settings/auto-reply-settings'
    | '/settings/auto-send'
    | '/settings/automation-schedule'
    | '/settings/automations'
    | '/settings/call-routing'
    | '/settings/call-templates'
    | '/settings/cancellations'
    | '/settings/care-coordinators'
    | '/settings/caregiver-engagement'
    | '/settings/caregiver-tags'
    | '/settings/change-history'
    | '/settings/chrome-extension'
    | '/settings/client-communication'
    | '/settings/clock-in-out'
    | '/settings/clock-in-templates'
    | '/settings/configurations'
    | '/settings/confirmation-messages'
    | '/settings/daily-digest'
    | '/settings/data-sync'
    | '/settings/early-access'
    | '/settings/help-center'
    | '/settings/off-hours'
    | '/settings/offices'
    | '/settings/open-shift-responses'
    | '/settings/other-templates'
    | '/settings/outreach-automation'
    | '/settings/outreach-templates'
    | '/settings/phoebe'
    | '/settings/phone'
    | '/settings/phone-instructions'
    | '/settings/phone-numbers'
    | '/settings/phone-try'
    | '/settings/pronunciations'
    | '/settings/quiet-hours'
    | '/settings/recommendations'
    | '/settings/shift-confirmation-skip-allow-lists'
    | '/settings/shift-confirmations'
    | '/settings/skip-allow-lists'
    | '/settings/slack'
    | '/settings/tag-matching'
    | '/settings/tags'
    | '/settings/team-coverage'
    | '/settings/team-members'
    | '/settings/teams'
    | '/slack/link'
    | '/admin'
    | '/settings'
    | '/automations/$automationId'
    | '/outreaches/$callout-id'
    | '/routines/$routineId'
    | '/shifts/$shift-id'
    | '/surveys/$survey-id'
    | '/surveys/create'
    | '/training/announcement'
    | '/training/client-onboarding'
    | '/training/demo'
    | '/training/onboarding'
    | '/admin/accounts/$accountId'
    | '/admin/agent-notes/$note-id'
    | '/admin/agent-traces/$conversationId'
    | '/admin/agent-traces/caregiver'
    | '/admin/agent-traces/client'
    | '/admin/agent-traces/continual'
    | '/admin/agent-traces/ephemeral'
    | '/admin/agent-traces/prompts'
    | '/admin/agent/connections'
    | '/admin/agent/skills'
    | '/admin/agent/v3-automations'
    | '/admin/agent/virtualization'
    | '/admin/calls/$callId'
    | '/admin/care-coordinators/$care-coordinator-id'
    | '/admin/caregivers/$caregiver-id'
    | '/admin/clients/$client-id'
    | '/admin/organizations/$organization-id'
    | '/admin/revenue/$account-id'
    | '/admin/revenue/accounts'
    | '/admin/sales/agreements'
    | '/admin/sandbox/$organizationId'
    | '/admin/shifts/$shift-id'
    | '/admin/users/$user-id'
    | '/admin/v3-agent/$runId'
    | '/admin/v3-agent/automations'
    | '/admin/v3-agent/new'
    | '/admin/v3-agent/skills'
    | '/admin/voice-config/$organization-id'
    | '/admin/voice-evals/cases'
    | '/admin/voice-evals/catalog'
    | '/admin/voice-evals/compare'
    | '/admin/voice-evals/compare-case'
    | '/admin/voice-playground/$call-id'
    | '/admin/voice-qa/$callId'
    | '/admin/voice-qa/shadow-comparison'
    | '/admin/voip/$organization-id'
    | '/settings/notifications/$channel'
    | '/settings/team-members/bulk'
    | '/settings/team-members/defaults'
    | '/agent'
    | '/automations'
    | '/calendar'
    | '/conversations'
    | '/outreaches'
    | '/routines'
    | '/scheduled'
    | '/shifts'
    | '/surveys'
    | '/training'
    | '/admin/access-tokens'
    | '/admin/accounts'
    | '/admin/agent-notes'
    | '/admin/agent-traces'
    | '/admin/auto-callout-board'
    | '/admin/automations'
    | '/admin/calls'
    | '/admin/care-coordinators'
    | '/admin/caregivers'
    | '/admin/clients'
    | '/admin/extension-lab'
    | '/admin/franchises'
    | '/admin/org-distributions'
    | '/admin/organization-attributes'
    | '/admin/organizations'
    | '/admin/outbox'
    | '/admin/recommendation-explorer'
    | '/admin/revenue'
    | '/admin/sandbox'
    | '/admin/shifts'
    | '/admin/users'
    | '/admin/v3-agent'
    | '/admin/voice-config'
    | '/admin/voice-evals'
    | '/admin/voice-playground'
    | '/admin/voice-qa'
    | '/admin/voip'
    | '/settings/notifications'
    | '/agent/runs/$runId'
    | '/outreaches/message/$message-id'
    | '/outreaches/message/create'
    | '/outreaches/survey/$survey-id'
    | '/outreaches/survey/create'
    | '/admin/agent-traces/run/$runId'
    | '/admin/agent/$runId'
    | '/admin/agent/new'
    | '/admin/agent/actions/$audit-id'
    | '/admin/agent/automations/list'
    | '/admin/agent/automations/runs'
    | '/admin/agent/pages/$slug'
    | '/admin/agent/scratchpad/$note-id'
    | '/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId'
    | '/admin/ehr-contracts/{-$vendor}/{-$endpoint}'
    | '/admin/organization-attributes/$tab/{-$organizationId}'
    | '/admin/v3-agent/scratchpad/$note-id'
    | '/admin/agent'
    | '/admin/agent/actions'
    | '/admin/agent/automations'
    | '/admin/agent/judge'
    | '/admin/agent/pages'
    | '/admin/agent/scratchpad'
    | '/admin/v3-agent/judge'
    | '/admin/v3-agent/scratchpad'
    | '/settings/team-members/$memberUserId'
    | '/extension-review/calendar/php/unassigned'
    | '/admin/agent/automations/groups/$automationGroupId'
    | '/admin/agent/judge/trace/$runId'
    | '/admin/v3-agent/judge/trace/$runId'
    | '/settings/team-members/$memberUserId/notifications/$channel'
    | '/admin/automations/$organizationId/$automationId'
    | '/admin/voice-evals/runs/$runId'
    | '/settings/team-members/$memberUserId/notifications'
    | '/admin/automations/$organizationId/$automationId/runs/$automationRunId'
    | '/admin/extension-lab/ehr/$provider/$entity/$externalId'
    | '/admin/voice-evals/runs/$runId/cases/$caseResultId'
    | '/admin/agent/automations/$organizationId/$automationId'
    | '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
  id:
    | '__root__'
    | '/_app'
    | '/_auth'
    | '/phoebe-thinking-tips-mockup'
    | '/teach-phoebe-feedback-tags-mockup'
    | '/_app/(agent)'
    | '/_app/(extension)'
    | '/_app/(main)'
    | '/_app/admin'
    | '/_app/settings'
    | '/$organization-id/demo'
    | '/_auth/accept-invitation'
    | '/_auth/change-password'
    | '/_auth/error'
    | '/_auth/intro-call-booked'
    | '/_auth/reset-password'
    | '/_auth/sign-in'
    | '/_auth/sign-out'
    | '/_auth/sign-up'
    | '/chrome-extension/privacy'
    | '/outreaches/phoebe-thinking-tips-mockup'
    | '/r/$code'
    | '/simulator-world/display'
    | '/slack-agent-v3/link'
    | '/_app/(extension)/extension'
    | '/_app/(extension)/extension-local'
    | '/_app/admin/extension-lab'
    | '/_app/admin/v3-agent'
    | '/_app/settings/notifications'
    | '/_app/(agent)/agent'
    | '/_app/(main)/activity'
    | '/_app/(main)/activity-board'
    | '/_app/(main)/authorizations'
    | '/_app/(main)/callouts'
    | '/_app/(main)/caregivers'
    | '/_app/(main)/clients'
    | '/_app/(main)/coverage'
    | '/_app/(main)/dry-run-report'
    | '/_app/(main)/financials'
    | '/_app/(main)/home'
    | '/_app/(main)/leaderboard'
    | '/_app/(main)/learn-phoebe'
    | '/_app/(main)/metrics'
    | '/_app/(main)/phone'
    | '/_app/(main)/playbooks'
    | '/_app/(main)/referrals'
    | '/_app/(main)/teach-phoebe'
    | '/_app/(main)/training'
    | '/_app/(main)/voice-calls'
    | '/_app/admin/agent-tools'
    | '/_app/admin/amd-live'
    | '/_app/admin/care-plan-previewer'
    | '/_app/admin/dashboard-usage'
    | '/_app/admin/data-quality'
    | '/_app/admin/data-sync'
    | '/_app/admin/demo-org'
    | '/_app/admin/design-kit'
    | '/_app/admin/document-ingestion'
    | '/_app/admin/flags'
    | '/_app/admin/imessage'
    | '/_app/admin/llm-spend'
    | '/_app/admin/message-queue'
    | '/_app/admin/notifications-lab'
    | '/_app/admin/org-snapshots'
    | '/_app/admin/organization-default-settings'
    | '/_app/admin/outreach-observability'
    | '/_app/admin/outreaches'
    | '/_app/admin/prompt-rollout'
    | '/_app/admin/quality-scoreboard'
    | '/_app/admin/report-generator'
    | '/_app/admin/search'
    | '/_app/admin/shift-assignment-health'
    | '/_app/admin/simulator-world'
    | '/_app/admin/sync-settings'
    | '/_app/admin/tag-matching'
    | '/_app/admin/tam-map'
    | '/_app/admin/ui-components'
    | '/_app/admin/v3-event-components'
    | '/_app/admin/voice'
    | '/_app/admin/voice-latency'
    | '/_app/admin/wbr'
    | '/_app/internal/agreements'
    | '/_app/settings/activity-feed'
    | '/_app/settings/agency-context'
    | '/_app/settings/agent-rules'
    | '/_app/settings/auto-assign'
    | '/_app/settings/auto-draft'
    | '/_app/settings/auto-reply-settings'
    | '/_app/settings/auto-send'
    | '/_app/settings/automation-schedule'
    | '/_app/settings/automations'
    | '/_app/settings/call-routing'
    | '/_app/settings/call-templates'
    | '/_app/settings/cancellations'
    | '/_app/settings/care-coordinators'
    | '/_app/settings/caregiver-engagement'
    | '/_app/settings/caregiver-tags'
    | '/_app/settings/change-history'
    | '/_app/settings/chrome-extension'
    | '/_app/settings/client-communication'
    | '/_app/settings/clock-in-out'
    | '/_app/settings/clock-in-templates'
    | '/_app/settings/configurations'
    | '/_app/settings/confirmation-messages'
    | '/_app/settings/daily-digest'
    | '/_app/settings/data-sync'
    | '/_app/settings/early-access'
    | '/_app/settings/help-center'
    | '/_app/settings/off-hours'
    | '/_app/settings/offices'
    | '/_app/settings/open-shift-responses'
    | '/_app/settings/other-templates'
    | '/_app/settings/outreach-automation'
    | '/_app/settings/outreach-templates'
    | '/_app/settings/phoebe'
    | '/_app/settings/phone'
    | '/_app/settings/phone-instructions'
    | '/_app/settings/phone-numbers'
    | '/_app/settings/phone-try'
    | '/_app/settings/pronunciations'
    | '/_app/settings/quiet-hours'
    | '/_app/settings/recommendations'
    | '/_app/settings/shift-confirmation-skip-allow-lists'
    | '/_app/settings/shift-confirmations'
    | '/_app/settings/skip-allow-lists'
    | '/_app/settings/slack'
    | '/_app/settings/tag-matching'
    | '/_app/settings/tags'
    | '/_app/settings/team-coverage'
    | '/_app/settings/team-members'
    | '/_app/settings/teams'
    | '/_app/slack/link'
    | '/_app/(main)/'
    | '/_app/admin/'
    | '/_app/settings/'
    | '/_app/admin/agent/_chat'
    | '/_app/admin/agent/judge'
    | '/_app/admin/v3-agent/judge'
    | '/_app/(main)/automations/$automationId'
    | '/_app/(main)/outreaches/$callout-id'
    | '/_app/(main)/routines/$routineId'
    | '/_app/(main)/shifts/$shift-id'
    | '/_app/(main)/surveys/$survey-id'
    | '/_app/(main)/surveys/create'
    | '/_app/(main)/training/announcement'
    | '/_app/(main)/training/client-onboarding'
    | '/_app/(main)/training/demo'
    | '/_app/(main)/training/onboarding'
    | '/_app/admin/accounts/$accountId'
    | '/_app/admin/agent-notes/$note-id'
    | '/_app/admin/agent-traces/$conversationId'
    | '/_app/admin/agent-traces/caregiver'
    | '/_app/admin/agent-traces/client'
    | '/_app/admin/agent-traces/continual'
    | '/_app/admin/agent-traces/ephemeral'
    | '/_app/admin/agent-traces/prompts'
    | '/_app/admin/agent/connections'
    | '/_app/admin/agent/skills'
    | '/_app/admin/agent/v3-automations'
    | '/_app/admin/agent/virtualization'
    | '/_app/admin/calls/$callId'
    | '/_app/admin/care-coordinators/$care-coordinator-id'
    | '/_app/admin/caregivers/$caregiver-id'
    | '/_app/admin/clients/$client-id'
    | '/_app/admin/organizations/$organization-id'
    | '/_app/admin/revenue/$account-id'
    | '/_app/admin/revenue/accounts'
    | '/_app/admin/sales/agreements'
    | '/_app/admin/sandbox/$organizationId'
    | '/_app/admin/shifts/$shift-id'
    | '/_app/admin/users/$user-id'
    | '/_app/admin/v3-agent/$runId'
    | '/_app/admin/v3-agent/automations'
    | '/_app/admin/v3-agent/new'
    | '/_app/admin/v3-agent/skills'
    | '/_app/admin/voice-config/$organization-id'
    | '/_app/admin/voice-evals/cases'
    | '/_app/admin/voice-evals/catalog'
    | '/_app/admin/voice-evals/compare'
    | '/_app/admin/voice-evals/compare-case'
    | '/_app/admin/voice-playground/$call-id'
    | '/_app/admin/voice-qa/$callId'
    | '/_app/admin/voice-qa/shadow-comparison'
    | '/_app/admin/voip/$organization-id'
    | '/_app/settings/notifications/$channel'
    | '/_app/settings/team-members_/$memberUserId'
    | '/_app/settings/team-members_/bulk'
    | '/_app/settings/team-members_/defaults'
    | '/_app/(agent)/agent/'
    | '/_app/(main)/automations/'
    | '/_app/(main)/calendar/'
    | '/_app/(main)/conversations/'
    | '/_app/(main)/outreaches/'
    | '/_app/(main)/routines/'
    | '/_app/(main)/scheduled/'
    | '/_app/(main)/shifts/'
    | '/_app/(main)/surveys/'
    | '/_app/(main)/training/'
    | '/_app/admin/access-tokens/'
    | '/_app/admin/accounts/'
    | '/_app/admin/agent-notes/'
    | '/_app/admin/agent-traces/'
    | '/_app/admin/auto-callout-board/'
    | '/_app/admin/automations/'
    | '/_app/admin/calls/'
    | '/_app/admin/care-coordinators/'
    | '/_app/admin/caregivers/'
    | '/_app/admin/clients/'
    | '/_app/admin/extension-lab/'
    | '/_app/admin/franchises/'
    | '/_app/admin/org-distributions/'
    | '/_app/admin/organization-attributes/'
    | '/_app/admin/organizations/'
    | '/_app/admin/outbox/'
    | '/_app/admin/recommendation-explorer/'
    | '/_app/admin/revenue/'
    | '/_app/admin/sandbox/'
    | '/_app/admin/shifts/'
    | '/_app/admin/users/'
    | '/_app/admin/v3-agent/'
    | '/_app/admin/voice-config/'
    | '/_app/admin/voice-evals/'
    | '/_app/admin/voice-playground/'
    | '/_app/admin/voice-qa/'
    | '/_app/admin/voip/'
    | '/_app/settings/notifications/'
    | '/_app/(agent)/agent/runs/$runId'
    | '/_app/(main)/outreaches/message/$message-id'
    | '/_app/(main)/outreaches/message/create'
    | '/_app/(main)/outreaches/survey/$survey-id'
    | '/_app/(main)/outreaches/survey/create'
    | '/_app/admin/agent-traces/run/$runId'
    | '/_app/admin/agent/_chat/$runId'
    | '/_app/admin/agent/_chat/new'
    | '/_app/admin/agent/actions/$audit-id'
    | '/_app/admin/agent/automations/list'
    | '/_app/admin/agent/automations/runs'
    | '/_app/admin/agent/pages/$slug'
    | '/_app/admin/agent/scratchpad/$note-id'
    | '/_app/admin/automations/$organizationId/$automationId'
    | '/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId'
    | '/_app/admin/ehr-contracts/{-$vendor}/{-$endpoint}'
    | '/_app/admin/organization-attributes/$tab/{-$organizationId}'
    | '/_app/admin/v3-agent/scratchpad/$note-id'
    | '/_app/admin/agent/_chat/'
    | '/_app/admin/agent/actions/'
    | '/_app/admin/agent/automations/'
    | '/_app/admin/agent/judge/'
    | '/_app/admin/agent/pages/'
    | '/_app/admin/agent/scratchpad/'
    | '/_app/admin/v3-agent/judge/'
    | '/_app/admin/v3-agent/scratchpad/'
    | '/_app/settings/team-members_/$memberUserId/'
    | '/_app/(main)/extension-review/calendar/php/unassigned'
    | '/_app/admin/agent/automations/$organizationId/$automationId'
    | '/_app/admin/agent/automations/groups/$automationGroupId'
    | '/_app/admin/agent/judge/trace/$runId'
    | '/_app/admin/v3-agent/judge/trace/$runId'
    | '/_app/settings/team-members_/$memberUserId/notifications/$channel'
    | '/_app/admin/automations/$organizationId/$automationId/'
    | '/_app/admin/voice-evals/runs/$runId/'
    | '/_app/settings/team-members_/$memberUserId/notifications/'
    | '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId'
    | '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId'
    | '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId'
    | '/_app/admin/agent/automations/$organizationId/$automationId/'
    | '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  PhoebeThinkingTipsMockupRoute: typeof PhoebeThinkingTipsMockupRoute
  TeachPhoebeFeedbackTagsMockupRoute: typeof TeachPhoebeFeedbackTagsMockupRoute
  OrganizationIdDemoRoute: typeof OrganizationIdDemoRoute
  ChromeExtensionPrivacyRoute: typeof ChromeExtensionPrivacyRoute
  OutreachesPhoebeThinkingTipsMockupRoute: typeof OutreachesPhoebeThinkingTipsMockupRoute
  RCodeRoute: typeof RCodeRoute
  SimulatorWorldDisplayRoute: typeof SimulatorWorldDisplayRoute
  SlackAgentV3LinkRoute: typeof SlackAgentV3LinkRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/phoebe-thinking-tips-mockup': {
      id: '/phoebe-thinking-tips-mockup'
      path: '/phoebe-thinking-tips-mockup'
      fullPath: '/phoebe-thinking-tips-mockup'
      preLoaderRoute: typeof PhoebeThinkingTipsMockupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teach-phoebe-feedback-tags-mockup': {
      id: '/teach-phoebe-feedback-tags-mockup'
      path: '/teach-phoebe-feedback-tags-mockup'
      fullPath: '/teach-phoebe-feedback-tags-mockup'
      preLoaderRoute: typeof TeachPhoebeFeedbackTagsMockupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organization-id/demo': {
      id: '/$organization-id/demo'
      path: '/$organization-id/demo'
      fullPath: '/$organization-id/demo'
      preLoaderRoute: typeof OrganizationIdDemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/(agent)': {
      id: '/_app/(agent)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppagentRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(extension)': {
      id: '/_app/(extension)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppextensionRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(main)': {
      id: '/_app/(main)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppmainRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_auth/accept-invitation': {
      id: '/_auth/accept-invitation'
      path: '/accept-invitation'
      fullPath: '/accept-invitation'
      preLoaderRoute: typeof AuthAcceptInvitationRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/change-password': {
      id: '/_auth/change-password'
      path: '/change-password'
      fullPath: '/change-password'
      preLoaderRoute: typeof AuthChangePasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/error': {
      id: '/_auth/error'
      path: '/error'
      fullPath: '/error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/intro-call-booked': {
      id: '/_auth/intro-call-booked'
      path: '/intro-call-booked'
      fullPath: '/intro-call-booked'
      preLoaderRoute: typeof AuthIntroCallBookedRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-in': {
      id: '/_auth/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof AuthSignInRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-out': {
      id: '/_auth/sign-out'
      path: '/sign-out'
      fullPath: '/sign-out'
      preLoaderRoute: typeof AuthSignOutRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/_auth/sign-up': {
      id: '/_auth/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/chrome-extension/privacy': {
      id: '/chrome-extension/privacy'
      path: '/chrome-extension/privacy'
      fullPath: '/chrome-extension/privacy'
      preLoaderRoute: typeof ChromeExtensionPrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/outreaches/phoebe-thinking-tips-mockup': {
      id: '/outreaches/phoebe-thinking-tips-mockup'
      path: '/outreaches/phoebe-thinking-tips-mockup'
      fullPath: '/outreaches/phoebe-thinking-tips-mockup'
      preLoaderRoute: typeof OutreachesPhoebeThinkingTipsMockupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$code': {
      id: '/r/$code'
      path: '/r/$code'
      fullPath: '/r/$code'
      preLoaderRoute: typeof RCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/simulator-world/display': {
      id: '/simulator-world/display'
      path: '/simulator-world/display'
      fullPath: '/simulator-world/display'
      preLoaderRoute: typeof SimulatorWorldDisplayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/slack-agent-v3/link': {
      id: '/slack-agent-v3/link'
      path: '/slack-agent-v3/link'
      fullPath: '/slack-agent-v3/link'
      preLoaderRoute: typeof SlackAgentV3LinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/(agent)/agent': {
      id: '/_app/(agent)/agent'
      path: '/agent'
      fullPath: '/agent'
      preLoaderRoute: typeof AppagentAgentRouteImport
      parentRoute: typeof AppagentRouteRoute
    }
    '/_app/(extension)/extension': {
      id: '/_app/(extension)/extension'
      path: '/extension'
      fullPath: '/extension'
      preLoaderRoute: typeof AppextensionExtensionRouteRouteImport
      parentRoute: typeof AppextensionRouteRoute
    }
    '/_app/(extension)/extension-local': {
      id: '/_app/(extension)/extension-local'
      path: '/extension-local'
      fullPath: '/extension-local'
      preLoaderRoute: typeof AppextensionExtensionLocalRouteRouteImport
      parentRoute: typeof AppextensionRouteRoute
    }
    '/_app/(main)/': {
      id: '/_app/(main)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppmainIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/activity': {
      id: '/_app/(main)/activity'
      path: '/activity'
      fullPath: '/activity'
      preLoaderRoute: typeof AppmainActivityRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/activity-board': {
      id: '/_app/(main)/activity-board'
      path: '/activity-board'
      fullPath: '/activity-board'
      preLoaderRoute: typeof AppmainActivityBoardRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/authorizations': {
      id: '/_app/(main)/authorizations'
      path: '/authorizations'
      fullPath: '/authorizations'
      preLoaderRoute: typeof AppmainAuthorizationsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/callouts': {
      id: '/_app/(main)/callouts'
      path: '/callouts'
      fullPath: '/callouts'
      preLoaderRoute: typeof AppmainCalloutsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/caregivers': {
      id: '/_app/(main)/caregivers'
      path: '/caregivers'
      fullPath: '/caregivers'
      preLoaderRoute: typeof AppmainCaregiversRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/clients': {
      id: '/_app/(main)/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppmainClientsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/coverage': {
      id: '/_app/(main)/coverage'
      path: '/coverage'
      fullPath: '/coverage'
      preLoaderRoute: typeof AppmainCoverageRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/dry-run-report': {
      id: '/_app/(main)/dry-run-report'
      path: '/dry-run-report'
      fullPath: '/dry-run-report'
      preLoaderRoute: typeof AppmainDryRunReportRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/financials': {
      id: '/_app/(main)/financials'
      path: '/financials'
      fullPath: '/financials'
      preLoaderRoute: typeof AppmainFinancialsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/home': {
      id: '/_app/(main)/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AppmainHomeRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/leaderboard': {
      id: '/_app/(main)/leaderboard'
      path: '/leaderboard'
      fullPath: '/leaderboard'
      preLoaderRoute: typeof AppmainLeaderboardRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/learn-phoebe': {
      id: '/_app/(main)/learn-phoebe'
      path: '/learn-phoebe'
      fullPath: '/learn-phoebe'
      preLoaderRoute: typeof AppmainLearnPhoebeRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/metrics': {
      id: '/_app/(main)/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof AppmainMetricsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/phone': {
      id: '/_app/(main)/phone'
      path: '/phone'
      fullPath: '/phone'
      preLoaderRoute: typeof AppmainPhoneRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/playbooks': {
      id: '/_app/(main)/playbooks'
      path: '/playbooks'
      fullPath: '/playbooks'
      preLoaderRoute: typeof AppmainPlaybooksRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/referrals': {
      id: '/_app/(main)/referrals'
      path: '/referrals'
      fullPath: '/referrals'
      preLoaderRoute: typeof AppmainReferralsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/teach-phoebe': {
      id: '/_app/(main)/teach-phoebe'
      path: '/teach-phoebe'
      fullPath: '/teach-phoebe'
      preLoaderRoute: typeof AppmainTeachPhoebeRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/training': {
      id: '/_app/(main)/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AppmainTrainingRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/voice-calls': {
      id: '/_app/(main)/voice-calls'
      path: '/voice-calls'
      fullPath: '/voice-calls'
      preLoaderRoute: typeof AppmainVoiceCallsRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/admin/': {
      id: '/_app/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AppAdminIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-tools': {
      id: '/_app/admin/agent-tools'
      path: '/agent-tools'
      fullPath: '/admin/agent-tools'
      preLoaderRoute: typeof AppAdminAgentToolsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/amd-live': {
      id: '/_app/admin/amd-live'
      path: '/amd-live'
      fullPath: '/admin/amd-live'
      preLoaderRoute: typeof AppAdminAmdLiveRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/care-plan-previewer': {
      id: '/_app/admin/care-plan-previewer'
      path: '/care-plan-previewer'
      fullPath: '/admin/care-plan-previewer'
      preLoaderRoute: typeof AppAdminCarePlanPreviewerRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/dashboard-usage': {
      id: '/_app/admin/dashboard-usage'
      path: '/dashboard-usage'
      fullPath: '/admin/dashboard-usage'
      preLoaderRoute: typeof AppAdminDashboardUsageRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/data-quality': {
      id: '/_app/admin/data-quality'
      path: '/data-quality'
      fullPath: '/admin/data-quality'
      preLoaderRoute: typeof AppAdminDataQualityRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/data-sync': {
      id: '/_app/admin/data-sync'
      path: '/data-sync'
      fullPath: '/admin/data-sync'
      preLoaderRoute: typeof AppAdminDataSyncRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/demo-org': {
      id: '/_app/admin/demo-org'
      path: '/demo-org'
      fullPath: '/admin/demo-org'
      preLoaderRoute: typeof AppAdminDemoOrgRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/design-kit': {
      id: '/_app/admin/design-kit'
      path: '/design-kit'
      fullPath: '/admin/design-kit'
      preLoaderRoute: typeof AppAdminDesignKitRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/document-ingestion': {
      id: '/_app/admin/document-ingestion'
      path: '/document-ingestion'
      fullPath: '/admin/document-ingestion'
      preLoaderRoute: typeof AppAdminDocumentIngestionRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/extension-lab': {
      id: '/_app/admin/extension-lab'
      path: '/extension-lab'
      fullPath: '/admin/extension-lab'
      preLoaderRoute: typeof AppAdminExtensionLabRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/flags': {
      id: '/_app/admin/flags'
      path: '/flags'
      fullPath: '/admin/flags'
      preLoaderRoute: typeof AppAdminFlagsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/imessage': {
      id: '/_app/admin/imessage'
      path: '/imessage'
      fullPath: '/admin/imessage'
      preLoaderRoute: typeof AppAdminImessageRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/llm-spend': {
      id: '/_app/admin/llm-spend'
      path: '/llm-spend'
      fullPath: '/admin/llm-spend'
      preLoaderRoute: typeof AppAdminLlmSpendRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/message-queue': {
      id: '/_app/admin/message-queue'
      path: '/message-queue'
      fullPath: '/admin/message-queue'
      preLoaderRoute: typeof AppAdminMessageQueueRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/notifications-lab': {
      id: '/_app/admin/notifications-lab'
      path: '/notifications-lab'
      fullPath: '/admin/notifications-lab'
      preLoaderRoute: typeof AppAdminNotificationsLabRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/org-snapshots': {
      id: '/_app/admin/org-snapshots'
      path: '/org-snapshots'
      fullPath: '/admin/org-snapshots'
      preLoaderRoute: typeof AppAdminOrgSnapshotsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organization-default-settings': {
      id: '/_app/admin/organization-default-settings'
      path: '/organization-default-settings'
      fullPath: '/admin/organization-default-settings'
      preLoaderRoute: typeof AppAdminOrganizationDefaultSettingsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/outreach-observability': {
      id: '/_app/admin/outreach-observability'
      path: '/outreach-observability'
      fullPath: '/admin/outreach-observability'
      preLoaderRoute: typeof AppAdminOutreachObservabilityRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/outreaches': {
      id: '/_app/admin/outreaches'
      path: '/outreaches'
      fullPath: '/admin/outreaches'
      preLoaderRoute: typeof AppAdminOutreachesRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/prompt-rollout': {
      id: '/_app/admin/prompt-rollout'
      path: '/prompt-rollout'
      fullPath: '/admin/prompt-rollout'
      preLoaderRoute: typeof AppAdminPromptRolloutRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/quality-scoreboard': {
      id: '/_app/admin/quality-scoreboard'
      path: '/quality-scoreboard'
      fullPath: '/admin/quality-scoreboard'
      preLoaderRoute: typeof AppAdminQualityScoreboardRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/report-generator': {
      id: '/_app/admin/report-generator'
      path: '/report-generator'
      fullPath: '/admin/report-generator'
      preLoaderRoute: typeof AppAdminReportGeneratorRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/search': {
      id: '/_app/admin/search'
      path: '/search'
      fullPath: '/admin/search'
      preLoaderRoute: typeof AppAdminSearchRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/shift-assignment-health': {
      id: '/_app/admin/shift-assignment-health'
      path: '/shift-assignment-health'
      fullPath: '/admin/shift-assignment-health'
      preLoaderRoute: typeof AppAdminShiftAssignmentHealthRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/simulator-world': {
      id: '/_app/admin/simulator-world'
      path: '/simulator-world'
      fullPath: '/admin/simulator-world'
      preLoaderRoute: typeof AppAdminSimulatorWorldRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sync-settings': {
      id: '/_app/admin/sync-settings'
      path: '/sync-settings'
      fullPath: '/admin/sync-settings'
      preLoaderRoute: typeof AppAdminSyncSettingsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/tag-matching': {
      id: '/_app/admin/tag-matching'
      path: '/tag-matching'
      fullPath: '/admin/tag-matching'
      preLoaderRoute: typeof AppAdminTagMatchingRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/tam-map': {
      id: '/_app/admin/tam-map'
      path: '/tam-map'
      fullPath: '/admin/tam-map'
      preLoaderRoute: typeof AppAdminTamMapRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/ui-components': {
      id: '/_app/admin/ui-components'
      path: '/ui-components'
      fullPath: '/admin/ui-components'
      preLoaderRoute: typeof AppAdminUiComponentsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/v3-agent': {
      id: '/_app/admin/v3-agent'
      path: '/v3-agent'
      fullPath: '/admin/v3-agent'
      preLoaderRoute: typeof AppAdminV3AgentRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/v3-event-components': {
      id: '/_app/admin/v3-event-components'
      path: '/v3-event-components'
      fullPath: '/admin/v3-event-components'
      preLoaderRoute: typeof AppAdminV3EventComponentsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice': {
      id: '/_app/admin/voice'
      path: '/voice'
      fullPath: '/admin/voice'
      preLoaderRoute: typeof AppAdminVoiceRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-latency': {
      id: '/_app/admin/voice-latency'
      path: '/voice-latency'
      fullPath: '/admin/voice-latency'
      preLoaderRoute: typeof AppAdminVoiceLatencyRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/wbr': {
      id: '/_app/admin/wbr'
      path: '/wbr'
      fullPath: '/admin/wbr'
      preLoaderRoute: typeof AppAdminWbrRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/internal/agreements': {
      id: '/_app/internal/agreements'
      path: '/internal/agreements'
      fullPath: '/internal/agreements'
      preLoaderRoute: typeof AppInternalAgreementsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/activity-feed': {
      id: '/_app/settings/activity-feed'
      path: '/activity-feed'
      fullPath: '/settings/activity-feed'
      preLoaderRoute: typeof AppSettingsActivityFeedRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/agency-context': {
      id: '/_app/settings/agency-context'
      path: '/agency-context'
      fullPath: '/settings/agency-context'
      preLoaderRoute: typeof AppSettingsAgencyContextRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/agent-rules': {
      id: '/_app/settings/agent-rules'
      path: '/agent-rules'
      fullPath: '/settings/agent-rules'
      preLoaderRoute: typeof AppSettingsAgentRulesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-assign': {
      id: '/_app/settings/auto-assign'
      path: '/auto-assign'
      fullPath: '/settings/auto-assign'
      preLoaderRoute: typeof AppSettingsAutoAssignRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-draft': {
      id: '/_app/settings/auto-draft'
      path: '/auto-draft'
      fullPath: '/settings/auto-draft'
      preLoaderRoute: typeof AppSettingsAutoDraftRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-reply-settings': {
      id: '/_app/settings/auto-reply-settings'
      path: '/auto-reply-settings'
      fullPath: '/settings/auto-reply-settings'
      preLoaderRoute: typeof AppSettingsAutoReplySettingsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/auto-send': {
      id: '/_app/settings/auto-send'
      path: '/auto-send'
      fullPath: '/settings/auto-send'
      preLoaderRoute: typeof AppSettingsAutoSendRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/automation-schedule': {
      id: '/_app/settings/automation-schedule'
      path: '/automation-schedule'
      fullPath: '/settings/automation-schedule'
      preLoaderRoute: typeof AppSettingsAutomationScheduleRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/automations': {
      id: '/_app/settings/automations'
      path: '/automations'
      fullPath: '/settings/automations'
      preLoaderRoute: typeof AppSettingsAutomationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/call-routing': {
      id: '/_app/settings/call-routing'
      path: '/call-routing'
      fullPath: '/settings/call-routing'
      preLoaderRoute: typeof AppSettingsCallRoutingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/call-templates': {
      id: '/_app/settings/call-templates'
      path: '/call-templates'
      fullPath: '/settings/call-templates'
      preLoaderRoute: typeof AppSettingsCallTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/cancellations': {
      id: '/_app/settings/cancellations'
      path: '/cancellations'
      fullPath: '/settings/cancellations'
      preLoaderRoute: typeof AppSettingsCancellationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/care-coordinators': {
      id: '/_app/settings/care-coordinators'
      path: '/care-coordinators'
      fullPath: '/settings/care-coordinators'
      preLoaderRoute: typeof AppSettingsCareCoordinatorsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/caregiver-engagement': {
      id: '/_app/settings/caregiver-engagement'
      path: '/caregiver-engagement'
      fullPath: '/settings/caregiver-engagement'
      preLoaderRoute: typeof AppSettingsCaregiverEngagementRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/caregiver-tags': {
      id: '/_app/settings/caregiver-tags'
      path: '/caregiver-tags'
      fullPath: '/settings/caregiver-tags'
      preLoaderRoute: typeof AppSettingsCaregiverTagsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/change-history': {
      id: '/_app/settings/change-history'
      path: '/change-history'
      fullPath: '/settings/change-history'
      preLoaderRoute: typeof AppSettingsChangeHistoryRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/chrome-extension': {
      id: '/_app/settings/chrome-extension'
      path: '/chrome-extension'
      fullPath: '/settings/chrome-extension'
      preLoaderRoute: typeof AppSettingsChromeExtensionRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/client-communication': {
      id: '/_app/settings/client-communication'
      path: '/client-communication'
      fullPath: '/settings/client-communication'
      preLoaderRoute: typeof AppSettingsClientCommunicationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/clock-in-out': {
      id: '/_app/settings/clock-in-out'
      path: '/clock-in-out'
      fullPath: '/settings/clock-in-out'
      preLoaderRoute: typeof AppSettingsClockInOutRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/clock-in-templates': {
      id: '/_app/settings/clock-in-templates'
      path: '/clock-in-templates'
      fullPath: '/settings/clock-in-templates'
      preLoaderRoute: typeof AppSettingsClockInTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/configurations': {
      id: '/_app/settings/configurations'
      path: '/configurations'
      fullPath: '/settings/configurations'
      preLoaderRoute: typeof AppSettingsConfigurationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/confirmation-messages': {
      id: '/_app/settings/confirmation-messages'
      path: '/confirmation-messages'
      fullPath: '/settings/confirmation-messages'
      preLoaderRoute: typeof AppSettingsConfirmationMessagesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/daily-digest': {
      id: '/_app/settings/daily-digest'
      path: '/daily-digest'
      fullPath: '/settings/daily-digest'
      preLoaderRoute: typeof AppSettingsDailyDigestRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/data-sync': {
      id: '/_app/settings/data-sync'
      path: '/data-sync'
      fullPath: '/settings/data-sync'
      preLoaderRoute: typeof AppSettingsDataSyncRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/early-access': {
      id: '/_app/settings/early-access'
      path: '/early-access'
      fullPath: '/settings/early-access'
      preLoaderRoute: typeof AppSettingsEarlyAccessRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/help-center': {
      id: '/_app/settings/help-center'
      path: '/help-center'
      fullPath: '/settings/help-center'
      preLoaderRoute: typeof AppSettingsHelpCenterRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/off-hours': {
      id: '/_app/settings/off-hours'
      path: '/off-hours'
      fullPath: '/settings/off-hours'
      preLoaderRoute: typeof AppSettingsOffHoursRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/offices': {
      id: '/_app/settings/offices'
      path: '/offices'
      fullPath: '/settings/offices'
      preLoaderRoute: typeof AppSettingsOfficesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/open-shift-responses': {
      id: '/_app/settings/open-shift-responses'
      path: '/open-shift-responses'
      fullPath: '/settings/open-shift-responses'
      preLoaderRoute: typeof AppSettingsOpenShiftResponsesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/other-templates': {
      id: '/_app/settings/other-templates'
      path: '/other-templates'
      fullPath: '/settings/other-templates'
      preLoaderRoute: typeof AppSettingsOtherTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/outreach-automation': {
      id: '/_app/settings/outreach-automation'
      path: '/outreach-automation'
      fullPath: '/settings/outreach-automation'
      preLoaderRoute: typeof AppSettingsOutreachAutomationRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/outreach-templates': {
      id: '/_app/settings/outreach-templates'
      path: '/outreach-templates'
      fullPath: '/settings/outreach-templates'
      preLoaderRoute: typeof AppSettingsOutreachTemplatesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phoebe': {
      id: '/_app/settings/phoebe'
      path: '/phoebe'
      fullPath: '/settings/phoebe'
      preLoaderRoute: typeof AppSettingsPhoebeRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone': {
      id: '/_app/settings/phone'
      path: '/phone'
      fullPath: '/settings/phone'
      preLoaderRoute: typeof AppSettingsPhoneRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone-instructions': {
      id: '/_app/settings/phone-instructions'
      path: '/phone-instructions'
      fullPath: '/settings/phone-instructions'
      preLoaderRoute: typeof AppSettingsPhoneInstructionsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone-numbers': {
      id: '/_app/settings/phone-numbers'
      path: '/phone-numbers'
      fullPath: '/settings/phone-numbers'
      preLoaderRoute: typeof AppSettingsPhoneNumbersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/phone-try': {
      id: '/_app/settings/phone-try'
      path: '/phone-try'
      fullPath: '/settings/phone-try'
      preLoaderRoute: typeof AppSettingsPhoneTryRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/pronunciations': {
      id: '/_app/settings/pronunciations'
      path: '/pronunciations'
      fullPath: '/settings/pronunciations'
      preLoaderRoute: typeof AppSettingsPronunciationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/quiet-hours': {
      id: '/_app/settings/quiet-hours'
      path: '/quiet-hours'
      fullPath: '/settings/quiet-hours'
      preLoaderRoute: typeof AppSettingsQuietHoursRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/recommendations': {
      id: '/_app/settings/recommendations'
      path: '/recommendations'
      fullPath: '/settings/recommendations'
      preLoaderRoute: typeof AppSettingsRecommendationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/shift-confirmation-skip-allow-lists': {
      id: '/_app/settings/shift-confirmation-skip-allow-lists'
      path: '/shift-confirmation-skip-allow-lists'
      fullPath: '/settings/shift-confirmation-skip-allow-lists'
      preLoaderRoute: typeof AppSettingsShiftConfirmationSkipAllowListsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/shift-confirmations': {
      id: '/_app/settings/shift-confirmations'
      path: '/shift-confirmations'
      fullPath: '/settings/shift-confirmations'
      preLoaderRoute: typeof AppSettingsShiftConfirmationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/skip-allow-lists': {
      id: '/_app/settings/skip-allow-lists'
      path: '/skip-allow-lists'
      fullPath: '/settings/skip-allow-lists'
      preLoaderRoute: typeof AppSettingsSkipAllowListsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/slack': {
      id: '/_app/settings/slack'
      path: '/slack'
      fullPath: '/settings/slack'
      preLoaderRoute: typeof AppSettingsSlackRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tag-matching': {
      id: '/_app/settings/tag-matching'
      path: '/tag-matching'
      fullPath: '/settings/tag-matching'
      preLoaderRoute: typeof AppSettingsTagMatchingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/tags': {
      id: '/_app/settings/tags'
      path: '/tags'
      fullPath: '/settings/tags'
      preLoaderRoute: typeof AppSettingsTagsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team-coverage': {
      id: '/_app/settings/team-coverage'
      path: '/team-coverage'
      fullPath: '/settings/team-coverage'
      preLoaderRoute: typeof AppSettingsTeamCoverageRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team-members': {
      id: '/_app/settings/team-members'
      path: '/team-members'
      fullPath: '/settings/team-members'
      preLoaderRoute: typeof AppSettingsTeamMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/teams': {
      id: '/_app/settings/teams'
      path: '/teams'
      fullPath: '/settings/teams'
      preLoaderRoute: typeof AppSettingsTeamsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/slack/link': {
      id: '/_app/slack/link'
      path: '/slack/link'
      fullPath: '/slack/link'
      preLoaderRoute: typeof AppSlackLinkRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/(agent)/agent/': {
      id: '/_app/(agent)/agent/'
      path: '/'
      fullPath: '/agent/'
      preLoaderRoute: typeof AppagentAgentIndexRouteImport
      parentRoute: typeof AppagentAgentRoute
    }
    '/_app/(main)/automations/': {
      id: '/_app/(main)/automations/'
      path: '/automations'
      fullPath: '/automations/'
      preLoaderRoute: typeof AppmainAutomationsIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/automations/$automationId': {
      id: '/_app/(main)/automations/$automationId'
      path: '/automations/$automationId'
      fullPath: '/automations/$automationId'
      preLoaderRoute: typeof AppmainAutomationsAutomationIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/calendar/': {
      id: '/_app/(main)/calendar/'
      path: '/calendar'
      fullPath: '/calendar/'
      preLoaderRoute: typeof AppmainCalendarIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/conversations/': {
      id: '/_app/(main)/conversations/'
      path: '/conversations'
      fullPath: '/conversations/'
      preLoaderRoute: typeof AppmainConversationsIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/': {
      id: '/_app/(main)/outreaches/'
      path: '/outreaches'
      fullPath: '/outreaches/'
      preLoaderRoute: typeof AppmainOutreachesIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/$callout-id': {
      id: '/_app/(main)/outreaches/$callout-id'
      path: '/outreaches/$callout-id'
      fullPath: '/outreaches/$callout-id'
      preLoaderRoute: typeof AppmainOutreachesCalloutIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/routines/': {
      id: '/_app/(main)/routines/'
      path: '/routines'
      fullPath: '/routines/'
      preLoaderRoute: typeof AppmainRoutinesIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/routines/$routineId': {
      id: '/_app/(main)/routines/$routineId'
      path: '/routines/$routineId'
      fullPath: '/routines/$routineId'
      preLoaderRoute: typeof AppmainRoutinesRoutineIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/scheduled/': {
      id: '/_app/(main)/scheduled/'
      path: '/scheduled'
      fullPath: '/scheduled/'
      preLoaderRoute: typeof AppmainScheduledIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/shifts/': {
      id: '/_app/(main)/shifts/'
      path: '/shifts'
      fullPath: '/shifts/'
      preLoaderRoute: typeof AppmainShiftsIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/shifts/$shift-id': {
      id: '/_app/(main)/shifts/$shift-id'
      path: '/shifts/$shift-id'
      fullPath: '/shifts/$shift-id'
      preLoaderRoute: typeof AppmainShiftsShiftIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/surveys/': {
      id: '/_app/(main)/surveys/'
      path: '/surveys'
      fullPath: '/surveys/'
      preLoaderRoute: typeof AppmainSurveysIndexRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/surveys/$survey-id': {
      id: '/_app/(main)/surveys/$survey-id'
      path: '/surveys/$survey-id'
      fullPath: '/surveys/$survey-id'
      preLoaderRoute: typeof AppmainSurveysSurveyIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/surveys/create': {
      id: '/_app/(main)/surveys/create'
      path: '/surveys/create'
      fullPath: '/surveys/create'
      preLoaderRoute: typeof AppmainSurveysCreateRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/training/': {
      id: '/_app/(main)/training/'
      path: '/'
      fullPath: '/training/'
      preLoaderRoute: typeof AppmainTrainingIndexRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/training/announcement': {
      id: '/_app/(main)/training/announcement'
      path: '/announcement'
      fullPath: '/training/announcement'
      preLoaderRoute: typeof AppmainTrainingAnnouncementRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/training/client-onboarding': {
      id: '/_app/(main)/training/client-onboarding'
      path: '/client-onboarding'
      fullPath: '/training/client-onboarding'
      preLoaderRoute: typeof AppmainTrainingClientOnboardingRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/training/demo': {
      id: '/_app/(main)/training/demo'
      path: '/demo'
      fullPath: '/training/demo'
      preLoaderRoute: typeof AppmainTrainingDemoRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/(main)/training/onboarding': {
      id: '/_app/(main)/training/onboarding'
      path: '/onboarding'
      fullPath: '/training/onboarding'
      preLoaderRoute: typeof AppmainTrainingOnboardingRouteImport
      parentRoute: typeof AppmainTrainingRoute
    }
    '/_app/admin/access-tokens/': {
      id: '/_app/admin/access-tokens/'
      path: '/access-tokens'
      fullPath: '/admin/access-tokens/'
      preLoaderRoute: typeof AppAdminAccessTokensIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/accounts/': {
      id: '/_app/admin/accounts/'
      path: '/accounts'
      fullPath: '/admin/accounts/'
      preLoaderRoute: typeof AppAdminAccountsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/accounts/$accountId': {
      id: '/_app/admin/accounts/$accountId'
      path: '/accounts/$accountId'
      fullPath: '/admin/accounts/$accountId'
      preLoaderRoute: typeof AppAdminAccountsAccountIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-notes/': {
      id: '/_app/admin/agent-notes/'
      path: '/agent-notes'
      fullPath: '/admin/agent-notes/'
      preLoaderRoute: typeof AppAdminAgentNotesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-notes/$note-id': {
      id: '/_app/admin/agent-notes/$note-id'
      path: '/agent-notes/$note-id'
      fullPath: '/admin/agent-notes/$note-id'
      preLoaderRoute: typeof AppAdminAgentNotesNoteIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/': {
      id: '/_app/admin/agent-traces/'
      path: '/agent-traces'
      fullPath: '/admin/agent-traces/'
      preLoaderRoute: typeof AppAdminAgentTracesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/$conversationId': {
      id: '/_app/admin/agent-traces/$conversationId'
      path: '/agent-traces/$conversationId'
      fullPath: '/admin/agent-traces/$conversationId'
      preLoaderRoute: typeof AppAdminAgentTracesConversationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/caregiver': {
      id: '/_app/admin/agent-traces/caregiver'
      path: '/agent-traces/caregiver'
      fullPath: '/admin/agent-traces/caregiver'
      preLoaderRoute: typeof AppAdminAgentTracesCaregiverRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/client': {
      id: '/_app/admin/agent-traces/client'
      path: '/agent-traces/client'
      fullPath: '/admin/agent-traces/client'
      preLoaderRoute: typeof AppAdminAgentTracesClientRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/continual': {
      id: '/_app/admin/agent-traces/continual'
      path: '/agent-traces/continual'
      fullPath: '/admin/agent-traces/continual'
      preLoaderRoute: typeof AppAdminAgentTracesContinualRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/ephemeral': {
      id: '/_app/admin/agent-traces/ephemeral'
      path: '/agent-traces/ephemeral'
      fullPath: '/admin/agent-traces/ephemeral'
      preLoaderRoute: typeof AppAdminAgentTracesEphemeralRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent-traces/prompts': {
      id: '/_app/admin/agent-traces/prompts'
      path: '/agent-traces/prompts'
      fullPath: '/admin/agent-traces/prompts'
      preLoaderRoute: typeof AppAdminAgentTracesPromptsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/_chat': {
      id: '/_app/admin/agent/_chat'
      path: '/agent'
      fullPath: '/admin/agent'
      preLoaderRoute: typeof AppAdminAgentChatRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/connections': {
      id: '/_app/admin/agent/connections'
      path: '/agent/connections'
      fullPath: '/admin/agent/connections'
      preLoaderRoute: typeof AppAdminAgentConnectionsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/judge': {
      id: '/_app/admin/agent/judge'
      path: '/agent/judge'
      fullPath: '/admin/agent/judge'
      preLoaderRoute: typeof AppAdminAgentJudgeRouteRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/skills': {
      id: '/_app/admin/agent/skills'
      path: '/agent/skills'
      fullPath: '/admin/agent/skills'
      preLoaderRoute: typeof AppAdminAgentSkillsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/v3-automations': {
      id: '/_app/admin/agent/v3-automations'
      path: '/agent/v3-automations'
      fullPath: '/admin/agent/v3-automations'
      preLoaderRoute: typeof AppAdminAgentV3AutomationsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/virtualization': {
      id: '/_app/admin/agent/virtualization'
      path: '/agent/virtualization'
      fullPath: '/admin/agent/virtualization'
      preLoaderRoute: typeof AppAdminAgentVirtualizationRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/auto-callout-board/': {
      id: '/_app/admin/auto-callout-board/'
      path: '/auto-callout-board'
      fullPath: '/admin/auto-callout-board/'
      preLoaderRoute: typeof AppAdminAutoCalloutBoardIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/automations/': {
      id: '/_app/admin/automations/'
      path: '/automations'
      fullPath: '/admin/automations/'
      preLoaderRoute: typeof AppAdminAutomationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/calls/': {
      id: '/_app/admin/calls/'
      path: '/calls'
      fullPath: '/admin/calls/'
      preLoaderRoute: typeof AppAdminCallsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/calls/$callId': {
      id: '/_app/admin/calls/$callId'
      path: '/calls/$callId'
      fullPath: '/admin/calls/$callId'
      preLoaderRoute: typeof AppAdminCallsCallIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/care-coordinators/': {
      id: '/_app/admin/care-coordinators/'
      path: '/care-coordinators'
      fullPath: '/admin/care-coordinators/'
      preLoaderRoute: typeof AppAdminCareCoordinatorsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/care-coordinators/$care-coordinator-id': {
      id: '/_app/admin/care-coordinators/$care-coordinator-id'
      path: '/care-coordinators/$care-coordinator-id'
      fullPath: '/admin/care-coordinators/$care-coordinator-id'
      preLoaderRoute: typeof AppAdminCareCoordinatorsCareCoordinatorIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/caregivers/': {
      id: '/_app/admin/caregivers/'
      path: '/caregivers'
      fullPath: '/admin/caregivers/'
      preLoaderRoute: typeof AppAdminCaregiversIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/caregivers/$caregiver-id': {
      id: '/_app/admin/caregivers/$caregiver-id'
      path: '/caregivers/$caregiver-id'
      fullPath: '/admin/caregivers/$caregiver-id'
      preLoaderRoute: typeof AppAdminCaregiversCaregiverIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/clients/': {
      id: '/_app/admin/clients/'
      path: '/clients'
      fullPath: '/admin/clients/'
      preLoaderRoute: typeof AppAdminClientsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/clients/$client-id': {
      id: '/_app/admin/clients/$client-id'
      path: '/clients/$client-id'
      fullPath: '/admin/clients/$client-id'
      preLoaderRoute: typeof AppAdminClientsClientIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/extension-lab/': {
      id: '/_app/admin/extension-lab/'
      path: '/'
      fullPath: '/admin/extension-lab/'
      preLoaderRoute: typeof AppAdminExtensionLabIndexRouteImport
      parentRoute: typeof AppAdminExtensionLabRouteRoute
    }
    '/_app/admin/franchises/': {
      id: '/_app/admin/franchises/'
      path: '/franchises'
      fullPath: '/admin/franchises/'
      preLoaderRoute: typeof AppAdminFranchisesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/org-distributions/': {
      id: '/_app/admin/org-distributions/'
      path: '/org-distributions'
      fullPath: '/admin/org-distributions/'
      preLoaderRoute: typeof AppAdminOrgDistributionsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organization-attributes/': {
      id: '/_app/admin/organization-attributes/'
      path: '/organization-attributes'
      fullPath: '/admin/organization-attributes/'
      preLoaderRoute: typeof AppAdminOrganizationAttributesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations/': {
      id: '/_app/admin/organizations/'
      path: '/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AppAdminOrganizationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organizations/$organization-id': {
      id: '/_app/admin/organizations/$organization-id'
      path: '/organizations/$organization-id'
      fullPath: '/admin/organizations/$organization-id'
      preLoaderRoute: typeof AppAdminOrganizationsOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/outbox/': {
      id: '/_app/admin/outbox/'
      path: '/outbox'
      fullPath: '/admin/outbox/'
      preLoaderRoute: typeof AppAdminOutboxIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/recommendation-explorer/': {
      id: '/_app/admin/recommendation-explorer/'
      path: '/recommendation-explorer'
      fullPath: '/admin/recommendation-explorer/'
      preLoaderRoute: typeof AppAdminRecommendationExplorerIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/revenue/': {
      id: '/_app/admin/revenue/'
      path: '/revenue'
      fullPath: '/admin/revenue/'
      preLoaderRoute: typeof AppAdminRevenueIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/revenue/$account-id': {
      id: '/_app/admin/revenue/$account-id'
      path: '/revenue/$account-id'
      fullPath: '/admin/revenue/$account-id'
      preLoaderRoute: typeof AppAdminRevenueAccountIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/revenue/accounts': {
      id: '/_app/admin/revenue/accounts'
      path: '/revenue/accounts'
      fullPath: '/admin/revenue/accounts'
      preLoaderRoute: typeof AppAdminRevenueAccountsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sales/agreements': {
      id: '/_app/admin/sales/agreements'
      path: '/sales/agreements'
      fullPath: '/admin/sales/agreements'
      preLoaderRoute: typeof AppAdminSalesAgreementsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sandbox/': {
      id: '/_app/admin/sandbox/'
      path: '/sandbox'
      fullPath: '/admin/sandbox/'
      preLoaderRoute: typeof AppAdminSandboxIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/sandbox/$organizationId': {
      id: '/_app/admin/sandbox/$organizationId'
      path: '/sandbox/$organizationId'
      fullPath: '/admin/sandbox/$organizationId'
      preLoaderRoute: typeof AppAdminSandboxOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/shifts/': {
      id: '/_app/admin/shifts/'
      path: '/shifts'
      fullPath: '/admin/shifts/'
      preLoaderRoute: typeof AppAdminShiftsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/shifts/$shift-id': {
      id: '/_app/admin/shifts/$shift-id'
      path: '/shifts/$shift-id'
      fullPath: '/admin/shifts/$shift-id'
      preLoaderRoute: typeof AppAdminShiftsShiftIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users/': {
      id: '/_app/admin/users/'
      path: '/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AppAdminUsersIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/users/$user-id': {
      id: '/_app/admin/users/$user-id'
      path: '/users/$user-id'
      fullPath: '/admin/users/$user-id'
      preLoaderRoute: typeof AppAdminUsersUserIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/v3-agent/': {
      id: '/_app/admin/v3-agent/'
      path: '/'
      fullPath: '/admin/v3-agent/'
      preLoaderRoute: typeof AppAdminV3AgentIndexRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/v3-agent/$runId': {
      id: '/_app/admin/v3-agent/$runId'
      path: '/$runId'
      fullPath: '/admin/v3-agent/$runId'
      preLoaderRoute: typeof AppAdminV3AgentRunIdRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/v3-agent/automations': {
      id: '/_app/admin/v3-agent/automations'
      path: '/automations'
      fullPath: '/admin/v3-agent/automations'
      preLoaderRoute: typeof AppAdminV3AgentAutomationsRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/v3-agent/judge': {
      id: '/_app/admin/v3-agent/judge'
      path: '/judge'
      fullPath: '/admin/v3-agent/judge'
      preLoaderRoute: typeof AppAdminV3AgentJudgeRouteRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/v3-agent/new': {
      id: '/_app/admin/v3-agent/new'
      path: '/new'
      fullPath: '/admin/v3-agent/new'
      preLoaderRoute: typeof AppAdminV3AgentNewRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/v3-agent/skills': {
      id: '/_app/admin/v3-agent/skills'
      path: '/skills'
      fullPath: '/admin/v3-agent/skills'
      preLoaderRoute: typeof AppAdminV3AgentSkillsRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/voice-config/': {
      id: '/_app/admin/voice-config/'
      path: '/voice-config'
      fullPath: '/admin/voice-config/'
      preLoaderRoute: typeof AppAdminVoiceConfigIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-config/$organization-id': {
      id: '/_app/admin/voice-config/$organization-id'
      path: '/voice-config/$organization-id'
      fullPath: '/admin/voice-config/$organization-id'
      preLoaderRoute: typeof AppAdminVoiceConfigOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/': {
      id: '/_app/admin/voice-evals/'
      path: '/voice-evals'
      fullPath: '/admin/voice-evals/'
      preLoaderRoute: typeof AppAdminVoiceEvalsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/cases': {
      id: '/_app/admin/voice-evals/cases'
      path: '/voice-evals/cases'
      fullPath: '/admin/voice-evals/cases'
      preLoaderRoute: typeof AppAdminVoiceEvalsCasesRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/catalog': {
      id: '/_app/admin/voice-evals/catalog'
      path: '/voice-evals/catalog'
      fullPath: '/admin/voice-evals/catalog'
      preLoaderRoute: typeof AppAdminVoiceEvalsCatalogRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/compare': {
      id: '/_app/admin/voice-evals/compare'
      path: '/voice-evals/compare'
      fullPath: '/admin/voice-evals/compare'
      preLoaderRoute: typeof AppAdminVoiceEvalsCompareRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-evals/compare-case': {
      id: '/_app/admin/voice-evals/compare-case'
      path: '/voice-evals/compare-case'
      fullPath: '/admin/voice-evals/compare-case'
      preLoaderRoute: typeof AppAdminVoiceEvalsCompareCaseRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-playground/': {
      id: '/_app/admin/voice-playground/'
      path: '/voice-playground'
      fullPath: '/admin/voice-playground/'
      preLoaderRoute: typeof AppAdminVoicePlaygroundIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-playground/$call-id': {
      id: '/_app/admin/voice-playground/$call-id'
      path: '/voice-playground/$call-id'
      fullPath: '/admin/voice-playground/$call-id'
      preLoaderRoute: typeof AppAdminVoicePlaygroundCallIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-qa/': {
      id: '/_app/admin/voice-qa/'
      path: '/voice-qa'
      fullPath: '/admin/voice-qa/'
      preLoaderRoute: typeof AppAdminVoiceQaIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-qa/$callId': {
      id: '/_app/admin/voice-qa/$callId'
      path: '/voice-qa/$callId'
      fullPath: '/admin/voice-qa/$callId'
      preLoaderRoute: typeof AppAdminVoiceQaCallIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voice-qa/shadow-comparison': {
      id: '/_app/admin/voice-qa/shadow-comparison'
      path: '/voice-qa/shadow-comparison'
      fullPath: '/admin/voice-qa/shadow-comparison'
      preLoaderRoute: typeof AppAdminVoiceQaShadowComparisonRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voip/': {
      id: '/_app/admin/voip/'
      path: '/voip'
      fullPath: '/admin/voip/'
      preLoaderRoute: typeof AppAdminVoipIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/voip/$organization-id': {
      id: '/_app/admin/voip/$organization-id'
      path: '/voip/$organization-id'
      fullPath: '/admin/voip/$organization-id'
      preLoaderRoute: typeof AppAdminVoipOrganizationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/settings/notifications/': {
      id: '/_app/settings/notifications/'
      path: '/'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof AppSettingsNotificationsIndexRouteImport
      parentRoute: typeof AppSettingsNotificationsRouteRoute
    }
    '/_app/settings/notifications/$channel': {
      id: '/_app/settings/notifications/$channel'
      path: '/$channel'
      fullPath: '/settings/notifications/$channel'
      preLoaderRoute: typeof AppSettingsNotificationsChannelRouteImport
      parentRoute: typeof AppSettingsNotificationsRouteRoute
    }
    '/_app/settings/team-members_/$memberUserId': {
      id: '/_app/settings/team-members_/$memberUserId'
      path: '/team-members/$memberUserId'
      fullPath: '/settings/team-members/$memberUserId'
      preLoaderRoute: typeof AppSettingsTeamMembersMemberUserIdRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team-members_/bulk': {
      id: '/_app/settings/team-members_/bulk'
      path: '/team-members/bulk'
      fullPath: '/settings/team-members/bulk'
      preLoaderRoute: typeof AppSettingsTeamMembersBulkRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/team-members_/defaults': {
      id: '/_app/settings/team-members_/defaults'
      path: '/team-members/defaults'
      fullPath: '/settings/team-members/defaults'
      preLoaderRoute: typeof AppSettingsTeamMembersDefaultsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/(agent)/agent/runs/$runId': {
      id: '/_app/(agent)/agent/runs/$runId'
      path: '/runs/$runId'
      fullPath: '/agent/runs/$runId'
      preLoaderRoute: typeof AppagentAgentRunsRunIdRouteImport
      parentRoute: typeof AppagentAgentRoute
    }
    '/_app/(main)/outreaches/message/$message-id': {
      id: '/_app/(main)/outreaches/message/$message-id'
      path: '/outreaches/message/$message-id'
      fullPath: '/outreaches/message/$message-id'
      preLoaderRoute: typeof AppmainOutreachesMessageMessageIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/message/create': {
      id: '/_app/(main)/outreaches/message/create'
      path: '/outreaches/message/create'
      fullPath: '/outreaches/message/create'
      preLoaderRoute: typeof AppmainOutreachesMessageCreateRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/survey/$survey-id': {
      id: '/_app/(main)/outreaches/survey/$survey-id'
      path: '/outreaches/survey/$survey-id'
      fullPath: '/outreaches/survey/$survey-id'
      preLoaderRoute: typeof AppmainOutreachesSurveySurveyIdRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/(main)/outreaches/survey/create': {
      id: '/_app/(main)/outreaches/survey/create'
      path: '/outreaches/survey/create'
      fullPath: '/outreaches/survey/create'
      preLoaderRoute: typeof AppmainOutreachesSurveyCreateRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/admin/agent-traces/run/$runId': {
      id: '/_app/admin/agent-traces/run/$runId'
      path: '/agent-traces/run/$runId'
      fullPath: '/admin/agent-traces/run/$runId'
      preLoaderRoute: typeof AppAdminAgentTracesRunRunIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/_chat/': {
      id: '/_app/admin/agent/_chat/'
      path: '/'
      fullPath: '/admin/agent/'
      preLoaderRoute: typeof AppAdminAgentChatIndexRouteImport
      parentRoute: typeof AppAdminAgentChatRouteRoute
    }
    '/_app/admin/agent/_chat/$runId': {
      id: '/_app/admin/agent/_chat/$runId'
      path: '/$runId'
      fullPath: '/admin/agent/$runId'
      preLoaderRoute: typeof AppAdminAgentChatRunIdRouteImport
      parentRoute: typeof AppAdminAgentChatRouteRoute
    }
    '/_app/admin/agent/_chat/new': {
      id: '/_app/admin/agent/_chat/new'
      path: '/new'
      fullPath: '/admin/agent/new'
      preLoaderRoute: typeof AppAdminAgentChatNewRouteImport
      parentRoute: typeof AppAdminAgentChatRouteRoute
    }
    '/_app/admin/agent/actions/': {
      id: '/_app/admin/agent/actions/'
      path: '/agent/actions'
      fullPath: '/admin/agent/actions/'
      preLoaderRoute: typeof AppAdminAgentActionsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/actions/$audit-id': {
      id: '/_app/admin/agent/actions/$audit-id'
      path: '/agent/actions/$audit-id'
      fullPath: '/admin/agent/actions/$audit-id'
      preLoaderRoute: typeof AppAdminAgentActionsAuditIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/': {
      id: '/_app/admin/agent/automations/'
      path: '/agent/automations'
      fullPath: '/admin/agent/automations/'
      preLoaderRoute: typeof AppAdminAgentAutomationsIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/list': {
      id: '/_app/admin/agent/automations/list'
      path: '/agent/automations/list'
      fullPath: '/admin/agent/automations/list'
      preLoaderRoute: typeof AppAdminAgentAutomationsListRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/runs': {
      id: '/_app/admin/agent/automations/runs'
      path: '/agent/automations/runs'
      fullPath: '/admin/agent/automations/runs'
      preLoaderRoute: typeof AppAdminAgentAutomationsRunsRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/judge/': {
      id: '/_app/admin/agent/judge/'
      path: '/'
      fullPath: '/admin/agent/judge/'
      preLoaderRoute: typeof AppAdminAgentJudgeIndexRouteImport
      parentRoute: typeof AppAdminAgentJudgeRouteRoute
    }
    '/_app/admin/agent/pages/': {
      id: '/_app/admin/agent/pages/'
      path: '/agent/pages'
      fullPath: '/admin/agent/pages/'
      preLoaderRoute: typeof AppAdminAgentPagesIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/pages/$slug': {
      id: '/_app/admin/agent/pages/$slug'
      path: '/agent/pages/$slug'
      fullPath: '/admin/agent/pages/$slug'
      preLoaderRoute: typeof AppAdminAgentPagesSlugRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/scratchpad/': {
      id: '/_app/admin/agent/scratchpad/'
      path: '/agent/scratchpad'
      fullPath: '/admin/agent/scratchpad/'
      preLoaderRoute: typeof AppAdminAgentScratchpadIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/scratchpad/$note-id': {
      id: '/_app/admin/agent/scratchpad/$note-id'
      path: '/agent/scratchpad/$note-id'
      fullPath: '/admin/agent/scratchpad/$note-id'
      preLoaderRoute: typeof AppAdminAgentScratchpadNoteIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/automations/$organizationId/$automationId': {
      id: '/_app/admin/automations/$organizationId/$automationId'
      path: '/automations/$organizationId/$automationId'
      fullPath: '/admin/automations/$organizationId/$automationId'
      preLoaderRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId': {
      id: '/_app/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId'
      path: '/caregiver-sms-shadow/$organizationId/$sourceMessageId'
      fullPath: '/admin/caregiver-sms-shadow/$organizationId/$sourceMessageId'
      preLoaderRoute: typeof AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/ehr-contracts/{-$vendor}/{-$endpoint}': {
      id: '/_app/admin/ehr-contracts/{-$vendor}/{-$endpoint}'
      path: '/ehr-contracts/{-$vendor}/{-$endpoint}'
      fullPath: '/admin/ehr-contracts/{-$vendor}/{-$endpoint}'
      preLoaderRoute: typeof AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125RouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/organization-attributes/$tab/{-$organizationId}': {
      id: '/_app/admin/organization-attributes/$tab/{-$organizationId}'
      path: '/organization-attributes/$tab/{-$organizationId}'
      fullPath: '/admin/organization-attributes/$tab/{-$organizationId}'
      preLoaderRoute: typeof AppAdminOrganizationAttributesTabChar123OrganizationIdChar125RouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/v3-agent/judge/': {
      id: '/_app/admin/v3-agent/judge/'
      path: '/'
      fullPath: '/admin/v3-agent/judge/'
      preLoaderRoute: typeof AppAdminV3AgentJudgeIndexRouteImport
      parentRoute: typeof AppAdminV3AgentJudgeRouteRoute
    }
    '/_app/admin/v3-agent/scratchpad/': {
      id: '/_app/admin/v3-agent/scratchpad/'
      path: '/scratchpad'
      fullPath: '/admin/v3-agent/scratchpad/'
      preLoaderRoute: typeof AppAdminV3AgentScratchpadIndexRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/admin/v3-agent/scratchpad/$note-id': {
      id: '/_app/admin/v3-agent/scratchpad/$note-id'
      path: '/scratchpad/$note-id'
      fullPath: '/admin/v3-agent/scratchpad/$note-id'
      preLoaderRoute: typeof AppAdminV3AgentScratchpadNoteIdRouteImport
      parentRoute: typeof AppAdminV3AgentRouteRoute
    }
    '/_app/settings/team-members_/$memberUserId/': {
      id: '/_app/settings/team-members_/$memberUserId/'
      path: '/'
      fullPath: '/settings/team-members/$memberUserId/'
      preLoaderRoute: typeof AppSettingsTeamMembersMemberUserIdIndexRouteImport
      parentRoute: typeof AppSettingsTeamMembersMemberUserIdRoute
    }
    '/_app/(main)/extension-review/calendar/php/unassigned': {
      id: '/_app/(main)/extension-review/calendar/php/unassigned'
      path: '/extension-review/calendar/php/unassigned'
      fullPath: '/extension-review/calendar/php/unassigned'
      preLoaderRoute: typeof AppmainExtensionReviewCalendarPhpUnassignedRouteImport
      parentRoute: typeof AppmainRouteRoute
    }
    '/_app/admin/agent/automations/$organizationId/$automationId': {
      id: '/_app/admin/agent/automations/$organizationId/$automationId'
      path: '/agent/automations/$organizationId/$automationId'
      fullPath: '/admin/agent/automations/$organizationId/$automationId'
      preLoaderRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/groups/$automationGroupId': {
      id: '/_app/admin/agent/automations/groups/$automationGroupId'
      path: '/agent/automations/groups/$automationGroupId'
      fullPath: '/admin/agent/automations/groups/$automationGroupId'
      preLoaderRoute: typeof AppAdminAgentAutomationsGroupsAutomationGroupIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/judge/trace/$runId': {
      id: '/_app/admin/agent/judge/trace/$runId'
      path: '/trace/$runId'
      fullPath: '/admin/agent/judge/trace/$runId'
      preLoaderRoute: typeof AppAdminAgentJudgeTraceRunIdRouteImport
      parentRoute: typeof AppAdminAgentJudgeRouteRoute
    }
    '/_app/admin/automations/$organizationId/$automationId/': {
      id: '/_app/admin/automations/$organizationId/$automationId/'
      path: '/'
      fullPath: '/admin/automations/$organizationId/$automationId/'
      preLoaderRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRouteImport
      parentRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRoute
    }
    '/_app/admin/v3-agent/judge/trace/$runId': {
      id: '/_app/admin/v3-agent/judge/trace/$runId'
      path: '/trace/$runId'
      fullPath: '/admin/v3-agent/judge/trace/$runId'
      preLoaderRoute: typeof AppAdminV3AgentJudgeTraceRunIdRouteImport
      parentRoute: typeof AppAdminV3AgentJudgeRouteRoute
    }
    '/_app/admin/voice-evals/runs/$runId/': {
      id: '/_app/admin/voice-evals/runs/$runId/'
      path: '/voice-evals/runs/$runId'
      fullPath: '/admin/voice-evals/runs/$runId/'
      preLoaderRoute: typeof AppAdminVoiceEvalsRunsRunIdIndexRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/settings/team-members_/$memberUserId/notifications/': {
      id: '/_app/settings/team-members_/$memberUserId/notifications/'
      path: '/notifications'
      fullPath: '/settings/team-members/$memberUserId/notifications/'
      preLoaderRoute: typeof AppSettingsTeamMembersMemberUserIdNotificationsIndexRouteImport
      parentRoute: typeof AppSettingsTeamMembersMemberUserIdRoute
    }
    '/_app/settings/team-members_/$memberUserId/notifications/$channel': {
      id: '/_app/settings/team-members_/$memberUserId/notifications/$channel'
      path: '/notifications/$channel'
      fullPath: '/settings/team-members/$memberUserId/notifications/$channel'
      preLoaderRoute: typeof AppSettingsTeamMembersMemberUserIdNotificationsChannelRouteImport
      parentRoute: typeof AppSettingsTeamMembersMemberUserIdRoute
    }
    '/_app/admin/agent/automations/$organizationId/$automationId/': {
      id: '/_app/admin/agent/automations/$organizationId/$automationId/'
      path: '/'
      fullPath: '/admin/agent/automations/$organizationId/$automationId/'
      preLoaderRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRouteImport
      parentRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRoute
    }
    '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId': {
      id: '/_app/admin/automations/$organizationId/$automationId/runs/$automationRunId'
      path: '/runs/$automationRunId'
      fullPath: '/admin/automations/$organizationId/$automationId/runs/$automationRunId'
      preLoaderRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport
      parentRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRoute
    }
    '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId': {
      id: '/_app/admin/extension-lab/ehr/$provider/$entity/$externalId'
      path: '/ehr/$provider/$entity/$externalId'
      fullPath: '/admin/extension-lab/ehr/$provider/$entity/$externalId'
      preLoaderRoute: typeof AppAdminExtensionLabEhrProviderEntityExternalIdRouteImport
      parentRoute: typeof AppAdminExtensionLabRouteRoute
    }
    '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId': {
      id: '/_app/admin/voice-evals/runs/$runId/cases/$caseResultId'
      path: '/voice-evals/runs/$runId/cases/$caseResultId'
      fullPath: '/admin/voice-evals/runs/$runId/cases/$caseResultId'
      preLoaderRoute: typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRouteImport
      parentRoute: typeof AppAdminRouteRoute
    }
    '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId': {
      id: '/_app/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
      path: '/runs/$automationRunId'
      fullPath: '/admin/agent/automations/$organizationId/$automationId/runs/$automationRunId'
      preLoaderRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRouteImport
      parentRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRoute
    }
  }
}

interface AppagentAgentRouteChildren {
  AppagentAgentIndexRoute: typeof AppagentAgentIndexRoute
  AppagentAgentRunsRunIdRoute: typeof AppagentAgentRunsRunIdRoute
}

const AppagentAgentRouteChildren: AppagentAgentRouteChildren = {
  AppagentAgentIndexRoute: AppagentAgentIndexRoute,
  AppagentAgentRunsRunIdRoute: AppagentAgentRunsRunIdRoute,
}

const AppagentAgentRouteWithChildren = AppagentAgentRoute._addFileChildren(
  AppagentAgentRouteChildren,
)

interface AppagentRouteRouteChildren {
  AppagentAgentRoute: typeof AppagentAgentRouteWithChildren
}

const AppagentRouteRouteChildren: AppagentRouteRouteChildren = {
  AppagentAgentRoute: AppagentAgentRouteWithChildren,
}

const AppagentRouteRouteWithChildren = AppagentRouteRoute._addFileChildren(
  AppagentRouteRouteChildren,
)

interface AppextensionRouteRouteChildren {
  AppextensionExtensionRouteRoute: typeof AppextensionExtensionRouteRoute
  AppextensionExtensionLocalRouteRoute: typeof AppextensionExtensionLocalRouteRoute
}

const AppextensionRouteRouteChildren: AppextensionRouteRouteChildren = {
  AppextensionExtensionRouteRoute: AppextensionExtensionRouteRoute,
  AppextensionExtensionLocalRouteRoute: AppextensionExtensionLocalRouteRoute,
}

const AppextensionRouteRouteWithChildren =
  AppextensionRouteRoute._addFileChildren(AppextensionRouteRouteChildren)

interface AppmainTrainingRouteChildren {
  AppmainTrainingAnnouncementRoute: typeof AppmainTrainingAnnouncementRoute
  AppmainTrainingClientOnboardingRoute: typeof AppmainTrainingClientOnboardingRoute
  AppmainTrainingDemoRoute: typeof AppmainTrainingDemoRoute
  AppmainTrainingOnboardingRoute: typeof AppmainTrainingOnboardingRoute
  AppmainTrainingIndexRoute: typeof AppmainTrainingIndexRoute
}

const AppmainTrainingRouteChildren: AppmainTrainingRouteChildren = {
  AppmainTrainingAnnouncementRoute: AppmainTrainingAnnouncementRoute,
  AppmainTrainingClientOnboardingRoute: AppmainTrainingClientOnboardingRoute,
  AppmainTrainingDemoRoute: AppmainTrainingDemoRoute,
  AppmainTrainingOnboardingRoute: AppmainTrainingOnboardingRoute,
  AppmainTrainingIndexRoute: AppmainTrainingIndexRoute,
}

const AppmainTrainingRouteWithChildren = AppmainTrainingRoute._addFileChildren(
  AppmainTrainingRouteChildren,
)

interface AppmainRouteRouteChildren {
  AppmainActivityRoute: typeof AppmainActivityRoute
  AppmainActivityBoardRoute: typeof AppmainActivityBoardRoute
  AppmainAuthorizationsRoute: typeof AppmainAuthorizationsRoute
  AppmainCalloutsRoute: typeof AppmainCalloutsRoute
  AppmainCaregiversRoute: typeof AppmainCaregiversRoute
  AppmainClientsRoute: typeof AppmainClientsRoute
  AppmainCoverageRoute: typeof AppmainCoverageRoute
  AppmainDryRunReportRoute: typeof AppmainDryRunReportRoute
  AppmainFinancialsRoute: typeof AppmainFinancialsRoute
  AppmainHomeRoute: typeof AppmainHomeRoute
  AppmainLeaderboardRoute: typeof AppmainLeaderboardRoute
  AppmainLearnPhoebeRoute: typeof AppmainLearnPhoebeRoute
  AppmainMetricsRoute: typeof AppmainMetricsRoute
  AppmainPhoneRoute: typeof AppmainPhoneRoute
  AppmainPlaybooksRoute: typeof AppmainPlaybooksRoute
  AppmainReferralsRoute: typeof AppmainReferralsRoute
  AppmainTeachPhoebeRoute: typeof AppmainTeachPhoebeRoute
  AppmainTrainingRoute: typeof AppmainTrainingRouteWithChildren
  AppmainVoiceCallsRoute: typeof AppmainVoiceCallsRoute
  AppmainIndexRoute: typeof AppmainIndexRoute
  AppmainAutomationsAutomationIdRoute: typeof AppmainAutomationsAutomationIdRoute
  AppmainOutreachesCalloutIdRoute: typeof AppmainOutreachesCalloutIdRoute
  AppmainRoutinesRoutineIdRoute: typeof AppmainRoutinesRoutineIdRoute
  AppmainShiftsShiftIdRoute: typeof AppmainShiftsShiftIdRoute
  AppmainSurveysSurveyIdRoute: typeof AppmainSurveysSurveyIdRoute
  AppmainSurveysCreateRoute: typeof AppmainSurveysCreateRoute
  AppmainAutomationsIndexRoute: typeof AppmainAutomationsIndexRoute
  AppmainCalendarIndexRoute: typeof AppmainCalendarIndexRoute
  AppmainConversationsIndexRoute: typeof AppmainConversationsIndexRoute
  AppmainOutreachesIndexRoute: typeof AppmainOutreachesIndexRoute
  AppmainRoutinesIndexRoute: typeof AppmainRoutinesIndexRoute
  AppmainScheduledIndexRoute: typeof AppmainScheduledIndexRoute
  AppmainShiftsIndexRoute: typeof AppmainShiftsIndexRoute
  AppmainSurveysIndexRoute: typeof AppmainSurveysIndexRoute
  AppmainOutreachesMessageMessageIdRoute: typeof AppmainOutreachesMessageMessageIdRoute
  AppmainOutreachesMessageCreateRoute: typeof AppmainOutreachesMessageCreateRoute
  AppmainOutreachesSurveySurveyIdRoute: typeof AppmainOutreachesSurveySurveyIdRoute
  AppmainOutreachesSurveyCreateRoute: typeof AppmainOutreachesSurveyCreateRoute
  AppmainExtensionReviewCalendarPhpUnassignedRoute: typeof AppmainExtensionReviewCalendarPhpUnassignedRoute
}

const AppmainRouteRouteChildren: AppmainRouteRouteChildren = {
  AppmainActivityRoute: AppmainActivityRoute,
  AppmainActivityBoardRoute: AppmainActivityBoardRoute,
  AppmainAuthorizationsRoute: AppmainAuthorizationsRoute,
  AppmainCalloutsRoute: AppmainCalloutsRoute,
  AppmainCaregiversRoute: AppmainCaregiversRoute,
  AppmainClientsRoute: AppmainClientsRoute,
  AppmainCoverageRoute: AppmainCoverageRoute,
  AppmainDryRunReportRoute: AppmainDryRunReportRoute,
  AppmainFinancialsRoute: AppmainFinancialsRoute,
  AppmainHomeRoute: AppmainHomeRoute,
  AppmainLeaderboardRoute: AppmainLeaderboardRoute,
  AppmainLearnPhoebeRoute: AppmainLearnPhoebeRoute,
  AppmainMetricsRoute: AppmainMetricsRoute,
  AppmainPhoneRoute: AppmainPhoneRoute,
  AppmainPlaybooksRoute: AppmainPlaybooksRoute,
  AppmainReferralsRoute: AppmainReferralsRoute,
  AppmainTeachPhoebeRoute: AppmainTeachPhoebeRoute,
  AppmainTrainingRoute: AppmainTrainingRouteWithChildren,
  AppmainVoiceCallsRoute: AppmainVoiceCallsRoute,
  AppmainIndexRoute: AppmainIndexRoute,
  AppmainAutomationsAutomationIdRoute: AppmainAutomationsAutomationIdRoute,
  AppmainOutreachesCalloutIdRoute: AppmainOutreachesCalloutIdRoute,
  AppmainRoutinesRoutineIdRoute: AppmainRoutinesRoutineIdRoute,
  AppmainShiftsShiftIdRoute: AppmainShiftsShiftIdRoute,
  AppmainSurveysSurveyIdRoute: AppmainSurveysSurveyIdRoute,
  AppmainSurveysCreateRoute: AppmainSurveysCreateRoute,
  AppmainAutomationsIndexRoute: AppmainAutomationsIndexRoute,
  AppmainCalendarIndexRoute: AppmainCalendarIndexRoute,
  AppmainConversationsIndexRoute: AppmainConversationsIndexRoute,
  AppmainOutreachesIndexRoute: AppmainOutreachesIndexRoute,
  AppmainRoutinesIndexRoute: AppmainRoutinesIndexRoute,
  AppmainScheduledIndexRoute: AppmainScheduledIndexRoute,
  AppmainShiftsIndexRoute: AppmainShiftsIndexRoute,
  AppmainSurveysIndexRoute: AppmainSurveysIndexRoute,
  AppmainOutreachesMessageMessageIdRoute:
    AppmainOutreachesMessageMessageIdRoute,
  AppmainOutreachesMessageCreateRoute: AppmainOutreachesMessageCreateRoute,
  AppmainOutreachesSurveySurveyIdRoute: AppmainOutreachesSurveySurveyIdRoute,
  AppmainOutreachesSurveyCreateRoute: AppmainOutreachesSurveyCreateRoute,
  AppmainExtensionReviewCalendarPhpUnassignedRoute:
    AppmainExtensionReviewCalendarPhpUnassignedRoute,
}

const AppmainRouteRouteWithChildren = AppmainRouteRoute._addFileChildren(
  AppmainRouteRouteChildren,
)

interface AppAdminExtensionLabRouteRouteChildren {
  AppAdminExtensionLabIndexRoute: typeof AppAdminExtensionLabIndexRoute
  AppAdminExtensionLabEhrProviderEntityExternalIdRoute: typeof AppAdminExtensionLabEhrProviderEntityExternalIdRoute
}

const AppAdminExtensionLabRouteRouteChildren: AppAdminExtensionLabRouteRouteChildren =
  {
    AppAdminExtensionLabIndexRoute: AppAdminExtensionLabIndexRoute,
    AppAdminExtensionLabEhrProviderEntityExternalIdRoute:
      AppAdminExtensionLabEhrProviderEntityExternalIdRoute,
  }

const AppAdminExtensionLabRouteRouteWithChildren =
  AppAdminExtensionLabRouteRoute._addFileChildren(
    AppAdminExtensionLabRouteRouteChildren,
  )

interface AppAdminV3AgentJudgeRouteRouteChildren {
  AppAdminV3AgentJudgeIndexRoute: typeof AppAdminV3AgentJudgeIndexRoute
  AppAdminV3AgentJudgeTraceRunIdRoute: typeof AppAdminV3AgentJudgeTraceRunIdRoute
}

const AppAdminV3AgentJudgeRouteRouteChildren: AppAdminV3AgentJudgeRouteRouteChildren =
  {
    AppAdminV3AgentJudgeIndexRoute: AppAdminV3AgentJudgeIndexRoute,
    AppAdminV3AgentJudgeTraceRunIdRoute: AppAdminV3AgentJudgeTraceRunIdRoute,
  }

const AppAdminV3AgentJudgeRouteRouteWithChildren =
  AppAdminV3AgentJudgeRouteRoute._addFileChildren(
    AppAdminV3AgentJudgeRouteRouteChildren,
  )

interface AppAdminV3AgentRouteRouteChildren {
  AppAdminV3AgentJudgeRouteRoute: typeof AppAdminV3AgentJudgeRouteRouteWithChildren
  AppAdminV3AgentRunIdRoute: typeof AppAdminV3AgentRunIdRoute
  AppAdminV3AgentAutomationsRoute: typeof AppAdminV3AgentAutomationsRoute
  AppAdminV3AgentNewRoute: typeof AppAdminV3AgentNewRoute
  AppAdminV3AgentSkillsRoute: typeof AppAdminV3AgentSkillsRoute
  AppAdminV3AgentIndexRoute: typeof AppAdminV3AgentIndexRoute
  AppAdminV3AgentScratchpadNoteIdRoute: typeof AppAdminV3AgentScratchpadNoteIdRoute
  AppAdminV3AgentScratchpadIndexRoute: typeof AppAdminV3AgentScratchpadIndexRoute
}

const AppAdminV3AgentRouteRouteChildren: AppAdminV3AgentRouteRouteChildren = {
  AppAdminV3AgentJudgeRouteRoute: AppAdminV3AgentJudgeRouteRouteWithChildren,
  AppAdminV3AgentRunIdRoute: AppAdminV3AgentRunIdRoute,
  AppAdminV3AgentAutomationsRoute: AppAdminV3AgentAutomationsRoute,
  AppAdminV3AgentNewRoute: AppAdminV3AgentNewRoute,
  AppAdminV3AgentSkillsRoute: AppAdminV3AgentSkillsRoute,
  AppAdminV3AgentIndexRoute: AppAdminV3AgentIndexRoute,
  AppAdminV3AgentScratchpadNoteIdRoute: AppAdminV3AgentScratchpadNoteIdRoute,
  AppAdminV3AgentScratchpadIndexRoute: AppAdminV3AgentScratchpadIndexRoute,
}

const AppAdminV3AgentRouteRouteWithChildren =
  AppAdminV3AgentRouteRoute._addFileChildren(AppAdminV3AgentRouteRouteChildren)

interface AppAdminAgentChatRouteRouteChildren {
  AppAdminAgentChatRunIdRoute: typeof AppAdminAgentChatRunIdRoute
  AppAdminAgentChatNewRoute: typeof AppAdminAgentChatNewRoute
  AppAdminAgentChatIndexRoute: typeof AppAdminAgentChatIndexRoute
}

const AppAdminAgentChatRouteRouteChildren: AppAdminAgentChatRouteRouteChildren =
  {
    AppAdminAgentChatRunIdRoute: AppAdminAgentChatRunIdRoute,
    AppAdminAgentChatNewRoute: AppAdminAgentChatNewRoute,
    AppAdminAgentChatIndexRoute: AppAdminAgentChatIndexRoute,
  }

const AppAdminAgentChatRouteRouteWithChildren =
  AppAdminAgentChatRouteRoute._addFileChildren(
    AppAdminAgentChatRouteRouteChildren,
  )

interface AppAdminAgentJudgeRouteRouteChildren {
  AppAdminAgentJudgeIndexRoute: typeof AppAdminAgentJudgeIndexRoute
  AppAdminAgentJudgeTraceRunIdRoute: typeof AppAdminAgentJudgeTraceRunIdRoute
}

const AppAdminAgentJudgeRouteRouteChildren: AppAdminAgentJudgeRouteRouteChildren =
  {
    AppAdminAgentJudgeIndexRoute: AppAdminAgentJudgeIndexRoute,
    AppAdminAgentJudgeTraceRunIdRoute: AppAdminAgentJudgeTraceRunIdRoute,
  }

const AppAdminAgentJudgeRouteRouteWithChildren =
  AppAdminAgentJudgeRouteRoute._addFileChildren(
    AppAdminAgentJudgeRouteRouteChildren,
  )

interface AppAdminAutomationsOrganizationIdAutomationIdRouteChildren {
  AppAdminAutomationsOrganizationIdAutomationIdIndexRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdIndexRoute
  AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}

const AppAdminAutomationsOrganizationIdAutomationIdRouteChildren: AppAdminAutomationsOrganizationIdAutomationIdRouteChildren =
  {
    AppAdminAutomationsOrganizationIdAutomationIdIndexRoute:
      AppAdminAutomationsOrganizationIdAutomationIdIndexRoute,
    AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute:
      AppAdminAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute,
  }

const AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren =
  AppAdminAutomationsOrganizationIdAutomationIdRoute._addFileChildren(
    AppAdminAutomationsOrganizationIdAutomationIdRouteChildren,
  )

interface AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren {
  AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute
  AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute
}

const AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren: AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren =
  {
    AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute:
      AppAdminAgentAutomationsOrganizationIdAutomationIdIndexRoute,
    AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute:
      AppAdminAgentAutomationsOrganizationIdAutomationIdRunsAutomationRunIdRoute,
  }

const AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren =
  AppAdminAgentAutomationsOrganizationIdAutomationIdRoute._addFileChildren(
    AppAdminAgentAutomationsOrganizationIdAutomationIdRouteChildren,
  )

interface AppAdminRouteRouteChildren {
  AppAdminExtensionLabRouteRoute: typeof AppAdminExtensionLabRouteRouteWithChildren
  AppAdminV3AgentRouteRoute: typeof AppAdminV3AgentRouteRouteWithChildren
  AppAdminAgentToolsRoute: typeof AppAdminAgentToolsRoute
  AppAdminAmdLiveRoute: typeof AppAdminAmdLiveRoute
  AppAdminCarePlanPreviewerRoute: typeof AppAdminCarePlanPreviewerRoute
  AppAdminDashboardUsageRoute: typeof AppAdminDashboardUsageRoute
  AppAdminDataQualityRoute: typeof AppAdminDataQualityRoute
  AppAdminDataSyncRoute: typeof AppAdminDataSyncRoute
  AppAdminDemoOrgRoute: typeof AppAdminDemoOrgRoute
  AppAdminDesignKitRoute: typeof AppAdminDesignKitRoute
  AppAdminDocumentIngestionRoute: typeof AppAdminDocumentIngestionRoute
  AppAdminFlagsRoute: typeof AppAdminFlagsRoute
  AppAdminImessageRoute: typeof AppAdminImessageRoute
  AppAdminLlmSpendRoute: typeof AppAdminLlmSpendRoute
  AppAdminMessageQueueRoute: typeof AppAdminMessageQueueRoute
  AppAdminNotificationsLabRoute: typeof AppAdminNotificationsLabRoute
  AppAdminOrgSnapshotsRoute: typeof AppAdminOrgSnapshotsRoute
  AppAdminOrganizationDefaultSettingsRoute: typeof AppAdminOrganizationDefaultSettingsRoute
  AppAdminOutreachObservabilityRoute: typeof AppAdminOutreachObservabilityRoute
  AppAdminOutreachesRoute: typeof AppAdminOutreachesRoute
  AppAdminPromptRolloutRoute: typeof AppAdminPromptRolloutRoute
  AppAdminQualityScoreboardRoute: typeof AppAdminQualityScoreboardRoute
  AppAdminReportGeneratorRoute: typeof AppAdminReportGeneratorRoute
  AppAdminSearchRoute: typeof AppAdminSearchRoute
  AppAdminShiftAssignmentHealthRoute: typeof AppAdminShiftAssignmentHealthRoute
  AppAdminSimulatorWorldRoute: typeof AppAdminSimulatorWorldRoute
  AppAdminSyncSettingsRoute: typeof AppAdminSyncSettingsRoute
  AppAdminTagMatchingRoute: typeof AppAdminTagMatchingRoute
  AppAdminTamMapRoute: typeof AppAdminTamMapRoute
  AppAdminUiComponentsRoute: typeof AppAdminUiComponentsRoute
  AppAdminV3EventComponentsRoute: typeof AppAdminV3EventComponentsRoute
  AppAdminVoiceRoute: typeof AppAdminVoiceRoute
  AppAdminVoiceLatencyRoute: typeof AppAdminVoiceLatencyRoute
  AppAdminWbrRoute: typeof AppAdminWbrRoute
  AppAdminIndexRoute: typeof AppAdminIndexRoute
  AppAdminAgentChatRouteRoute: typeof AppAdminAgentChatRouteRouteWithChildren
  AppAdminAgentJudgeRouteRoute: typeof AppAdminAgentJudgeRouteRouteWithChildren
  AppAdminAccountsAccountIdRoute: typeof AppAdminAccountsAccountIdRoute
  AppAdminAgentNotesNoteIdRoute: typeof AppAdminAgentNotesNoteIdRoute
  AppAdminAgentTracesConversationIdRoute: typeof AppAdminAgentTracesConversationIdRoute
  AppAdminAgentTracesCaregiverRoute: typeof AppAdminAgentTracesCaregiverRoute
  AppAdminAgentTracesClientRoute: typeof AppAdminAgentTracesClientRoute
  AppAdminAgentTracesContinualRoute: typeof AppAdminAgentTracesContinualRoute
  AppAdminAgentTracesEphemeralRoute: typeof AppAdminAgentTracesEphemeralRoute
  AppAdminAgentTracesPromptsRoute: typeof AppAdminAgentTracesPromptsRoute
  AppAdminAgentConnectionsRoute: typeof AppAdminAgentConnectionsRoute
  AppAdminAgentSkillsRoute: typeof AppAdminAgentSkillsRoute
  AppAdminAgentV3AutomationsRoute: typeof AppAdminAgentV3AutomationsRoute
  AppAdminAgentVirtualizationRoute: typeof AppAdminAgentVirtualizationRoute
  AppAdminCallsCallIdRoute: typeof AppAdminCallsCallIdRoute
  AppAdminCareCoordinatorsCareCoordinatorIdRoute: typeof AppAdminCareCoordinatorsCareCoordinatorIdRoute
  AppAdminCaregiversCaregiverIdRoute: typeof AppAdminCaregiversCaregiverIdRoute
  AppAdminClientsClientIdRoute: typeof AppAdminClientsClientIdRoute
  AppAdminOrganizationsOrganizationIdRoute: typeof AppAdminOrganizationsOrganizationIdRoute
  AppAdminRevenueAccountIdRoute: typeof AppAdminRevenueAccountIdRoute
  AppAdminRevenueAccountsRoute: typeof AppAdminRevenueAccountsRoute
  AppAdminSalesAgreementsRoute: typeof AppAdminSalesAgreementsRoute
  AppAdminSandboxOrganizationIdRoute: typeof AppAdminSandboxOrganizationIdRoute
  AppAdminShiftsShiftIdRoute: typeof AppAdminShiftsShiftIdRoute
  AppAdminUsersUserIdRoute: typeof AppAdminUsersUserIdRoute
  AppAdminVoiceConfigOrganizationIdRoute: typeof AppAdminVoiceConfigOrganizationIdRoute
  AppAdminVoiceEvalsCasesRoute: typeof AppAdminVoiceEvalsCasesRoute
  AppAdminVoiceEvalsCatalogRoute: typeof AppAdminVoiceEvalsCatalogRoute
  AppAdminVoiceEvalsCompareRoute: typeof AppAdminVoiceEvalsCompareRoute
  AppAdminVoiceEvalsCompareCaseRoute: typeof AppAdminVoiceEvalsCompareCaseRoute
  AppAdminVoicePlaygroundCallIdRoute: typeof AppAdminVoicePlaygroundCallIdRoute
  AppAdminVoiceQaCallIdRoute: typeof AppAdminVoiceQaCallIdRoute
  AppAdminVoiceQaShadowComparisonRoute: typeof AppAdminVoiceQaShadowComparisonRoute
  AppAdminVoipOrganizationIdRoute: typeof AppAdminVoipOrganizationIdRoute
  AppAdminAccessTokensIndexRoute: typeof AppAdminAccessTokensIndexRoute
  AppAdminAccountsIndexRoute: typeof AppAdminAccountsIndexRoute
  AppAdminAgentNotesIndexRoute: typeof AppAdminAgentNotesIndexRoute
  AppAdminAgentTracesIndexRoute: typeof AppAdminAgentTracesIndexRoute
  AppAdminAutoCalloutBoardIndexRoute: typeof AppAdminAutoCalloutBoardIndexRoute
  AppAdminAutomationsIndexRoute: typeof AppAdminAutomationsIndexRoute
  AppAdminCallsIndexRoute: typeof AppAdminCallsIndexRoute
  AppAdminCareCoordinatorsIndexRoute: typeof AppAdminCareCoordinatorsIndexRoute
  AppAdminCaregiversIndexRoute: typeof AppAdminCaregiversIndexRoute
  AppAdminClientsIndexRoute: typeof AppAdminClientsIndexRoute
  AppAdminFranchisesIndexRoute: typeof AppAdminFranchisesIndexRoute
  AppAdminOrgDistributionsIndexRoute: typeof AppAdminOrgDistributionsIndexRoute
  AppAdminOrganizationAttributesIndexRoute: typeof AppAdminOrganizationAttributesIndexRoute
  AppAdminOrganizationsIndexRoute: typeof AppAdminOrganizationsIndexRoute
  AppAdminOutboxIndexRoute: typeof AppAdminOutboxIndexRoute
  AppAdminRecommendationExplorerIndexRoute: typeof AppAdminRecommendationExplorerIndexRoute
  AppAdminRevenueIndexRoute: typeof AppAdminRevenueIndexRoute
  AppAdminSandboxIndexRoute: typeof AppAdminSandboxIndexRoute
  AppAdminShiftsIndexRoute: typeof AppAdminShiftsIndexRoute
  AppAdminUsersIndexRoute: typeof AppAdminUsersIndexRoute
  AppAdminVoiceConfigIndexRoute: typeof AppAdminVoiceConfigIndexRoute
  AppAdminVoiceEvalsIndexRoute: typeof AppAdminVoiceEvalsIndexRoute
  AppAdminVoicePlaygroundIndexRoute: typeof AppAdminVoicePlaygroundIndexRoute
  AppAdminVoiceQaIndexRoute: typeof AppAdminVoiceQaIndexRoute
  AppAdminVoipIndexRoute: typeof AppAdminVoipIndexRoute
  AppAdminAgentTracesRunRunIdRoute: typeof AppAdminAgentTracesRunRunIdRoute
  AppAdminAgentActionsAuditIdRoute: typeof AppAdminAgentActionsAuditIdRoute
  AppAdminAgentAutomationsListRoute: typeof AppAdminAgentAutomationsListRoute
  AppAdminAgentAutomationsRunsRoute: typeof AppAdminAgentAutomationsRunsRoute
  AppAdminAgentPagesSlugRoute: typeof AppAdminAgentPagesSlugRoute
  AppAdminAgentScratchpadNoteIdRoute: typeof AppAdminAgentScratchpadNoteIdRoute
  AppAdminAutomationsOrganizationIdAutomationIdRoute: typeof AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren
  AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute: typeof AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute
  AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route: typeof AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route
  AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route: typeof AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route
  AppAdminAgentActionsIndexRoute: typeof AppAdminAgentActionsIndexRoute
  AppAdminAgentAutomationsIndexRoute: typeof AppAdminAgentAutomationsIndexRoute
  AppAdminAgentPagesIndexRoute: typeof AppAdminAgentPagesIndexRoute
  AppAdminAgentScratchpadIndexRoute: typeof AppAdminAgentScratchpadIndexRoute
  AppAdminAgentAutomationsOrganizationIdAutomationIdRoute: typeof AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren
  AppAdminAgentAutomationsGroupsAutomationGroupIdRoute: typeof AppAdminAgentAutomationsGroupsAutomationGroupIdRoute
  AppAdminVoiceEvalsRunsRunIdIndexRoute: typeof AppAdminVoiceEvalsRunsRunIdIndexRoute
  AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute: typeof AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute
}

const AppAdminRouteRouteChildren: AppAdminRouteRouteChildren = {
  AppAdminExtensionLabRouteRoute: AppAdminExtensionLabRouteRouteWithChildren,
  AppAdminV3AgentRouteRoute: AppAdminV3AgentRouteRouteWithChildren,
  AppAdminAgentToolsRoute: AppAdminAgentToolsRoute,
  AppAdminAmdLiveRoute: AppAdminAmdLiveRoute,
  AppAdminCarePlanPreviewerRoute: AppAdminCarePlanPreviewerRoute,
  AppAdminDashboardUsageRoute: AppAdminDashboardUsageRoute,
  AppAdminDataQualityRoute: AppAdminDataQualityRoute,
  AppAdminDataSyncRoute: AppAdminDataSyncRoute,
  AppAdminDemoOrgRoute: AppAdminDemoOrgRoute,
  AppAdminDesignKitRoute: AppAdminDesignKitRoute,
  AppAdminDocumentIngestionRoute: AppAdminDocumentIngestionRoute,
  AppAdminFlagsRoute: AppAdminFlagsRoute,
  AppAdminImessageRoute: AppAdminImessageRoute,
  AppAdminLlmSpendRoute: AppAdminLlmSpendRoute,
  AppAdminMessageQueueRoute: AppAdminMessageQueueRoute,
  AppAdminNotificationsLabRoute: AppAdminNotificationsLabRoute,
  AppAdminOrgSnapshotsRoute: AppAdminOrgSnapshotsRoute,
  AppAdminOrganizationDefaultSettingsRoute:
    AppAdminOrganizationDefaultSettingsRoute,
  AppAdminOutreachObservabilityRoute: AppAdminOutreachObservabilityRoute,
  AppAdminOutreachesRoute: AppAdminOutreachesRoute,
  AppAdminPromptRolloutRoute: AppAdminPromptRolloutRoute,
  AppAdminQualityScoreboardRoute: AppAdminQualityScoreboardRoute,
  AppAdminReportGeneratorRoute: AppAdminReportGeneratorRoute,
  AppAdminSearchRoute: AppAdminSearchRoute,
  AppAdminShiftAssignmentHealthRoute: AppAdminShiftAssignmentHealthRoute,
  AppAdminSimulatorWorldRoute: AppAdminSimulatorWorldRoute,
  AppAdminSyncSettingsRoute: AppAdminSyncSettingsRoute,
  AppAdminTagMatchingRoute: AppAdminTagMatchingRoute,
  AppAdminTamMapRoute: AppAdminTamMapRoute,
  AppAdminUiComponentsRoute: AppAdminUiComponentsRoute,
  AppAdminV3EventComponentsRoute: AppAdminV3EventComponentsRoute,
  AppAdminVoiceRoute: AppAdminVoiceRoute,
  AppAdminVoiceLatencyRoute: AppAdminVoiceLatencyRoute,
  AppAdminWbrRoute: AppAdminWbrRoute,
  AppAdminIndexRoute: AppAdminIndexRoute,
  AppAdminAgentChatRouteRoute: AppAdminAgentChatRouteRouteWithChildren,
  AppAdminAgentJudgeRouteRoute: AppAdminAgentJudgeRouteRouteWithChildren,
  AppAdminAccountsAccountIdRoute: AppAdminAccountsAccountIdRoute,
  AppAdminAgentNotesNoteIdRoute: AppAdminAgentNotesNoteIdRoute,
  AppAdminAgentTracesConversationIdRoute:
    AppAdminAgentTracesConversationIdRoute,
  AppAdminAgentTracesCaregiverRoute: AppAdminAgentTracesCaregiverRoute,
  AppAdminAgentTracesClientRoute: AppAdminAgentTracesClientRoute,
  AppAdminAgentTracesContinualRoute: AppAdminAgentTracesContinualRoute,
  AppAdminAgentTracesEphemeralRoute: AppAdminAgentTracesEphemeralRoute,
  AppAdminAgentTracesPromptsRoute: AppAdminAgentTracesPromptsRoute,
  AppAdminAgentConnectionsRoute: AppAdminAgentConnectionsRoute,
  AppAdminAgentSkillsRoute: AppAdminAgentSkillsRoute,
  AppAdminAgentV3AutomationsRoute: AppAdminAgentV3AutomationsRoute,
  AppAdminAgentVirtualizationRoute: AppAdminAgentVirtualizationRoute,
  AppAdminCallsCallIdRoute: AppAdminCallsCallIdRoute,
  AppAdminCareCoordinatorsCareCoordinatorIdRoute:
    AppAdminCareCoordinatorsCareCoordinatorIdRoute,
  AppAdminCaregiversCaregiverIdRoute: AppAdminCaregiversCaregiverIdRoute,
  AppAdminClientsClientIdRoute: AppAdminClientsClientIdRoute,
  AppAdminOrganizationsOrganizationIdRoute:
    AppAdminOrganizationsOrganizationIdRoute,
  AppAdminRevenueAccountIdRoute: AppAdminRevenueAccountIdRoute,
  AppAdminRevenueAccountsRoute: AppAdminRevenueAccountsRoute,
  AppAdminSalesAgreementsRoute: AppAdminSalesAgreementsRoute,
  AppAdminSandboxOrganizationIdRoute: AppAdminSandboxOrganizationIdRoute,
  AppAdminShiftsShiftIdRoute: AppAdminShiftsShiftIdRoute,
  AppAdminUsersUserIdRoute: AppAdminUsersUserIdRoute,
  AppAdminVoiceConfigOrganizationIdRoute:
    AppAdminVoiceConfigOrganizationIdRoute,
  AppAdminVoiceEvalsCasesRoute: AppAdminVoiceEvalsCasesRoute,
  AppAdminVoiceEvalsCatalogRoute: AppAdminVoiceEvalsCatalogRoute,
  AppAdminVoiceEvalsCompareRoute: AppAdminVoiceEvalsCompareRoute,
  AppAdminVoiceEvalsCompareCaseRoute: AppAdminVoiceEvalsCompareCaseRoute,
  AppAdminVoicePlaygroundCallIdRoute: AppAdminVoicePlaygroundCallIdRoute,
  AppAdminVoiceQaCallIdRoute: AppAdminVoiceQaCallIdRoute,
  AppAdminVoiceQaShadowComparisonRoute: AppAdminVoiceQaShadowComparisonRoute,
  AppAdminVoipOrganizationIdRoute: AppAdminVoipOrganizationIdRoute,
  AppAdminAccessTokensIndexRoute: AppAdminAccessTokensIndexRoute,
  AppAdminAccountsIndexRoute: AppAdminAccountsIndexRoute,
  AppAdminAgentNotesIndexRoute: AppAdminAgentNotesIndexRoute,
  AppAdminAgentTracesIndexRoute: AppAdminAgentTracesIndexRoute,
  AppAdminAutoCalloutBoardIndexRoute: AppAdminAutoCalloutBoardIndexRoute,
  AppAdminAutomationsIndexRoute: AppAdminAutomationsIndexRoute,
  AppAdminCallsIndexRoute: AppAdminCallsIndexRoute,
  AppAdminCareCoordinatorsIndexRoute: AppAdminCareCoordinatorsIndexRoute,
  AppAdminCaregiversIndexRoute: AppAdminCaregiversIndexRoute,
  AppAdminClientsIndexRoute: AppAdminClientsIndexRoute,
  AppAdminFranchisesIndexRoute: AppAdminFranchisesIndexRoute,
  AppAdminOrgDistributionsIndexRoute: AppAdminOrgDistributionsIndexRoute,
  AppAdminOrganizationAttributesIndexRoute:
    AppAdminOrganizationAttributesIndexRoute,
  AppAdminOrganizationsIndexRoute: AppAdminOrganizationsIndexRoute,
  AppAdminOutboxIndexRoute: AppAdminOutboxIndexRoute,
  AppAdminRecommendationExplorerIndexRoute:
    AppAdminRecommendationExplorerIndexRoute,
  AppAdminRevenueIndexRoute: AppAdminRevenueIndexRoute,
  AppAdminSandboxIndexRoute: AppAdminSandboxIndexRoute,
  AppAdminShiftsIndexRoute: AppAdminShiftsIndexRoute,
  AppAdminUsersIndexRoute: AppAdminUsersIndexRoute,
  AppAdminVoiceConfigIndexRoute: AppAdminVoiceConfigIndexRoute,
  AppAdminVoiceEvalsIndexRoute: AppAdminVoiceEvalsIndexRoute,
  AppAdminVoicePlaygroundIndexRoute: AppAdminVoicePlaygroundIndexRoute,
  AppAdminVoiceQaIndexRoute: AppAdminVoiceQaIndexRoute,
  AppAdminVoipIndexRoute: AppAdminVoipIndexRoute,
  AppAdminAgentTracesRunRunIdRoute: AppAdminAgentTracesRunRunIdRoute,
  AppAdminAgentActionsAuditIdRoute: AppAdminAgentActionsAuditIdRoute,
  AppAdminAgentAutomationsListRoute: AppAdminAgentAutomationsListRoute,
  AppAdminAgentAutomationsRunsRoute: AppAdminAgentAutomationsRunsRoute,
  AppAdminAgentPagesSlugRoute: AppAdminAgentPagesSlugRoute,
  AppAdminAgentScratchpadNoteIdRoute: AppAdminAgentScratchpadNoteIdRoute,
  AppAdminAutomationsOrganizationIdAutomationIdRoute:
    AppAdminAutomationsOrganizationIdAutomationIdRouteWithChildren,
  AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute:
    AppAdminCaregiverSmsShadowOrganizationIdSourceMessageIdRoute,
  AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route:
    AppAdminEhrContractsChar123VendorChar125Char123EndpointChar125Route,
  AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route:
    AppAdminOrganizationAttributesTabChar123OrganizationIdChar125Route,
  AppAdminAgentActionsIndexRoute: AppAdminAgentActionsIndexRoute,
  AppAdminAgentAutomationsIndexRoute: AppAdminAgentAutomationsIndexRoute,
  AppAdminAgentPagesIndexRoute: AppAdminAgentPagesIndexRoute,
  AppAdminAgentScratchpadIndexRoute: AppAdminAgentScratchpadIndexRoute,
  AppAdminAgentAutomationsOrganizationIdAutomationIdRoute:
    AppAdminAgentAutomationsOrganizationIdAutomationIdRouteWithChildren,
  AppAdminAgentAutomationsGroupsAutomationGroupIdRoute:
    AppAdminAgentAutomationsGroupsAutomationGroupIdRoute,
  AppAdminVoiceEvalsRunsRunIdIndexRoute: AppAdminVoiceEvalsRunsRunIdIndexRoute,
  AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute:
    AppAdminVoiceEvalsRunsRunIdCasesCaseResultIdRoute,
}

const AppAdminRouteRouteWithChildren = AppAdminRouteRoute._addFileChildren(
  AppAdminRouteRouteChildren,
)

interface AppSettingsNotificationsRouteRouteChildren {
  AppSettingsNotificationsChannelRoute: typeof AppSettingsNotificationsChannelRoute
  AppSettingsNotificationsIndexRoute: typeof AppSettingsNotificationsIndexRoute
}

const AppSettingsNotificationsRouteRouteChildren: AppSettingsNotificationsRouteRouteChildren =
  {
    AppSettingsNotificationsChannelRoute: AppSettingsNotificationsChannelRoute,
    AppSettingsNotificationsIndexRoute: AppSettingsNotificationsIndexRoute,
  }

const AppSettingsNotificationsRouteRouteWithChildren =
  AppSettingsNotificationsRouteRoute._addFileChildren(
    AppSettingsNotificationsRouteRouteChildren,
  )

interface AppSettingsTeamMembersMemberUserIdRouteChildren {
  AppSettingsTeamMembersMemberUserIdIndexRoute: typeof AppSettingsTeamMembersMemberUserIdIndexRoute
  AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute: typeof AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute
  AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute: typeof AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute
}

const AppSettingsTeamMembersMemberUserIdRouteChildren: AppSettingsTeamMembersMemberUserIdRouteChildren =
  {
    AppSettingsTeamMembersMemberUserIdIndexRoute:
      AppSettingsTeamMembersMemberUserIdIndexRoute,
    AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute:
      AppSettingsTeamMembersMemberUserIdNotificationsChannelRoute,
    AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute:
      AppSettingsTeamMembersMemberUserIdNotificationsIndexRoute,
  }

const AppSettingsTeamMembersMemberUserIdRouteWithChildren =
  AppSettingsTeamMembersMemberUserIdRoute._addFileChildren(
    AppSettingsTeamMembersMemberUserIdRouteChildren,
  )

interface AppSettingsRouteRouteChildren {
  AppSettingsNotificationsRouteRoute: typeof AppSettingsNotificationsRouteRouteWithChildren
  AppSettingsActivityFeedRoute: typeof AppSettingsActivityFeedRoute
  AppSettingsAgencyContextRoute: typeof AppSettingsAgencyContextRoute
  AppSettingsAgentRulesRoute: typeof AppSettingsAgentRulesRoute
  AppSettingsAutoAssignRoute: typeof AppSettingsAutoAssignRoute
  AppSettingsAutoDraftRoute: typeof AppSettingsAutoDraftRoute
  AppSettingsAutoReplySettingsRoute: typeof AppSettingsAutoReplySettingsRoute
  AppSettingsAutoSendRoute: typeof AppSettingsAutoSendRoute
  AppSettingsAutomationScheduleRoute: typeof AppSettingsAutomationScheduleRoute
  AppSettingsAutomationsRoute: typeof AppSettingsAutomationsRoute
  AppSettingsCallRoutingRoute: typeof AppSettingsCallRoutingRoute
  AppSettingsCallTemplatesRoute: typeof AppSettingsCallTemplatesRoute
  AppSettingsCancellationsRoute: typeof AppSettingsCancellationsRoute
  AppSettingsCareCoordinatorsRoute: typeof AppSettingsCareCoordinatorsRoute
  AppSettingsCaregiverEngagementRoute: typeof AppSettingsCaregiverEngagementRoute
  AppSettingsCaregiverTagsRoute: typeof AppSettingsCaregiverTagsRoute
  AppSettingsChangeHistoryRoute: typeof AppSettingsChangeHistoryRoute
  AppSettingsChromeExtensionRoute: typeof AppSettingsChromeExtensionRoute
  AppSettingsClientCommunicationRoute: typeof AppSettingsClientCommunicationRoute
  AppSettingsClockInOutRoute: typeof AppSettingsClockInOutRoute
  AppSettingsClockInTemplatesRoute: typeof AppSettingsClockInTemplatesRoute
  AppSettingsConfigurationsRoute: typeof AppSettingsConfigurationsRoute
  AppSettingsConfirmationMessagesRoute: typeof AppSettingsConfirmationMessagesRoute
  AppSettingsDailyDigestRoute: typeof AppSettingsDailyDigestRoute
  AppSettingsDataSyncRoute: typeof AppSettingsDataSyncRoute
  AppSettingsEarlyAccessRoute: typeof AppSettingsEarlyAccessRoute
  AppSettingsHelpCenterRoute: typeof AppSettingsHelpCenterRoute
  AppSettingsOffHoursRoute: typeof AppSettingsOffHoursRoute
  AppSettingsOfficesRoute: typeof AppSettingsOfficesRoute
  AppSettingsOpenShiftResponsesRoute: typeof AppSettingsOpenShiftResponsesRoute
  AppSettingsOtherTemplatesRoute: typeof AppSettingsOtherTemplatesRoute
  AppSettingsOutreachAutomationRoute: typeof AppSettingsOutreachAutomationRoute
  AppSettingsOutreachTemplatesRoute: typeof AppSettingsOutreachTemplatesRoute
  AppSettingsPhoebeRoute: typeof AppSettingsPhoebeRoute
  AppSettingsPhoneRoute: typeof AppSettingsPhoneRoute
  AppSettingsPhoneInstructionsRoute: typeof AppSettingsPhoneInstructionsRoute
  AppSettingsPhoneNumbersRoute: typeof AppSettingsPhoneNumbersRoute
  AppSettingsPhoneTryRoute: typeof AppSettingsPhoneTryRoute
  AppSettingsPronunciationsRoute: typeof AppSettingsPronunciationsRoute
  AppSettingsQuietHoursRoute: typeof AppSettingsQuietHoursRoute
  AppSettingsRecommendationsRoute: typeof AppSettingsRecommendationsRoute
  AppSettingsShiftConfirmationSkipAllowListsRoute: typeof AppSettingsShiftConfirmationSkipAllowListsRoute
  AppSettingsShiftConfirmationsRoute: typeof AppSettingsShiftConfirmationsRoute
  AppSettingsSkipAllowListsRoute: typeof AppSettingsSkipAllowListsRoute
  AppSettingsSlackRoute: typeof AppSettingsSlackRoute
  AppSettingsTagMatchingRoute: typeof AppSettingsTagMatchingRoute
  AppSettingsTagsRoute: typeof AppSettingsTagsRoute
  AppSettingsTeamCoverageRoute: typeof AppSettingsTeamCoverageRoute
  AppSettingsTeamMembersRoute: typeof AppSettingsTeamMembersRoute
  AppSettingsTeamsRoute: typeof AppSettingsTeamsRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsTeamMembersMemberUserIdRoute: typeof AppSettingsTeamMembersMemberUserIdRouteWithChildren
  AppSettingsTeamMembersBulkRoute: typeof AppSettingsTeamMembersBulkRoute
  AppSettingsTeamMembersDefaultsRoute: typeof AppSettingsTeamMembersDefaultsRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsNotificationsRouteRoute:
    AppSettingsNotificationsRouteRouteWithChildren,
  AppSettingsActivityFeedRoute: AppSettingsActivityFeedRoute,
  AppSettingsAgencyContextRoute: AppSettingsAgencyContextRoute,
  AppSettingsAgentRulesRoute: AppSettingsAgentRulesRoute,
  AppSettingsAutoAssignRoute: AppSettingsAutoAssignRoute,
  AppSettingsAutoDraftRoute: AppSettingsAutoDraftRoute,
  AppSettingsAutoReplySettingsRoute: AppSettingsAutoReplySettingsRoute,
  AppSettingsAutoSendRoute: AppSettingsAutoSendRoute,
  AppSettingsAutomationScheduleRoute: AppSettingsAutomationScheduleRoute,
  AppSettingsAutomationsRoute: AppSettingsAutomationsRoute,
  AppSettingsCallRoutingRoute: AppSettingsCallRoutingRoute,
  AppSettingsCallTemplatesRoute: AppSettingsCallTemplatesRoute,
  AppSettingsCancellationsRoute: AppSettingsCancellationsRoute,
  AppSettingsCareCoordinatorsRoute: AppSettingsCareCoordinatorsRoute,
  AppSettingsCaregiverEngagementRoute: AppSettingsCaregiverEngagementRoute,
  AppSettingsCaregiverTagsRoute: AppSettingsCaregiverTagsRoute,
  AppSettingsChangeHistoryRoute: AppSettingsChangeHistoryRoute,
  AppSettingsChromeExtensionRoute: AppSettingsChromeExtensionRoute,
  AppSettingsClientCommunicationRoute: AppSettingsClientCommunicationRoute,
  AppSettingsClockInOutRoute: AppSettingsClockInOutRoute,
  AppSettingsClockInTemplatesRoute: AppSettingsClockInTemplatesRoute,
  AppSettingsConfigurationsRoute: AppSettingsConfigurationsRoute,
  AppSettingsConfirmationMessagesRoute: AppSettingsConfirmationMessagesRoute,
  AppSettingsDailyDigestRoute: AppSettingsDailyDigestRoute,
  AppSettingsDataSyncRoute: AppSettingsDataSyncRoute,
  AppSettingsEarlyAccessRoute: AppSettingsEarlyAccessRoute,
  AppSettingsHelpCenterRoute: AppSettingsHelpCenterRoute,
  AppSettingsOffHoursRoute: AppSettingsOffHoursRoute,
  AppSettingsOfficesRoute: AppSettingsOfficesRoute,
  AppSettingsOpenShiftResponsesRoute: AppSettingsOpenShiftResponsesRoute,
  AppSettingsOtherTemplatesRoute: AppSettingsOtherTemplatesRoute,
  AppSettingsOutreachAutomationRoute: AppSettingsOutreachAutomationRoute,
  AppSettingsOutreachTemplatesRoute: AppSettingsOutreachTemplatesRoute,
  AppSettingsPhoebeRoute: AppSettingsPhoebeRoute,
  AppSettingsPhoneRoute: AppSettingsPhoneRoute,
  AppSettingsPhoneInstructionsRoute: AppSettingsPhoneInstructionsRoute,
  AppSettingsPhoneNumbersRoute: AppSettingsPhoneNumbersRoute,
  AppSettingsPhoneTryRoute: AppSettingsPhoneTryRoute,
  AppSettingsPronunciationsRoute: AppSettingsPronunciationsRoute,
  AppSettingsQuietHoursRoute: AppSettingsQuietHoursRoute,
  AppSettingsRecommendationsRoute: AppSettingsRecommendationsRoute,
  AppSettingsShiftConfirmationSkipAllowListsRoute:
    AppSettingsShiftConfirmationSkipAllowListsRoute,
  AppSettingsShiftConfirmationsRoute: AppSettingsShiftConfirmationsRoute,
  AppSettingsSkipAllowListsRoute: AppSettingsSkipAllowListsRoute,
  AppSettingsSlackRoute: AppSettingsSlackRoute,
  AppSettingsTagMatchingRoute: AppSettingsTagMatchingRoute,
  AppSettingsTagsRoute: AppSettingsTagsRoute,
  AppSettingsTeamCoverageRoute: AppSettingsTeamCoverageRoute,
  AppSettingsTeamMembersRoute: AppSettingsTeamMembersRoute,
  AppSettingsTeamsRoute: AppSettingsTeamsRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsTeamMembersMemberUserIdRoute:
    AppSettingsTeamMembersMemberUserIdRouteWithChildren,
  AppSettingsTeamMembersBulkRoute: AppSettingsTeamMembersBulkRoute,
  AppSettingsTeamMembersDefaultsRoute: AppSettingsTeamMembersDefaultsRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppRouteRouteChildren {
  AppagentRouteRoute: typeof AppagentRouteRouteWithChildren
  AppextensionRouteRoute: typeof AppextensionRouteRouteWithChildren
  AppmainRouteRoute: typeof AppmainRouteRouteWithChildren
  AppAdminRouteRoute: typeof AppAdminRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppInternalAgreementsRoute: typeof AppInternalAgreementsRoute
  AppSlackLinkRoute: typeof AppSlackLinkRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppagentRouteRoute: AppagentRouteRouteWithChildren,
  AppextensionRouteRoute: AppextensionRouteRouteWithChildren,
  AppmainRouteRoute: AppmainRouteRouteWithChildren,
  AppAdminRouteRoute: AppAdminRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppInternalAgreementsRoute: AppInternalAgreementsRoute,
  AppSlackLinkRoute: AppSlackLinkRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthAcceptInvitationRoute: typeof AuthAcceptInvitationRoute
  AuthChangePasswordRoute: typeof AuthChangePasswordRoute
  AuthErrorRoute: typeof AuthErrorRoute
  AuthIntroCallBookedRoute: typeof AuthIntroCallBookedRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthSignInRoute: typeof AuthSignInRoute
  AuthSignOutRoute: typeof AuthSignOutRoute
  AuthSignUpRoute: typeof AuthSignUpRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthAcceptInvitationRoute: AuthAcceptInvitationRoute,
  AuthChangePasswordRoute: AuthChangePasswordRoute,
  AuthErrorRoute: AuthErrorRoute,
  AuthIntroCallBookedRoute: AuthIntroCallBookedRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthSignInRoute: AuthSignInRoute,
  AuthSignOutRoute: AuthSignOutRoute,
  AuthSignUpRoute: AuthSignUpRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  PhoebeThinkingTipsMockupRoute: PhoebeThinkingTipsMockupRoute,
  TeachPhoebeFeedbackTagsMockupRoute: TeachPhoebeFeedbackTagsMockupRoute,
  OrganizationIdDemoRoute: OrganizationIdDemoRoute,
  ChromeExtensionPrivacyRoute: ChromeExtensionPrivacyRoute,
  OutreachesPhoebeThinkingTipsMockupRoute:
    OutreachesPhoebeThinkingTipsMockupRoute,
  RCodeRoute: RCodeRoute,
  SimulatorWorldDisplayRoute: SimulatorWorldDisplayRoute,
  SlackAgentV3LinkRoute: SlackAgentV3LinkRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
